
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6d53"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6d53"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k4ank", function(module, exports) {
"use strict";

module.exports = (parcelRequire("eN4lT"));

});
parcelRegister("eN4lT", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $ac49048bedeacd41$export$ffb0004e005737fa, (v) => $ac49048bedeacd41$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $ac49048bedeacd41$export$34b9dba7ce09269b, (v) => $ac49048bedeacd41$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $ac49048bedeacd41$export$25062201e9e25d76, (v) => $ac49048bedeacd41$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ac49048bedeacd41$export$ffb0004e005737fa;
var $ac49048bedeacd41$export$34b9dba7ce09269b;
var $ac49048bedeacd41$export$25062201e9e25d76;
"use strict";

var $8T3gX = parcelRequire("8T3gX");
var $ac49048bedeacd41$var$k = Symbol.for("react.element"), $ac49048bedeacd41$var$l = Symbol.for("react.fragment"), $ac49048bedeacd41$var$m = Object.prototype.hasOwnProperty, $ac49048bedeacd41$var$n = $8T3gX.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ac49048bedeacd41$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ac49048bedeacd41$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$ac49048bedeacd41$var$m.call(a, b) && !$ac49048bedeacd41$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $ac49048bedeacd41$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $ac49048bedeacd41$var$n.current
    };
}
$ac49048bedeacd41$export$ffb0004e005737fa = $ac49048bedeacd41$var$l;
$ac49048bedeacd41$export$34b9dba7ce09269b = $ac49048bedeacd41$var$q;
$ac49048bedeacd41$export$25062201e9e25d76 = $ac49048bedeacd41$var$q;

});
parcelRegister("8T3gX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6VuwR"));

});
parcelRegister("6VuwR", function(module, exports) {

$parcel$export(module.exports, "Children", () => $50afbf63db049363$export$dca3b0875bd9a954, (v) => $50afbf63db049363$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $50afbf63db049363$export$16fa2f45be04daa8, (v) => $50afbf63db049363$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $50afbf63db049363$export$ffb0004e005737fa, (v) => $50afbf63db049363$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $50afbf63db049363$export$e2c29f18771995cb, (v) => $50afbf63db049363$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $50afbf63db049363$export$221d75b3f55bb0bd, (v) => $50afbf63db049363$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $50afbf63db049363$export$5f8d39834fd61797, (v) => $50afbf63db049363$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $50afbf63db049363$export$74bf444e3cd11ea5, (v) => $50afbf63db049363$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $50afbf63db049363$export$ae55be85d98224ed, (v) => $50afbf63db049363$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $50afbf63db049363$export$e530037191fcd5d7, (v) => $50afbf63db049363$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $50afbf63db049363$export$fd42f52fd3ae1109, (v) => $50afbf63db049363$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $50afbf63db049363$export$c8a8987d4410bf2d, (v) => $50afbf63db049363$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $50afbf63db049363$export$d38cd72104c1f0e9, (v) => $50afbf63db049363$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $50afbf63db049363$export$7d1e3a5e95ceca43, (v) => $50afbf63db049363$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $50afbf63db049363$export$257a8862b851cb5b, (v) => $50afbf63db049363$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $50afbf63db049363$export$a8257692ac88316c, (v) => $50afbf63db049363$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $50afbf63db049363$export$488013bae63b21da, (v) => $50afbf63db049363$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $50afbf63db049363$export$7c73462e0d25e514, (v) => $50afbf63db049363$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $50afbf63db049363$export$7568632d0d33d16d, (v) => $50afbf63db049363$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $50afbf63db049363$export$88948ce120ea2619, (v) => $50afbf63db049363$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $50afbf63db049363$export$35808ee640e87ca7, (v) => $50afbf63db049363$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $50afbf63db049363$export$fae74005e78b1a27, (v) => $50afbf63db049363$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $50afbf63db049363$export$dc8fbce3eb94dc1e, (v) => $50afbf63db049363$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $50afbf63db049363$export$6a7bc4e911dc01cf, (v) => $50afbf63db049363$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $50afbf63db049363$export$6d9c69b0de29b591, (v) => $50afbf63db049363$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $50afbf63db049363$export$f680877a34711e37, (v) => $50afbf63db049363$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $50afbf63db049363$export$d5a552a76deda3c2, (v) => $50afbf63db049363$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $50afbf63db049363$export$aaabe4eda9ed9969, (v) => $50afbf63db049363$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $50afbf63db049363$export$e5c5a5f917a5871c, (v) => $50afbf63db049363$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $50afbf63db049363$export$1538c33de8887b59, (v) => $50afbf63db049363$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $50afbf63db049363$export$13e3392192263954, (v) => $50afbf63db049363$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $50afbf63db049363$export$b8f5890fc79d6aca, (v) => $50afbf63db049363$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $50afbf63db049363$export$60241385465d0a34, (v) => $50afbf63db049363$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $50afbf63db049363$export$306c0aa65ff9ec16, (v) => $50afbf63db049363$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $50afbf63db049363$export$7b286972b8d8ccbf, (v) => $50afbf63db049363$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $50afbf63db049363$export$83d89fbfd8236492, (v) => $50afbf63db049363$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50afbf63db049363$export$dca3b0875bd9a954;
var $50afbf63db049363$export$16fa2f45be04daa8;
var $50afbf63db049363$export$ffb0004e005737fa;
var $50afbf63db049363$export$e2c29f18771995cb;
var $50afbf63db049363$export$221d75b3f55bb0bd;
var $50afbf63db049363$export$5f8d39834fd61797;
var $50afbf63db049363$export$74bf444e3cd11ea5;
var $50afbf63db049363$export$ae55be85d98224ed;
var $50afbf63db049363$export$e530037191fcd5d7;
var $50afbf63db049363$export$fd42f52fd3ae1109;
var $50afbf63db049363$export$c8a8987d4410bf2d;
var $50afbf63db049363$export$d38cd72104c1f0e9;
var $50afbf63db049363$export$7d1e3a5e95ceca43;
var $50afbf63db049363$export$257a8862b851cb5b;
var $50afbf63db049363$export$a8257692ac88316c;
var $50afbf63db049363$export$488013bae63b21da;
var $50afbf63db049363$export$7c73462e0d25e514;
var $50afbf63db049363$export$7568632d0d33d16d;
var $50afbf63db049363$export$88948ce120ea2619;
var $50afbf63db049363$export$35808ee640e87ca7;
var $50afbf63db049363$export$fae74005e78b1a27;
var $50afbf63db049363$export$dc8fbce3eb94dc1e;
var $50afbf63db049363$export$6a7bc4e911dc01cf;
var $50afbf63db049363$export$6d9c69b0de29b591;
var $50afbf63db049363$export$f680877a34711e37;
var $50afbf63db049363$export$d5a552a76deda3c2;
var $50afbf63db049363$export$aaabe4eda9ed9969;
var $50afbf63db049363$export$e5c5a5f917a5871c;
var $50afbf63db049363$export$1538c33de8887b59;
var $50afbf63db049363$export$13e3392192263954;
var $50afbf63db049363$export$b8f5890fc79d6aca;
var $50afbf63db049363$export$60241385465d0a34;
var $50afbf63db049363$export$306c0aa65ff9ec16;
var $50afbf63db049363$export$7b286972b8d8ccbf;
var $50afbf63db049363$export$83d89fbfd8236492;
"use strict";
var $50afbf63db049363$var$l = Symbol.for("react.element"), $50afbf63db049363$var$n = Symbol.for("react.portal"), $50afbf63db049363$var$p = Symbol.for("react.fragment"), $50afbf63db049363$var$q = Symbol.for("react.strict_mode"), $50afbf63db049363$var$r = Symbol.for("react.profiler"), $50afbf63db049363$var$t = Symbol.for("react.provider"), $50afbf63db049363$var$u = Symbol.for("react.context"), $50afbf63db049363$var$v = Symbol.for("react.forward_ref"), $50afbf63db049363$var$w = Symbol.for("react.suspense"), $50afbf63db049363$var$x = Symbol.for("react.memo"), $50afbf63db049363$var$y = Symbol.for("react.lazy"), $50afbf63db049363$var$z = Symbol.iterator;
function $50afbf63db049363$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $50afbf63db049363$var$z && a[$50afbf63db049363$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $50afbf63db049363$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $50afbf63db049363$var$C = Object.assign, $50afbf63db049363$var$D = {};
function $50afbf63db049363$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $50afbf63db049363$var$D;
    this.updater = e || $50afbf63db049363$var$B;
}
$50afbf63db049363$var$E.prototype.isReactComponent = {};
$50afbf63db049363$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$50afbf63db049363$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $50afbf63db049363$var$F() {}
$50afbf63db049363$var$F.prototype = $50afbf63db049363$var$E.prototype;
function $50afbf63db049363$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $50afbf63db049363$var$D;
    this.updater = e || $50afbf63db049363$var$B;
}
var $50afbf63db049363$var$H = $50afbf63db049363$var$G.prototype = new $50afbf63db049363$var$F;
$50afbf63db049363$var$H.constructor = $50afbf63db049363$var$G;
$50afbf63db049363$var$C($50afbf63db049363$var$H, $50afbf63db049363$var$E.prototype);
$50afbf63db049363$var$H.isPureReactComponent = !0;
var $50afbf63db049363$var$I = Array.isArray, $50afbf63db049363$var$J = Object.prototype.hasOwnProperty, $50afbf63db049363$var$K = {
    current: null
}, $50afbf63db049363$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $50afbf63db049363$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$50afbf63db049363$var$J.call(b, d) && !$50afbf63db049363$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $50afbf63db049363$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $50afbf63db049363$var$K.current
    };
}
function $50afbf63db049363$var$N(a, b) {
    return {
        $$typeof: $50afbf63db049363$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $50afbf63db049363$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $50afbf63db049363$var$l;
}
function $50afbf63db049363$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $50afbf63db049363$var$P = /\/+/g;
function $50afbf63db049363$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $50afbf63db049363$var$escape("" + a.key) : b.toString(36);
}
function $50afbf63db049363$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $50afbf63db049363$var$l:
                case $50afbf63db049363$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $50afbf63db049363$var$Q(h, 0) : d, $50afbf63db049363$var$I(c) ? (e = "", null != a && (e = a.replace($50afbf63db049363$var$P, "$&/") + "/"), $50afbf63db049363$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($50afbf63db049363$var$O(c) && (c = $50afbf63db049363$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($50afbf63db049363$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($50afbf63db049363$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $50afbf63db049363$var$Q(k, g);
        h += $50afbf63db049363$var$R(k, b, e, f, c);
    }
    else if (f = $50afbf63db049363$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $50afbf63db049363$var$Q(k, g++), h += $50afbf63db049363$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $50afbf63db049363$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $50afbf63db049363$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $50afbf63db049363$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $50afbf63db049363$var$U = {
    current: null
}, $50afbf63db049363$var$V = {
    transition: null
}, $50afbf63db049363$var$W = {
    ReactCurrentDispatcher: $50afbf63db049363$var$U,
    ReactCurrentBatchConfig: $50afbf63db049363$var$V,
    ReactCurrentOwner: $50afbf63db049363$var$K
};
$50afbf63db049363$export$dca3b0875bd9a954 = {
    map: $50afbf63db049363$var$S,
    forEach: function(a, b, e) {
        $50afbf63db049363$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $50afbf63db049363$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $50afbf63db049363$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$50afbf63db049363$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$50afbf63db049363$export$16fa2f45be04daa8 = $50afbf63db049363$var$E;
$50afbf63db049363$export$ffb0004e005737fa = $50afbf63db049363$var$p;
$50afbf63db049363$export$e2c29f18771995cb = $50afbf63db049363$var$r;
$50afbf63db049363$export$221d75b3f55bb0bd = $50afbf63db049363$var$G;
$50afbf63db049363$export$5f8d39834fd61797 = $50afbf63db049363$var$q;
$50afbf63db049363$export$74bf444e3cd11ea5 = $50afbf63db049363$var$w;
$50afbf63db049363$export$ae55be85d98224ed = $50afbf63db049363$var$W;
$50afbf63db049363$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $50afbf63db049363$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $50afbf63db049363$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$50afbf63db049363$var$J.call(b, f) && !$50afbf63db049363$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $50afbf63db049363$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$50afbf63db049363$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $50afbf63db049363$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $50afbf63db049363$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$50afbf63db049363$export$c8a8987d4410bf2d = $50afbf63db049363$var$M;
$50afbf63db049363$export$d38cd72104c1f0e9 = function(a) {
    var b = $50afbf63db049363$var$M.bind(null, a);
    b.type = a;
    return b;
};
$50afbf63db049363$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$50afbf63db049363$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $50afbf63db049363$var$v,
        render: a
    };
};
$50afbf63db049363$export$a8257692ac88316c = $50afbf63db049363$var$O;
$50afbf63db049363$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $50afbf63db049363$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $50afbf63db049363$var$T
    };
};
$50afbf63db049363$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $50afbf63db049363$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$50afbf63db049363$export$7568632d0d33d16d = function(a) {
    var b = $50afbf63db049363$var$V.transition;
    $50afbf63db049363$var$V.transition = {};
    try {
        a();
    } finally{
        $50afbf63db049363$var$V.transition = b;
    }
};
$50afbf63db049363$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$50afbf63db049363$export$35808ee640e87ca7 = function(a, b) {
    return $50afbf63db049363$var$U.current.useCallback(a, b);
};
$50afbf63db049363$export$fae74005e78b1a27 = function(a) {
    return $50afbf63db049363$var$U.current.useContext(a);
};
$50afbf63db049363$export$dc8fbce3eb94dc1e = function() {};
$50afbf63db049363$export$6a7bc4e911dc01cf = function(a) {
    return $50afbf63db049363$var$U.current.useDeferredValue(a);
};
$50afbf63db049363$export$6d9c69b0de29b591 = function(a, b) {
    return $50afbf63db049363$var$U.current.useEffect(a, b);
};
$50afbf63db049363$export$f680877a34711e37 = function() {
    return $50afbf63db049363$var$U.current.useId();
};
$50afbf63db049363$export$d5a552a76deda3c2 = function(a, b, e) {
    return $50afbf63db049363$var$U.current.useImperativeHandle(a, b, e);
};
$50afbf63db049363$export$aaabe4eda9ed9969 = function(a, b) {
    return $50afbf63db049363$var$U.current.useInsertionEffect(a, b);
};
$50afbf63db049363$export$e5c5a5f917a5871c = function(a, b) {
    return $50afbf63db049363$var$U.current.useLayoutEffect(a, b);
};
$50afbf63db049363$export$1538c33de8887b59 = function(a, b) {
    return $50afbf63db049363$var$U.current.useMemo(a, b);
};
$50afbf63db049363$export$13e3392192263954 = function(a, b, e) {
    return $50afbf63db049363$var$U.current.useReducer(a, b, e);
};
$50afbf63db049363$export$b8f5890fc79d6aca = function(a) {
    return $50afbf63db049363$var$U.current.useRef(a);
};
$50afbf63db049363$export$60241385465d0a34 = function(a) {
    return $50afbf63db049363$var$U.current.useState(a);
};
$50afbf63db049363$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $50afbf63db049363$var$U.current.useSyncExternalStore(a, b, e);
};
$50afbf63db049363$export$7b286972b8d8ccbf = function() {
    return $50afbf63db049363$var$U.current.useTransition();
};
$50afbf63db049363$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("WeH8M", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0af0d0faab426b68$export$ae55be85d98224ed, (v) => $0af0d0faab426b68$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0af0d0faab426b68$export$d39a5bbd09211389, (v) => $0af0d0faab426b68$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0af0d0faab426b68$export$882461b6382ed46c, (v) => $0af0d0faab426b68$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0af0d0faab426b68$export$466bfc07425424d5, (v) => $0af0d0faab426b68$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0af0d0faab426b68$export$cd75ccfd720a3cd4, (v) => $0af0d0faab426b68$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0af0d0faab426b68$export$fa8d919ba61d84db, (v) => $0af0d0faab426b68$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0af0d0faab426b68$export$757ceba2d55c277e, (v) => $0af0d0faab426b68$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0af0d0faab426b68$export$b3890eb0ae9dca99, (v) => $0af0d0faab426b68$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0af0d0faab426b68$export$502457920280e6be, (v) => $0af0d0faab426b68$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0af0d0faab426b68$export$c78a37762a8d58e1, (v) => $0af0d0faab426b68$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0af0d0faab426b68$export$dc54d992c10e8a18, (v) => $0af0d0faab426b68$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0af0d0faab426b68$export$83d89fbfd8236492, (v) => $0af0d0faab426b68$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0af0d0faab426b68$export$ae55be85d98224ed;
var $0af0d0faab426b68$export$d39a5bbd09211389;
var $0af0d0faab426b68$export$882461b6382ed46c;
var $0af0d0faab426b68$export$466bfc07425424d5;
var $0af0d0faab426b68$export$cd75ccfd720a3cd4;
var $0af0d0faab426b68$export$fa8d919ba61d84db;
var $0af0d0faab426b68$export$757ceba2d55c277e;
var $0af0d0faab426b68$export$b3890eb0ae9dca99;
var $0af0d0faab426b68$export$502457920280e6be;
var $0af0d0faab426b68$export$c78a37762a8d58e1;
var $0af0d0faab426b68$export$dc54d992c10e8a18;
var $0af0d0faab426b68$export$83d89fbfd8236492;
"use strict";

var $8T3gX = parcelRequire("8T3gX");

var $74qJ9 = parcelRequire("74qJ9");
function $0af0d0faab426b68$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0af0d0faab426b68$var$da = new Set, $0af0d0faab426b68$var$ea = {};
function $0af0d0faab426b68$var$fa(a, b) {
    $0af0d0faab426b68$var$ha(a, b);
    $0af0d0faab426b68$var$ha(a + "Capture", b);
}
function $0af0d0faab426b68$var$ha(a, b) {
    $0af0d0faab426b68$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0af0d0faab426b68$var$da.add(b[a]);
}
var $0af0d0faab426b68$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0af0d0faab426b68$var$ja = Object.prototype.hasOwnProperty, $0af0d0faab426b68$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0af0d0faab426b68$var$la = {}, $0af0d0faab426b68$var$ma = {};
function $0af0d0faab426b68$var$oa(a) {
    if ($0af0d0faab426b68$var$ja.call($0af0d0faab426b68$var$ma, a)) return !0;
    if ($0af0d0faab426b68$var$ja.call($0af0d0faab426b68$var$la, a)) return !1;
    if ($0af0d0faab426b68$var$ka.test(a)) return $0af0d0faab426b68$var$ma[a] = !0;
    $0af0d0faab426b68$var$la[a] = !0;
    return !1;
}
function $0af0d0faab426b68$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0af0d0faab426b68$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0af0d0faab426b68$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0af0d0faab426b68$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0af0d0faab426b68$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0af0d0faab426b68$var$z[b] = new $0af0d0faab426b68$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0af0d0faab426b68$var$ra = /[\-:]([a-z])/g;
function $0af0d0faab426b68$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0af0d0faab426b68$var$ra, $0af0d0faab426b68$var$sa);
    $0af0d0faab426b68$var$z[b] = new $0af0d0faab426b68$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0af0d0faab426b68$var$ra, $0af0d0faab426b68$var$sa);
    $0af0d0faab426b68$var$z[b] = new $0af0d0faab426b68$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0af0d0faab426b68$var$ra, $0af0d0faab426b68$var$sa);
    $0af0d0faab426b68$var$z[b] = new $0af0d0faab426b68$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0af0d0faab426b68$var$z.xlinkHref = new $0af0d0faab426b68$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0af0d0faab426b68$var$ta(a, b, c, d) {
    var e = $0af0d0faab426b68$var$z.hasOwnProperty(b) ? $0af0d0faab426b68$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0af0d0faab426b68$var$qa(b, c, e, d) && (c = null), d || null === e ? $0af0d0faab426b68$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0af0d0faab426b68$var$ua = $8T3gX.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0af0d0faab426b68$var$va = Symbol.for("react.element"), $0af0d0faab426b68$var$wa = Symbol.for("react.portal"), $0af0d0faab426b68$var$ya = Symbol.for("react.fragment"), $0af0d0faab426b68$var$za = Symbol.for("react.strict_mode"), $0af0d0faab426b68$var$Aa = Symbol.for("react.profiler"), $0af0d0faab426b68$var$Ba = Symbol.for("react.provider"), $0af0d0faab426b68$var$Ca = Symbol.for("react.context"), $0af0d0faab426b68$var$Da = Symbol.for("react.forward_ref"), $0af0d0faab426b68$var$Ea = Symbol.for("react.suspense"), $0af0d0faab426b68$var$Fa = Symbol.for("react.suspense_list"), $0af0d0faab426b68$var$Ga = Symbol.for("react.memo"), $0af0d0faab426b68$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0af0d0faab426b68$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0af0d0faab426b68$var$Ja = Symbol.iterator;
function $0af0d0faab426b68$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0af0d0faab426b68$var$Ja && a[$0af0d0faab426b68$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0af0d0faab426b68$var$A = Object.assign, $0af0d0faab426b68$var$La;
function $0af0d0faab426b68$var$Ma(a) {
    if (void 0 === $0af0d0faab426b68$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0af0d0faab426b68$var$La = b && b[1] || "";
    }
    return "\n" + $0af0d0faab426b68$var$La + a;
}
var $0af0d0faab426b68$var$Na = !1;
function $0af0d0faab426b68$var$Oa(a, b) {
    if (!a || $0af0d0faab426b68$var$Na) return "";
    $0af0d0faab426b68$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0af0d0faab426b68$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0af0d0faab426b68$var$Ma(a) : "";
}
function $0af0d0faab426b68$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0af0d0faab426b68$var$Ma(a.type);
        case 16:
            return $0af0d0faab426b68$var$Ma("Lazy");
        case 13:
            return $0af0d0faab426b68$var$Ma("Suspense");
        case 19:
            return $0af0d0faab426b68$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0af0d0faab426b68$var$Oa(a.type, !1), a;
        case 11:
            return a = $0af0d0faab426b68$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0af0d0faab426b68$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0af0d0faab426b68$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0af0d0faab426b68$var$ya:
            return "Fragment";
        case $0af0d0faab426b68$var$wa:
            return "Portal";
        case $0af0d0faab426b68$var$Aa:
            return "Profiler";
        case $0af0d0faab426b68$var$za:
            return "StrictMode";
        case $0af0d0faab426b68$var$Ea:
            return "Suspense";
        case $0af0d0faab426b68$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0af0d0faab426b68$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0af0d0faab426b68$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0af0d0faab426b68$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0af0d0faab426b68$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0af0d0faab426b68$var$Qa(a.type) || "Memo";
        case $0af0d0faab426b68$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0af0d0faab426b68$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0af0d0faab426b68$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0af0d0faab426b68$var$Qa(b);
        case 8:
            return b === $0af0d0faab426b68$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0af0d0faab426b68$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0af0d0faab426b68$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0af0d0faab426b68$var$Ua(a) {
    var b = $0af0d0faab426b68$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0af0d0faab426b68$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0af0d0faab426b68$var$Ua(a));
}
function $0af0d0faab426b68$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0af0d0faab426b68$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0af0d0faab426b68$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0af0d0faab426b68$var$Ya(a, b) {
    var c = b.checked;
    return $0af0d0faab426b68$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0af0d0faab426b68$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0af0d0faab426b68$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0af0d0faab426b68$var$ab(a, b) {
    b = b.checked;
    null != b && $0af0d0faab426b68$var$ta(a, "checked", b, !1);
}
function $0af0d0faab426b68$var$bb(a, b) {
    $0af0d0faab426b68$var$ab(a, b);
    var c = $0af0d0faab426b68$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0af0d0faab426b68$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0af0d0faab426b68$var$cb(a, b.type, $0af0d0faab426b68$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0af0d0faab426b68$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0af0d0faab426b68$var$cb(a, b, c) {
    if ("number" !== b || $0af0d0faab426b68$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0af0d0faab426b68$var$eb = Array.isArray;
function $0af0d0faab426b68$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0af0d0faab426b68$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0af0d0faab426b68$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0af0d0faab426b68$var$p(91));
    return $0af0d0faab426b68$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0af0d0faab426b68$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0af0d0faab426b68$var$p(92));
            if ($0af0d0faab426b68$var$eb(c)) {
                if (1 < c.length) throw Error($0af0d0faab426b68$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0af0d0faab426b68$var$Sa(c)
    };
}
function $0af0d0faab426b68$var$ib(a, b) {
    var c = $0af0d0faab426b68$var$Sa(b.value), d = $0af0d0faab426b68$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0af0d0faab426b68$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0af0d0faab426b68$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0af0d0faab426b68$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0af0d0faab426b68$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0af0d0faab426b68$var$mb, $0af0d0faab426b68$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0af0d0faab426b68$var$mb = $0af0d0faab426b68$var$mb || document.createElement("div");
        $0af0d0faab426b68$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0af0d0faab426b68$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0af0d0faab426b68$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0af0d0faab426b68$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0af0d0faab426b68$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0af0d0faab426b68$var$pb).forEach(function(a) {
    $0af0d0faab426b68$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0af0d0faab426b68$var$pb[b] = $0af0d0faab426b68$var$pb[a];
    });
});
function $0af0d0faab426b68$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0af0d0faab426b68$var$pb.hasOwnProperty(a) && $0af0d0faab426b68$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0af0d0faab426b68$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0af0d0faab426b68$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0af0d0faab426b68$var$tb = $0af0d0faab426b68$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0af0d0faab426b68$var$ub(a, b) {
    if (b) {
        if ($0af0d0faab426b68$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0af0d0faab426b68$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0af0d0faab426b68$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0af0d0faab426b68$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0af0d0faab426b68$var$p(62));
    }
}
function $0af0d0faab426b68$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0af0d0faab426b68$var$wb = null;
function $0af0d0faab426b68$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0af0d0faab426b68$var$yb = null, $0af0d0faab426b68$var$zb = null, $0af0d0faab426b68$var$Ab = null;
function $0af0d0faab426b68$var$Bb(a) {
    if (a = $0af0d0faab426b68$var$Cb(a)) {
        if ("function" !== typeof $0af0d0faab426b68$var$yb) throw Error($0af0d0faab426b68$var$p(280));
        var b = a.stateNode;
        b && (b = $0af0d0faab426b68$var$Db(b), $0af0d0faab426b68$var$yb(a.stateNode, a.type, b));
    }
}
function $0af0d0faab426b68$var$Eb(a) {
    $0af0d0faab426b68$var$zb ? $0af0d0faab426b68$var$Ab ? $0af0d0faab426b68$var$Ab.push(a) : $0af0d0faab426b68$var$Ab = [
        a
    ] : $0af0d0faab426b68$var$zb = a;
}
function $0af0d0faab426b68$var$Fb() {
    if ($0af0d0faab426b68$var$zb) {
        var a = $0af0d0faab426b68$var$zb, b = $0af0d0faab426b68$var$Ab;
        $0af0d0faab426b68$var$Ab = $0af0d0faab426b68$var$zb = null;
        $0af0d0faab426b68$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0af0d0faab426b68$var$Bb(b[a]);
    }
}
function $0af0d0faab426b68$var$Gb(a, b) {
    return a(b);
}
function $0af0d0faab426b68$var$Hb() {}
var $0af0d0faab426b68$var$Ib = !1;
function $0af0d0faab426b68$var$Jb(a, b, c) {
    if ($0af0d0faab426b68$var$Ib) return a(b, c);
    $0af0d0faab426b68$var$Ib = !0;
    try {
        return $0af0d0faab426b68$var$Gb(a, b, c);
    } finally{
        if ($0af0d0faab426b68$var$Ib = !1, null !== $0af0d0faab426b68$var$zb || null !== $0af0d0faab426b68$var$Ab) $0af0d0faab426b68$var$Hb(), $0af0d0faab426b68$var$Fb();
    }
}
function $0af0d0faab426b68$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0af0d0faab426b68$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0af0d0faab426b68$var$p(231, b, typeof c));
    return c;
}
var $0af0d0faab426b68$var$Lb = !1;
if ($0af0d0faab426b68$var$ia) try {
    var $0af0d0faab426b68$var$Mb = {};
    Object.defineProperty($0af0d0faab426b68$var$Mb, "passive", {
        get: function() {
            $0af0d0faab426b68$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0af0d0faab426b68$var$Mb, $0af0d0faab426b68$var$Mb);
    window.removeEventListener("test", $0af0d0faab426b68$var$Mb, $0af0d0faab426b68$var$Mb);
} catch (a) {
    $0af0d0faab426b68$var$Lb = !1;
}
function $0af0d0faab426b68$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0af0d0faab426b68$var$Ob = !1, $0af0d0faab426b68$var$Pb = null, $0af0d0faab426b68$var$Qb = !1, $0af0d0faab426b68$var$Rb = null, $0af0d0faab426b68$var$Sb = {
    onError: function(a) {
        $0af0d0faab426b68$var$Ob = !0;
        $0af0d0faab426b68$var$Pb = a;
    }
};
function $0af0d0faab426b68$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0af0d0faab426b68$var$Ob = !1;
    $0af0d0faab426b68$var$Pb = null;
    $0af0d0faab426b68$var$Nb.apply($0af0d0faab426b68$var$Sb, arguments);
}
function $0af0d0faab426b68$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0af0d0faab426b68$var$Tb.apply(this, arguments);
    if ($0af0d0faab426b68$var$Ob) {
        if ($0af0d0faab426b68$var$Ob) {
            var l = $0af0d0faab426b68$var$Pb;
            $0af0d0faab426b68$var$Ob = !1;
            $0af0d0faab426b68$var$Pb = null;
        } else throw Error($0af0d0faab426b68$var$p(198));
        $0af0d0faab426b68$var$Qb || ($0af0d0faab426b68$var$Qb = !0, $0af0d0faab426b68$var$Rb = l);
    }
}
function $0af0d0faab426b68$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0af0d0faab426b68$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0af0d0faab426b68$var$Xb(a) {
    if ($0af0d0faab426b68$var$Vb(a) !== a) throw Error($0af0d0faab426b68$var$p(188));
}
function $0af0d0faab426b68$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0af0d0faab426b68$var$Vb(a);
        if (null === b) throw Error($0af0d0faab426b68$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0af0d0faab426b68$var$Xb(e), a;
                if (f === d) return $0af0d0faab426b68$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0af0d0faab426b68$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0af0d0faab426b68$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0af0d0faab426b68$var$p(190));
    }
    if (3 !== c.tag) throw Error($0af0d0faab426b68$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0af0d0faab426b68$var$Zb(a) {
    a = $0af0d0faab426b68$var$Yb(a);
    return null !== a ? $0af0d0faab426b68$var$$b(a) : null;
}
function $0af0d0faab426b68$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0af0d0faab426b68$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0af0d0faab426b68$var$ac = $74qJ9.unstable_scheduleCallback, $0af0d0faab426b68$var$bc = $74qJ9.unstable_cancelCallback, $0af0d0faab426b68$var$cc = $74qJ9.unstable_shouldYield, $0af0d0faab426b68$var$dc = $74qJ9.unstable_requestPaint, $0af0d0faab426b68$var$B = $74qJ9.unstable_now, $0af0d0faab426b68$var$ec = $74qJ9.unstable_getCurrentPriorityLevel, $0af0d0faab426b68$var$fc = $74qJ9.unstable_ImmediatePriority, $0af0d0faab426b68$var$gc = $74qJ9.unstable_UserBlockingPriority, $0af0d0faab426b68$var$hc = $74qJ9.unstable_NormalPriority, $0af0d0faab426b68$var$ic = $74qJ9.unstable_LowPriority, $0af0d0faab426b68$var$jc = $74qJ9.unstable_IdlePriority, $0af0d0faab426b68$var$kc = null, $0af0d0faab426b68$var$lc = null;
function $0af0d0faab426b68$var$mc(a) {
    if ($0af0d0faab426b68$var$lc && "function" === typeof $0af0d0faab426b68$var$lc.onCommitFiberRoot) try {
        $0af0d0faab426b68$var$lc.onCommitFiberRoot($0af0d0faab426b68$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0af0d0faab426b68$var$oc = Math.clz32 ? Math.clz32 : $0af0d0faab426b68$var$nc, $0af0d0faab426b68$var$pc = Math.log, $0af0d0faab426b68$var$qc = Math.LN2;
function $0af0d0faab426b68$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0af0d0faab426b68$var$pc(a) / $0af0d0faab426b68$var$qc | 0) | 0;
}
var $0af0d0faab426b68$var$rc = 64, $0af0d0faab426b68$var$sc = 4194304;
function $0af0d0faab426b68$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0af0d0faab426b68$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0af0d0faab426b68$var$tc(h) : (f &= g, 0 !== f && (d = $0af0d0faab426b68$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0af0d0faab426b68$var$tc(g) : 0 !== f && (d = $0af0d0faab426b68$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0af0d0faab426b68$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0af0d0faab426b68$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0af0d0faab426b68$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0af0d0faab426b68$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0af0d0faab426b68$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0af0d0faab426b68$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0af0d0faab426b68$var$yc() {
    var a = $0af0d0faab426b68$var$rc;
    $0af0d0faab426b68$var$rc <<= 1;
    0 === ($0af0d0faab426b68$var$rc & 4194240) && ($0af0d0faab426b68$var$rc = 64);
    return a;
}
function $0af0d0faab426b68$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0af0d0faab426b68$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0af0d0faab426b68$var$oc(b);
    a[b] = c;
}
function $0af0d0faab426b68$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0af0d0faab426b68$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0af0d0faab426b68$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0af0d0faab426b68$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0af0d0faab426b68$var$C = 0;
function $0af0d0faab426b68$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0af0d0faab426b68$var$Ec, $0af0d0faab426b68$var$Fc, $0af0d0faab426b68$var$Gc, $0af0d0faab426b68$var$Hc, $0af0d0faab426b68$var$Ic, $0af0d0faab426b68$var$Jc = !1, $0af0d0faab426b68$var$Kc = [], $0af0d0faab426b68$var$Lc = null, $0af0d0faab426b68$var$Mc = null, $0af0d0faab426b68$var$Nc = null, $0af0d0faab426b68$var$Oc = new Map, $0af0d0faab426b68$var$Pc = new Map, $0af0d0faab426b68$var$Qc = [], $0af0d0faab426b68$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0af0d0faab426b68$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0af0d0faab426b68$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0af0d0faab426b68$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0af0d0faab426b68$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0af0d0faab426b68$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0af0d0faab426b68$var$Pc.delete(b.pointerId);
    }
}
function $0af0d0faab426b68$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0af0d0faab426b68$var$Cb(b), null !== b && $0af0d0faab426b68$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0af0d0faab426b68$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0af0d0faab426b68$var$Lc = $0af0d0faab426b68$var$Tc($0af0d0faab426b68$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0af0d0faab426b68$var$Mc = $0af0d0faab426b68$var$Tc($0af0d0faab426b68$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0af0d0faab426b68$var$Nc = $0af0d0faab426b68$var$Tc($0af0d0faab426b68$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0af0d0faab426b68$var$Oc.set(f, $0af0d0faab426b68$var$Tc($0af0d0faab426b68$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0af0d0faab426b68$var$Pc.set(f, $0af0d0faab426b68$var$Tc($0af0d0faab426b68$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0af0d0faab426b68$var$Vc(a) {
    var b = $0af0d0faab426b68$var$Wc(a.target);
    if (null !== b) {
        var c = $0af0d0faab426b68$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0af0d0faab426b68$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0af0d0faab426b68$var$Ic(a.priority, function() {
                        $0af0d0faab426b68$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0af0d0faab426b68$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0af0d0faab426b68$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0af0d0faab426b68$var$wb = d;
            c.target.dispatchEvent(d);
            $0af0d0faab426b68$var$wb = null;
        } else return b = $0af0d0faab426b68$var$Cb(c), null !== b && $0af0d0faab426b68$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0af0d0faab426b68$var$Zc(a, b, c) {
    $0af0d0faab426b68$var$Xc(a) && c.delete(b);
}
function $0af0d0faab426b68$var$$c() {
    $0af0d0faab426b68$var$Jc = !1;
    null !== $0af0d0faab426b68$var$Lc && $0af0d0faab426b68$var$Xc($0af0d0faab426b68$var$Lc) && ($0af0d0faab426b68$var$Lc = null);
    null !== $0af0d0faab426b68$var$Mc && $0af0d0faab426b68$var$Xc($0af0d0faab426b68$var$Mc) && ($0af0d0faab426b68$var$Mc = null);
    null !== $0af0d0faab426b68$var$Nc && $0af0d0faab426b68$var$Xc($0af0d0faab426b68$var$Nc) && ($0af0d0faab426b68$var$Nc = null);
    $0af0d0faab426b68$var$Oc.forEach($0af0d0faab426b68$var$Zc);
    $0af0d0faab426b68$var$Pc.forEach($0af0d0faab426b68$var$Zc);
}
function $0af0d0faab426b68$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0af0d0faab426b68$var$Jc || ($0af0d0faab426b68$var$Jc = !0, $74qJ9.unstable_scheduleCallback($74qJ9.unstable_NormalPriority, $0af0d0faab426b68$var$$c)));
}
function $0af0d0faab426b68$var$bd(a) {
    function b(b) {
        return $0af0d0faab426b68$var$ad(b, a);
    }
    if (0 < $0af0d0faab426b68$var$Kc.length) {
        $0af0d0faab426b68$var$ad($0af0d0faab426b68$var$Kc[0], a);
        for(var c = 1; c < $0af0d0faab426b68$var$Kc.length; c++){
            var d = $0af0d0faab426b68$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0af0d0faab426b68$var$Lc && $0af0d0faab426b68$var$ad($0af0d0faab426b68$var$Lc, a);
    null !== $0af0d0faab426b68$var$Mc && $0af0d0faab426b68$var$ad($0af0d0faab426b68$var$Mc, a);
    null !== $0af0d0faab426b68$var$Nc && $0af0d0faab426b68$var$ad($0af0d0faab426b68$var$Nc, a);
    $0af0d0faab426b68$var$Oc.forEach(b);
    $0af0d0faab426b68$var$Pc.forEach(b);
    for(c = 0; c < $0af0d0faab426b68$var$Qc.length; c++)d = $0af0d0faab426b68$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0af0d0faab426b68$var$Qc.length && (c = $0af0d0faab426b68$var$Qc[0], null === c.blockedOn);)$0af0d0faab426b68$var$Vc(c), null === c.blockedOn && $0af0d0faab426b68$var$Qc.shift();
}
var $0af0d0faab426b68$var$cd = $0af0d0faab426b68$var$ua.ReactCurrentBatchConfig, $0af0d0faab426b68$var$dd = !0;
function $0af0d0faab426b68$var$ed(a, b, c, d) {
    var e = $0af0d0faab426b68$var$C, f = $0af0d0faab426b68$var$cd.transition;
    $0af0d0faab426b68$var$cd.transition = null;
    try {
        $0af0d0faab426b68$var$C = 1, $0af0d0faab426b68$var$fd(a, b, c, d);
    } finally{
        $0af0d0faab426b68$var$C = e, $0af0d0faab426b68$var$cd.transition = f;
    }
}
function $0af0d0faab426b68$var$gd(a, b, c, d) {
    var e = $0af0d0faab426b68$var$C, f = $0af0d0faab426b68$var$cd.transition;
    $0af0d0faab426b68$var$cd.transition = null;
    try {
        $0af0d0faab426b68$var$C = 4, $0af0d0faab426b68$var$fd(a, b, c, d);
    } finally{
        $0af0d0faab426b68$var$C = e, $0af0d0faab426b68$var$cd.transition = f;
    }
}
function $0af0d0faab426b68$var$fd(a, b, c, d) {
    if ($0af0d0faab426b68$var$dd) {
        var e = $0af0d0faab426b68$var$Yc(a, b, c, d);
        if (null === e) $0af0d0faab426b68$var$hd(a, b, d, $0af0d0faab426b68$var$id, c), $0af0d0faab426b68$var$Sc(a, d);
        else if ($0af0d0faab426b68$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0af0d0faab426b68$var$Sc(a, d), b & 4 && -1 < $0af0d0faab426b68$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0af0d0faab426b68$var$Cb(e);
                null !== f && $0af0d0faab426b68$var$Ec(f);
                f = $0af0d0faab426b68$var$Yc(a, b, c, d);
                null === f && $0af0d0faab426b68$var$hd(a, b, d, $0af0d0faab426b68$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0af0d0faab426b68$var$hd(a, b, d, null, c);
    }
}
var $0af0d0faab426b68$var$id = null;
function $0af0d0faab426b68$var$Yc(a, b, c, d) {
    $0af0d0faab426b68$var$id = null;
    a = $0af0d0faab426b68$var$xb(d);
    a = $0af0d0faab426b68$var$Wc(a);
    if (null !== a) {
        if (b = $0af0d0faab426b68$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0af0d0faab426b68$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0af0d0faab426b68$var$id = a;
    return null;
}
function $0af0d0faab426b68$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0af0d0faab426b68$var$ec()){
                case $0af0d0faab426b68$var$fc:
                    return 1;
                case $0af0d0faab426b68$var$gc:
                    return 4;
                case $0af0d0faab426b68$var$hc:
                case $0af0d0faab426b68$var$ic:
                    return 16;
                case $0af0d0faab426b68$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0af0d0faab426b68$var$kd = null, $0af0d0faab426b68$var$ld = null, $0af0d0faab426b68$var$md = null;
function $0af0d0faab426b68$var$nd() {
    if ($0af0d0faab426b68$var$md) return $0af0d0faab426b68$var$md;
    var a, b = $0af0d0faab426b68$var$ld, c = b.length, d, e = "value" in $0af0d0faab426b68$var$kd ? $0af0d0faab426b68$var$kd.value : $0af0d0faab426b68$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0af0d0faab426b68$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0af0d0faab426b68$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0af0d0faab426b68$var$pd() {
    return !0;
}
function $0af0d0faab426b68$var$qd() {
    return !1;
}
function $0af0d0faab426b68$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0af0d0faab426b68$var$pd : $0af0d0faab426b68$var$qd;
        this.isPropagationStopped = $0af0d0faab426b68$var$qd;
        return this;
    }
    $0af0d0faab426b68$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0af0d0faab426b68$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0af0d0faab426b68$var$pd);
        },
        persist: function() {},
        isPersistent: $0af0d0faab426b68$var$pd
    });
    return b;
}
var $0af0d0faab426b68$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0af0d0faab426b68$var$td = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$sd), $0af0d0faab426b68$var$ud = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$sd, {
    view: 0,
    detail: 0
}), $0af0d0faab426b68$var$vd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$ud), $0af0d0faab426b68$var$wd, $0af0d0faab426b68$var$xd, $0af0d0faab426b68$var$yd, $0af0d0faab426b68$var$Ad = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0af0d0faab426b68$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0af0d0faab426b68$var$yd && ($0af0d0faab426b68$var$yd && "mousemove" === a.type ? ($0af0d0faab426b68$var$wd = a.screenX - $0af0d0faab426b68$var$yd.screenX, $0af0d0faab426b68$var$xd = a.screenY - $0af0d0faab426b68$var$yd.screenY) : $0af0d0faab426b68$var$xd = $0af0d0faab426b68$var$wd = 0, $0af0d0faab426b68$var$yd = a);
        return $0af0d0faab426b68$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0af0d0faab426b68$var$xd;
    }
}), $0af0d0faab426b68$var$Bd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Ad), $0af0d0faab426b68$var$Cd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$Ad, {
    dataTransfer: 0
}), $0af0d0faab426b68$var$Dd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Cd), $0af0d0faab426b68$var$Ed = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$ud, {
    relatedTarget: 0
}), $0af0d0faab426b68$var$Fd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Ed), $0af0d0faab426b68$var$Gd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0af0d0faab426b68$var$Hd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Gd), $0af0d0faab426b68$var$Id = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0af0d0faab426b68$var$Jd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Id), $0af0d0faab426b68$var$Kd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$sd, {
    data: 0
}), $0af0d0faab426b68$var$Ld = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Kd), $0af0d0faab426b68$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0af0d0faab426b68$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0af0d0faab426b68$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0af0d0faab426b68$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0af0d0faab426b68$var$Od[a]) ? !!b[a] : !1;
}
function $0af0d0faab426b68$var$zd() {
    return $0af0d0faab426b68$var$Pd;
}
var $0af0d0faab426b68$var$Qd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0af0d0faab426b68$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0af0d0faab426b68$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0af0d0faab426b68$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0af0d0faab426b68$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0af0d0faab426b68$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0af0d0faab426b68$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0af0d0faab426b68$var$Rd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Qd), $0af0d0faab426b68$var$Sd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0af0d0faab426b68$var$Td = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Sd), $0af0d0faab426b68$var$Ud = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0af0d0faab426b68$var$zd
}), $0af0d0faab426b68$var$Vd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Ud), $0af0d0faab426b68$var$Wd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0af0d0faab426b68$var$Xd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Wd), $0af0d0faab426b68$var$Yd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0af0d0faab426b68$var$Zd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Yd), $0af0d0faab426b68$var$$d = [
    9,
    13,
    27,
    32
], $0af0d0faab426b68$var$ae = $0af0d0faab426b68$var$ia && "CompositionEvent" in window, $0af0d0faab426b68$var$be = null;
$0af0d0faab426b68$var$ia && "documentMode" in document && ($0af0d0faab426b68$var$be = document.documentMode);
var $0af0d0faab426b68$var$ce = $0af0d0faab426b68$var$ia && "TextEvent" in window && !$0af0d0faab426b68$var$be, $0af0d0faab426b68$var$de = $0af0d0faab426b68$var$ia && (!$0af0d0faab426b68$var$ae || $0af0d0faab426b68$var$be && 8 < $0af0d0faab426b68$var$be && 11 >= $0af0d0faab426b68$var$be), $0af0d0faab426b68$var$ee = String.fromCharCode(32), $0af0d0faab426b68$var$fe = !1;
function $0af0d0faab426b68$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0af0d0faab426b68$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0af0d0faab426b68$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0af0d0faab426b68$var$ie = !1;
function $0af0d0faab426b68$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0af0d0faab426b68$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0af0d0faab426b68$var$fe = !0;
            return $0af0d0faab426b68$var$ee;
        case "textInput":
            return a = b.data, a === $0af0d0faab426b68$var$ee && $0af0d0faab426b68$var$fe ? null : a;
        default:
            return null;
    }
}
function $0af0d0faab426b68$var$ke(a, b) {
    if ($0af0d0faab426b68$var$ie) return "compositionend" === a || !$0af0d0faab426b68$var$ae && $0af0d0faab426b68$var$ge(a, b) ? (a = $0af0d0faab426b68$var$nd(), $0af0d0faab426b68$var$md = $0af0d0faab426b68$var$ld = $0af0d0faab426b68$var$kd = null, $0af0d0faab426b68$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0af0d0faab426b68$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0af0d0faab426b68$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0af0d0faab426b68$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0af0d0faab426b68$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0af0d0faab426b68$var$ne(a, b, c, d) {
    $0af0d0faab426b68$var$Eb(d);
    b = $0af0d0faab426b68$var$oe(b, "onChange");
    0 < b.length && (c = new $0af0d0faab426b68$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0af0d0faab426b68$var$pe = null, $0af0d0faab426b68$var$qe = null;
function $0af0d0faab426b68$var$re(a) {
    $0af0d0faab426b68$var$se(a, 0);
}
function $0af0d0faab426b68$var$te(a) {
    var b = $0af0d0faab426b68$var$ue(a);
    if ($0af0d0faab426b68$var$Wa(b)) return a;
}
function $0af0d0faab426b68$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0af0d0faab426b68$var$we = !1;
if ($0af0d0faab426b68$var$ia) {
    var $0af0d0faab426b68$var$xe;
    if ($0af0d0faab426b68$var$ia) {
        var $0af0d0faab426b68$var$ye = "oninput" in document;
        if (!$0af0d0faab426b68$var$ye) {
            var $0af0d0faab426b68$var$ze = document.createElement("div");
            $0af0d0faab426b68$var$ze.setAttribute("oninput", "return;");
            $0af0d0faab426b68$var$ye = "function" === typeof $0af0d0faab426b68$var$ze.oninput;
        }
        $0af0d0faab426b68$var$xe = $0af0d0faab426b68$var$ye;
    } else $0af0d0faab426b68$var$xe = !1;
    $0af0d0faab426b68$var$we = $0af0d0faab426b68$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0af0d0faab426b68$var$Ae() {
    $0af0d0faab426b68$var$pe && ($0af0d0faab426b68$var$pe.detachEvent("onpropertychange", $0af0d0faab426b68$var$Be), $0af0d0faab426b68$var$qe = $0af0d0faab426b68$var$pe = null);
}
function $0af0d0faab426b68$var$Be(a) {
    if ("value" === a.propertyName && $0af0d0faab426b68$var$te($0af0d0faab426b68$var$qe)) {
        var b = [];
        $0af0d0faab426b68$var$ne(b, $0af0d0faab426b68$var$qe, a, $0af0d0faab426b68$var$xb(a));
        $0af0d0faab426b68$var$Jb($0af0d0faab426b68$var$re, b);
    }
}
function $0af0d0faab426b68$var$Ce(a, b, c) {
    "focusin" === a ? ($0af0d0faab426b68$var$Ae(), $0af0d0faab426b68$var$pe = b, $0af0d0faab426b68$var$qe = c, $0af0d0faab426b68$var$pe.attachEvent("onpropertychange", $0af0d0faab426b68$var$Be)) : "focusout" === a && $0af0d0faab426b68$var$Ae();
}
function $0af0d0faab426b68$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0af0d0faab426b68$var$te($0af0d0faab426b68$var$qe);
}
function $0af0d0faab426b68$var$Ee(a, b) {
    if ("click" === a) return $0af0d0faab426b68$var$te(b);
}
function $0af0d0faab426b68$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0af0d0faab426b68$var$te(b);
}
function $0af0d0faab426b68$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0af0d0faab426b68$var$He = "function" === typeof Object.is ? Object.is : $0af0d0faab426b68$var$Ge;
function $0af0d0faab426b68$var$Ie(a, b) {
    if ($0af0d0faab426b68$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0af0d0faab426b68$var$ja.call(b, e) || !$0af0d0faab426b68$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0af0d0faab426b68$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0af0d0faab426b68$var$Ke(a, b) {
    var c = $0af0d0faab426b68$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0af0d0faab426b68$var$Je(c);
    }
}
function $0af0d0faab426b68$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0af0d0faab426b68$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0af0d0faab426b68$var$Me() {
    for(var a = window, b = $0af0d0faab426b68$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0af0d0faab426b68$var$Xa(a.document);
    }
    return b;
}
function $0af0d0faab426b68$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0af0d0faab426b68$var$Oe(a) {
    var b = $0af0d0faab426b68$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0af0d0faab426b68$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0af0d0faab426b68$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0af0d0faab426b68$var$Ke(c, f);
                var g = $0af0d0faab426b68$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0af0d0faab426b68$var$Pe = $0af0d0faab426b68$var$ia && "documentMode" in document && 11 >= document.documentMode, $0af0d0faab426b68$var$Qe = null, $0af0d0faab426b68$var$Re = null, $0af0d0faab426b68$var$Se = null, $0af0d0faab426b68$var$Te = !1;
function $0af0d0faab426b68$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0af0d0faab426b68$var$Te || null == $0af0d0faab426b68$var$Qe || $0af0d0faab426b68$var$Qe !== $0af0d0faab426b68$var$Xa(d) || (d = $0af0d0faab426b68$var$Qe, "selectionStart" in d && $0af0d0faab426b68$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0af0d0faab426b68$var$Se && $0af0d0faab426b68$var$Ie($0af0d0faab426b68$var$Se, d) || ($0af0d0faab426b68$var$Se = d, d = $0af0d0faab426b68$var$oe($0af0d0faab426b68$var$Re, "onSelect"), 0 < d.length && (b = new $0af0d0faab426b68$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0af0d0faab426b68$var$Qe)));
}
function $0af0d0faab426b68$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0af0d0faab426b68$var$We = {
    animationend: $0af0d0faab426b68$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0af0d0faab426b68$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0af0d0faab426b68$var$Ve("Animation", "AnimationStart"),
    transitionend: $0af0d0faab426b68$var$Ve("Transition", "TransitionEnd")
}, $0af0d0faab426b68$var$Xe = {}, $0af0d0faab426b68$var$Ye = {};
$0af0d0faab426b68$var$ia && ($0af0d0faab426b68$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0af0d0faab426b68$var$We.animationend.animation, delete $0af0d0faab426b68$var$We.animationiteration.animation, delete $0af0d0faab426b68$var$We.animationstart.animation), "TransitionEvent" in window || delete $0af0d0faab426b68$var$We.transitionend.transition);
function $0af0d0faab426b68$var$Ze(a) {
    if ($0af0d0faab426b68$var$Xe[a]) return $0af0d0faab426b68$var$Xe[a];
    if (!$0af0d0faab426b68$var$We[a]) return a;
    var b = $0af0d0faab426b68$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0af0d0faab426b68$var$Ye) return $0af0d0faab426b68$var$Xe[a] = b[c];
    return a;
}
var $0af0d0faab426b68$var$$e = $0af0d0faab426b68$var$Ze("animationend"), $0af0d0faab426b68$var$af = $0af0d0faab426b68$var$Ze("animationiteration"), $0af0d0faab426b68$var$bf = $0af0d0faab426b68$var$Ze("animationstart"), $0af0d0faab426b68$var$cf = $0af0d0faab426b68$var$Ze("transitionend"), $0af0d0faab426b68$var$df = new Map, $0af0d0faab426b68$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0af0d0faab426b68$var$ff(a, b) {
    $0af0d0faab426b68$var$df.set(a, b);
    $0af0d0faab426b68$var$fa(b, [
        a
    ]);
}
for(var $0af0d0faab426b68$var$gf = 0; $0af0d0faab426b68$var$gf < $0af0d0faab426b68$var$ef.length; $0af0d0faab426b68$var$gf++){
    var $0af0d0faab426b68$var$hf = $0af0d0faab426b68$var$ef[$0af0d0faab426b68$var$gf], $0af0d0faab426b68$var$jf = $0af0d0faab426b68$var$hf.toLowerCase(), $0af0d0faab426b68$var$kf = $0af0d0faab426b68$var$hf[0].toUpperCase() + $0af0d0faab426b68$var$hf.slice(1);
    $0af0d0faab426b68$var$ff($0af0d0faab426b68$var$jf, "on" + $0af0d0faab426b68$var$kf);
}
$0af0d0faab426b68$var$ff($0af0d0faab426b68$var$$e, "onAnimationEnd");
$0af0d0faab426b68$var$ff($0af0d0faab426b68$var$af, "onAnimationIteration");
$0af0d0faab426b68$var$ff($0af0d0faab426b68$var$bf, "onAnimationStart");
$0af0d0faab426b68$var$ff("dblclick", "onDoubleClick");
$0af0d0faab426b68$var$ff("focusin", "onFocus");
$0af0d0faab426b68$var$ff("focusout", "onBlur");
$0af0d0faab426b68$var$ff($0af0d0faab426b68$var$cf, "onTransitionEnd");
$0af0d0faab426b68$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0af0d0faab426b68$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0af0d0faab426b68$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0af0d0faab426b68$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0af0d0faab426b68$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0af0d0faab426b68$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0af0d0faab426b68$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0af0d0faab426b68$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0af0d0faab426b68$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0af0d0faab426b68$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0af0d0faab426b68$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0af0d0faab426b68$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0af0d0faab426b68$var$lf));
function $0af0d0faab426b68$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0af0d0faab426b68$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0af0d0faab426b68$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0af0d0faab426b68$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0af0d0faab426b68$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0af0d0faab426b68$var$Qb) throw a = $0af0d0faab426b68$var$Rb, $0af0d0faab426b68$var$Qb = !1, $0af0d0faab426b68$var$Rb = null, a;
}
function $0af0d0faab426b68$var$D(a, b) {
    var c = b[$0af0d0faab426b68$var$of];
    void 0 === c && (c = b[$0af0d0faab426b68$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0af0d0faab426b68$var$pf(b, a, 2, !1), c.add(d));
}
function $0af0d0faab426b68$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0af0d0faab426b68$var$pf(c, a, d, b);
}
var $0af0d0faab426b68$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0af0d0faab426b68$var$sf(a) {
    if (!a[$0af0d0faab426b68$var$rf]) {
        a[$0af0d0faab426b68$var$rf] = !0;
        $0af0d0faab426b68$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0af0d0faab426b68$var$mf.has(b) || $0af0d0faab426b68$var$qf(b, !1, a), $0af0d0faab426b68$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0af0d0faab426b68$var$rf] || (b[$0af0d0faab426b68$var$rf] = !0, $0af0d0faab426b68$var$qf("selectionchange", !1, b));
    }
}
function $0af0d0faab426b68$var$pf(a, b, c, d) {
    switch($0af0d0faab426b68$var$jd(b)){
        case 1:
            var e = $0af0d0faab426b68$var$ed;
            break;
        case 4:
            e = $0af0d0faab426b68$var$gd;
            break;
        default:
            e = $0af0d0faab426b68$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0af0d0faab426b68$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0af0d0faab426b68$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0af0d0faab426b68$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0af0d0faab426b68$var$Jb(function() {
        var d = f, e = $0af0d0faab426b68$var$xb(c), g = [];
        a: {
            var h = $0af0d0faab426b68$var$df.get(a);
            if (void 0 !== h) {
                var k = $0af0d0faab426b68$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0af0d0faab426b68$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0af0d0faab426b68$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0af0d0faab426b68$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0af0d0faab426b68$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0af0d0faab426b68$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0af0d0faab426b68$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0af0d0faab426b68$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0af0d0faab426b68$var$Vd;
                        break;
                    case $0af0d0faab426b68$var$$e:
                    case $0af0d0faab426b68$var$af:
                    case $0af0d0faab426b68$var$bf:
                        k = $0af0d0faab426b68$var$Hd;
                        break;
                    case $0af0d0faab426b68$var$cf:
                        k = $0af0d0faab426b68$var$Xd;
                        break;
                    case "scroll":
                        k = $0af0d0faab426b68$var$vd;
                        break;
                    case "wheel":
                        k = $0af0d0faab426b68$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0af0d0faab426b68$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0af0d0faab426b68$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0af0d0faab426b68$var$Kb(w, x), null != F && t.push($0af0d0faab426b68$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0af0d0faab426b68$var$wb && (n = c.relatedTarget || c.fromElement) && ($0af0d0faab426b68$var$Wc(n) || n[$0af0d0faab426b68$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0af0d0faab426b68$var$Wc(n) : null, null !== n && (J = $0af0d0faab426b68$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0af0d0faab426b68$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0af0d0faab426b68$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0af0d0faab426b68$var$ue(k);
                        u = null == n ? h : $0af0d0faab426b68$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0af0d0faab426b68$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0af0d0faab426b68$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0af0d0faab426b68$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0af0d0faab426b68$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0af0d0faab426b68$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0af0d0faab426b68$var$vf(t);
                                x = $0af0d0faab426b68$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0af0d0faab426b68$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0af0d0faab426b68$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0af0d0faab426b68$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0af0d0faab426b68$var$ve;
                else if ($0af0d0faab426b68$var$me(h)) {
                    if ($0af0d0faab426b68$var$we) na = $0af0d0faab426b68$var$Fe;
                    else {
                        na = $0af0d0faab426b68$var$De;
                        var xa = $0af0d0faab426b68$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0af0d0faab426b68$var$Ee);
                if (na && (na = na(a, d))) {
                    $0af0d0faab426b68$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0af0d0faab426b68$var$cb(h, "number", h.value);
            }
            xa = d ? $0af0d0faab426b68$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0af0d0faab426b68$var$me(xa) || "true" === xa.contentEditable) $0af0d0faab426b68$var$Qe = xa, $0af0d0faab426b68$var$Re = d, $0af0d0faab426b68$var$Se = null;
                    break;
                case "focusout":
                    $0af0d0faab426b68$var$Se = $0af0d0faab426b68$var$Re = $0af0d0faab426b68$var$Qe = null;
                    break;
                case "mousedown":
                    $0af0d0faab426b68$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0af0d0faab426b68$var$Te = !1;
                    $0af0d0faab426b68$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0af0d0faab426b68$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0af0d0faab426b68$var$Ue(g, c, e);
            }
            var $a;
            if ($0af0d0faab426b68$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0af0d0faab426b68$var$ie ? $0af0d0faab426b68$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0af0d0faab426b68$var$de && "ko" !== c.locale && ($0af0d0faab426b68$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0af0d0faab426b68$var$ie && ($a = $0af0d0faab426b68$var$nd()) : ($0af0d0faab426b68$var$kd = e, $0af0d0faab426b68$var$ld = "value" in $0af0d0faab426b68$var$kd ? $0af0d0faab426b68$var$kd.value : $0af0d0faab426b68$var$kd.textContent, $0af0d0faab426b68$var$ie = !0)), xa = $0af0d0faab426b68$var$oe(d, ba), 0 < xa.length && (ba = new $0af0d0faab426b68$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0af0d0faab426b68$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0af0d0faab426b68$var$ce ? $0af0d0faab426b68$var$je(a, c) : $0af0d0faab426b68$var$ke(a, c)) d = $0af0d0faab426b68$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0af0d0faab426b68$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0af0d0faab426b68$var$se(g, b);
    });
}
function $0af0d0faab426b68$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0af0d0faab426b68$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0af0d0faab426b68$var$Kb(a, c), null != f && d.unshift($0af0d0faab426b68$var$tf(a, f, e)), f = $0af0d0faab426b68$var$Kb(a, b), null != f && d.push($0af0d0faab426b68$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0af0d0faab426b68$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0af0d0faab426b68$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0af0d0faab426b68$var$Kb(c, f), null != k && g.unshift($0af0d0faab426b68$var$tf(c, k, h))) : e || (k = $0af0d0faab426b68$var$Kb(c, f), null != k && g.push($0af0d0faab426b68$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0af0d0faab426b68$var$xf = /\r\n?/g, $0af0d0faab426b68$var$yf = /\u0000|\uFFFD/g;
function $0af0d0faab426b68$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0af0d0faab426b68$var$xf, "\n").replace($0af0d0faab426b68$var$yf, "");
}
function $0af0d0faab426b68$var$Af(a, b, c) {
    b = $0af0d0faab426b68$var$zf(b);
    if ($0af0d0faab426b68$var$zf(a) !== b && c) throw Error($0af0d0faab426b68$var$p(425));
}
function $0af0d0faab426b68$var$Bf() {}
var $0af0d0faab426b68$var$Cf = null, $0af0d0faab426b68$var$Df = null;
function $0af0d0faab426b68$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0af0d0faab426b68$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0af0d0faab426b68$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0af0d0faab426b68$var$Hf = "function" === typeof Promise ? Promise : void 0, $0af0d0faab426b68$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0af0d0faab426b68$var$Hf ? function(a) {
    return $0af0d0faab426b68$var$Hf.resolve(null).then(a).catch($0af0d0faab426b68$var$If);
} : $0af0d0faab426b68$var$Ff;
function $0af0d0faab426b68$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0af0d0faab426b68$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0af0d0faab426b68$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0af0d0faab426b68$var$bd(b);
}
function $0af0d0faab426b68$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0af0d0faab426b68$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0af0d0faab426b68$var$Nf = Math.random().toString(36).slice(2), $0af0d0faab426b68$var$Of = "__reactFiber$" + $0af0d0faab426b68$var$Nf, $0af0d0faab426b68$var$Pf = "__reactProps$" + $0af0d0faab426b68$var$Nf, $0af0d0faab426b68$var$uf = "__reactContainer$" + $0af0d0faab426b68$var$Nf, $0af0d0faab426b68$var$of = "__reactEvents$" + $0af0d0faab426b68$var$Nf, $0af0d0faab426b68$var$Qf = "__reactListeners$" + $0af0d0faab426b68$var$Nf, $0af0d0faab426b68$var$Rf = "__reactHandles$" + $0af0d0faab426b68$var$Nf;
function $0af0d0faab426b68$var$Wc(a) {
    var b = a[$0af0d0faab426b68$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0af0d0faab426b68$var$uf] || c[$0af0d0faab426b68$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0af0d0faab426b68$var$Mf(a); null !== a;){
                if (c = a[$0af0d0faab426b68$var$Of]) return c;
                a = $0af0d0faab426b68$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0af0d0faab426b68$var$Cb(a) {
    a = a[$0af0d0faab426b68$var$Of] || a[$0af0d0faab426b68$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0af0d0faab426b68$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0af0d0faab426b68$var$p(33));
}
function $0af0d0faab426b68$var$Db(a) {
    return a[$0af0d0faab426b68$var$Pf] || null;
}
var $0af0d0faab426b68$var$Sf = [], $0af0d0faab426b68$var$Tf = -1;
function $0af0d0faab426b68$var$Uf(a) {
    return {
        current: a
    };
}
function $0af0d0faab426b68$var$E(a) {
    0 > $0af0d0faab426b68$var$Tf || (a.current = $0af0d0faab426b68$var$Sf[$0af0d0faab426b68$var$Tf], $0af0d0faab426b68$var$Sf[$0af0d0faab426b68$var$Tf] = null, $0af0d0faab426b68$var$Tf--);
}
function $0af0d0faab426b68$var$G(a, b) {
    $0af0d0faab426b68$var$Tf++;
    $0af0d0faab426b68$var$Sf[$0af0d0faab426b68$var$Tf] = a.current;
    a.current = b;
}
var $0af0d0faab426b68$var$Vf = {}, $0af0d0faab426b68$var$H = $0af0d0faab426b68$var$Uf($0af0d0faab426b68$var$Vf), $0af0d0faab426b68$var$Wf = $0af0d0faab426b68$var$Uf(!1), $0af0d0faab426b68$var$Xf = $0af0d0faab426b68$var$Vf;
function $0af0d0faab426b68$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0af0d0faab426b68$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0af0d0faab426b68$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0af0d0faab426b68$var$$f() {
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf);
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$H);
}
function $0af0d0faab426b68$var$ag(a, b, c) {
    if ($0af0d0faab426b68$var$H.current !== $0af0d0faab426b68$var$Vf) throw Error($0af0d0faab426b68$var$p(168));
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$H, b);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Wf, c);
}
function $0af0d0faab426b68$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0af0d0faab426b68$var$p(108, $0af0d0faab426b68$var$Ra(a) || "Unknown", e));
    return $0af0d0faab426b68$var$A({}, c, d);
}
function $0af0d0faab426b68$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0af0d0faab426b68$var$Vf;
    $0af0d0faab426b68$var$Xf = $0af0d0faab426b68$var$H.current;
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$H, a);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Wf, $0af0d0faab426b68$var$Wf.current);
    return !0;
}
function $0af0d0faab426b68$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0af0d0faab426b68$var$p(169));
    c ? (a = $0af0d0faab426b68$var$bg(a, b, $0af0d0faab426b68$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf), $0af0d0faab426b68$var$E($0af0d0faab426b68$var$H), $0af0d0faab426b68$var$G($0af0d0faab426b68$var$H, a)) : $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Wf, c);
}
var $0af0d0faab426b68$var$eg = null, $0af0d0faab426b68$var$fg = !1, $0af0d0faab426b68$var$gg = !1;
function $0af0d0faab426b68$var$hg(a) {
    null === $0af0d0faab426b68$var$eg ? $0af0d0faab426b68$var$eg = [
        a
    ] : $0af0d0faab426b68$var$eg.push(a);
}
function $0af0d0faab426b68$var$ig(a) {
    $0af0d0faab426b68$var$fg = !0;
    $0af0d0faab426b68$var$hg(a);
}
function $0af0d0faab426b68$var$jg() {
    if (!$0af0d0faab426b68$var$gg && null !== $0af0d0faab426b68$var$eg) {
        $0af0d0faab426b68$var$gg = !0;
        var a = 0, b = $0af0d0faab426b68$var$C;
        try {
            var c = $0af0d0faab426b68$var$eg;
            for($0af0d0faab426b68$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0af0d0faab426b68$var$eg = null;
            $0af0d0faab426b68$var$fg = !1;
        } catch (e) {
            throw null !== $0af0d0faab426b68$var$eg && ($0af0d0faab426b68$var$eg = $0af0d0faab426b68$var$eg.slice(a + 1)), $0af0d0faab426b68$var$ac($0af0d0faab426b68$var$fc, $0af0d0faab426b68$var$jg), e;
        } finally{
            $0af0d0faab426b68$var$C = b, $0af0d0faab426b68$var$gg = !1;
        }
    }
    return null;
}
var $0af0d0faab426b68$var$kg = [], $0af0d0faab426b68$var$lg = 0, $0af0d0faab426b68$var$mg = null, $0af0d0faab426b68$var$ng = 0, $0af0d0faab426b68$var$og = [], $0af0d0faab426b68$var$pg = 0, $0af0d0faab426b68$var$qg = null, $0af0d0faab426b68$var$rg = 1, $0af0d0faab426b68$var$sg = "";
function $0af0d0faab426b68$var$tg(a, b) {
    $0af0d0faab426b68$var$kg[$0af0d0faab426b68$var$lg++] = $0af0d0faab426b68$var$ng;
    $0af0d0faab426b68$var$kg[$0af0d0faab426b68$var$lg++] = $0af0d0faab426b68$var$mg;
    $0af0d0faab426b68$var$mg = a;
    $0af0d0faab426b68$var$ng = b;
}
function $0af0d0faab426b68$var$ug(a, b, c) {
    $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$rg;
    $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$sg;
    $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$qg;
    $0af0d0faab426b68$var$qg = a;
    var d = $0af0d0faab426b68$var$rg;
    a = $0af0d0faab426b68$var$sg;
    var e = 32 - $0af0d0faab426b68$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0af0d0faab426b68$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0af0d0faab426b68$var$rg = 1 << 32 - $0af0d0faab426b68$var$oc(b) + e | c << e | d;
        $0af0d0faab426b68$var$sg = f + a;
    } else $0af0d0faab426b68$var$rg = 1 << f | c << e | d, $0af0d0faab426b68$var$sg = a;
}
function $0af0d0faab426b68$var$vg(a) {
    null !== a.return && ($0af0d0faab426b68$var$tg(a, 1), $0af0d0faab426b68$var$ug(a, 1, 0));
}
function $0af0d0faab426b68$var$wg(a) {
    for(; a === $0af0d0faab426b68$var$mg;)$0af0d0faab426b68$var$mg = $0af0d0faab426b68$var$kg[--$0af0d0faab426b68$var$lg], $0af0d0faab426b68$var$kg[$0af0d0faab426b68$var$lg] = null, $0af0d0faab426b68$var$ng = $0af0d0faab426b68$var$kg[--$0af0d0faab426b68$var$lg], $0af0d0faab426b68$var$kg[$0af0d0faab426b68$var$lg] = null;
    for(; a === $0af0d0faab426b68$var$qg;)$0af0d0faab426b68$var$qg = $0af0d0faab426b68$var$og[--$0af0d0faab426b68$var$pg], $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg] = null, $0af0d0faab426b68$var$sg = $0af0d0faab426b68$var$og[--$0af0d0faab426b68$var$pg], $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg] = null, $0af0d0faab426b68$var$rg = $0af0d0faab426b68$var$og[--$0af0d0faab426b68$var$pg], $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg] = null;
}
var $0af0d0faab426b68$var$xg = null, $0af0d0faab426b68$var$yg = null, $0af0d0faab426b68$var$I = !1, $0af0d0faab426b68$var$zg = null;
function $0af0d0faab426b68$var$Ag(a, b) {
    var c = $0af0d0faab426b68$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0af0d0faab426b68$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0af0d0faab426b68$var$xg = a, $0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0af0d0faab426b68$var$xg = a, $0af0d0faab426b68$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0af0d0faab426b68$var$qg ? {
                id: $0af0d0faab426b68$var$rg,
                overflow: $0af0d0faab426b68$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0af0d0faab426b68$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0af0d0faab426b68$var$xg = a, $0af0d0faab426b68$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0af0d0faab426b68$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0af0d0faab426b68$var$Eg(a) {
    if ($0af0d0faab426b68$var$I) {
        var b = $0af0d0faab426b68$var$yg;
        if (b) {
            var c = b;
            if (!$0af0d0faab426b68$var$Cg(a, b)) {
                if ($0af0d0faab426b68$var$Dg(a)) throw Error($0af0d0faab426b68$var$p(418));
                b = $0af0d0faab426b68$var$Lf(c.nextSibling);
                var d = $0af0d0faab426b68$var$xg;
                b && $0af0d0faab426b68$var$Cg(a, b) ? $0af0d0faab426b68$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0af0d0faab426b68$var$I = !1, $0af0d0faab426b68$var$xg = a);
            }
        } else {
            if ($0af0d0faab426b68$var$Dg(a)) throw Error($0af0d0faab426b68$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0af0d0faab426b68$var$I = !1;
            $0af0d0faab426b68$var$xg = a;
        }
    }
}
function $0af0d0faab426b68$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0af0d0faab426b68$var$xg = a;
}
function $0af0d0faab426b68$var$Gg(a) {
    if (a !== $0af0d0faab426b68$var$xg) return !1;
    if (!$0af0d0faab426b68$var$I) return $0af0d0faab426b68$var$Fg(a), $0af0d0faab426b68$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0af0d0faab426b68$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0af0d0faab426b68$var$yg)) {
        if ($0af0d0faab426b68$var$Dg(a)) throw $0af0d0faab426b68$var$Hg(), Error($0af0d0faab426b68$var$p(418));
        for(; b;)$0af0d0faab426b68$var$Ag(a, b), b = $0af0d0faab426b68$var$Lf(b.nextSibling);
    }
    $0af0d0faab426b68$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0af0d0faab426b68$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0af0d0faab426b68$var$yg = null;
        }
    } else $0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$xg ? $0af0d0faab426b68$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0af0d0faab426b68$var$Hg() {
    for(var a = $0af0d0faab426b68$var$yg; a;)a = $0af0d0faab426b68$var$Lf(a.nextSibling);
}
function $0af0d0faab426b68$var$Ig() {
    $0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$xg = null;
    $0af0d0faab426b68$var$I = !1;
}
function $0af0d0faab426b68$var$Jg(a) {
    null === $0af0d0faab426b68$var$zg ? $0af0d0faab426b68$var$zg = [
        a
    ] : $0af0d0faab426b68$var$zg.push(a);
}
var $0af0d0faab426b68$var$Kg = $0af0d0faab426b68$var$ua.ReactCurrentBatchConfig;
function $0af0d0faab426b68$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0af0d0faab426b68$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0af0d0faab426b68$var$Mg = $0af0d0faab426b68$var$Uf(null), $0af0d0faab426b68$var$Ng = null, $0af0d0faab426b68$var$Og = null, $0af0d0faab426b68$var$Pg = null;
function $0af0d0faab426b68$var$Qg() {
    $0af0d0faab426b68$var$Pg = $0af0d0faab426b68$var$Og = $0af0d0faab426b68$var$Ng = null;
}
function $0af0d0faab426b68$var$Rg(a) {
    var b = $0af0d0faab426b68$var$Mg.current;
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Mg);
    a._currentValue = b;
}
function $0af0d0faab426b68$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0af0d0faab426b68$var$Tg(a, b) {
    $0af0d0faab426b68$var$Ng = a;
    $0af0d0faab426b68$var$Pg = $0af0d0faab426b68$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0af0d0faab426b68$var$Ug = !0), a.firstContext = null);
}
function $0af0d0faab426b68$var$Vg(a) {
    var b = a._currentValue;
    if ($0af0d0faab426b68$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0af0d0faab426b68$var$Og) {
            if (null === $0af0d0faab426b68$var$Ng) throw Error($0af0d0faab426b68$var$p(308));
            $0af0d0faab426b68$var$Og = a;
            $0af0d0faab426b68$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0af0d0faab426b68$var$Og = $0af0d0faab426b68$var$Og.next = a;
    }
    return b;
}
var $0af0d0faab426b68$var$Wg = null;
function $0af0d0faab426b68$var$Xg(a) {
    null === $0af0d0faab426b68$var$Wg ? $0af0d0faab426b68$var$Wg = [
        a
    ] : $0af0d0faab426b68$var$Wg.push(a);
}
function $0af0d0faab426b68$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0af0d0faab426b68$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0af0d0faab426b68$var$Zg(a, d);
}
function $0af0d0faab426b68$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0af0d0faab426b68$var$$g = !1;
function $0af0d0faab426b68$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0af0d0faab426b68$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0af0d0faab426b68$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0af0d0faab426b68$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0af0d0faab426b68$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0af0d0faab426b68$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0af0d0faab426b68$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0af0d0faab426b68$var$Zg(a, c);
}
function $0af0d0faab426b68$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0af0d0faab426b68$var$Cc(a, c);
    }
}
function $0af0d0faab426b68$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0af0d0faab426b68$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0af0d0faab426b68$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0af0d0faab426b68$var$A({}, q, r);
                            break a;
                        case 2:
                            $0af0d0faab426b68$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0af0d0faab426b68$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0af0d0faab426b68$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0af0d0faab426b68$var$p(191, e));
            e.call(d);
        }
    }
}
var $0af0d0faab426b68$var$jh = (new $8T3gX.Component).refs;
function $0af0d0faab426b68$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0af0d0faab426b68$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0af0d0faab426b68$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0af0d0faab426b68$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0af0d0faab426b68$var$L(), e = $0af0d0faab426b68$var$lh(a), f = $0af0d0faab426b68$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0af0d0faab426b68$var$dh(a, f, e);
        null !== b && ($0af0d0faab426b68$var$mh(b, a, e, d), $0af0d0faab426b68$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0af0d0faab426b68$var$L(), e = $0af0d0faab426b68$var$lh(a), f = $0af0d0faab426b68$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0af0d0faab426b68$var$dh(a, f, e);
        null !== b && ($0af0d0faab426b68$var$mh(b, a, e, d), $0af0d0faab426b68$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0af0d0faab426b68$var$L(), d = $0af0d0faab426b68$var$lh(a), e = $0af0d0faab426b68$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0af0d0faab426b68$var$dh(a, e, d);
        null !== b && ($0af0d0faab426b68$var$mh(b, a, d, c), $0af0d0faab426b68$var$eh(b, a, d));
    }
};
function $0af0d0faab426b68$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0af0d0faab426b68$var$Ie(c, d) || !$0af0d0faab426b68$var$Ie(e, f) : !0;
}
function $0af0d0faab426b68$var$ph(a, b, c) {
    var d = !1, e = $0af0d0faab426b68$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0af0d0faab426b68$var$Vg(f) : (e = $0af0d0faab426b68$var$Zf(b) ? $0af0d0faab426b68$var$Xf : $0af0d0faab426b68$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0af0d0faab426b68$var$Yf(a, e) : $0af0d0faab426b68$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0af0d0faab426b68$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0af0d0faab426b68$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0af0d0faab426b68$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0af0d0faab426b68$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0af0d0faab426b68$var$jh;
    $0af0d0faab426b68$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0af0d0faab426b68$var$Vg(f) : (f = $0af0d0faab426b68$var$Zf(b) ? $0af0d0faab426b68$var$Xf : $0af0d0faab426b68$var$H.current, e.context = $0af0d0faab426b68$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0af0d0faab426b68$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0af0d0faab426b68$var$nh.enqueueReplaceState(e, e.state, null), $0af0d0faab426b68$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0af0d0faab426b68$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0af0d0faab426b68$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0af0d0faab426b68$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0af0d0faab426b68$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0af0d0faab426b68$var$p(284));
        if (!c._owner) throw Error($0af0d0faab426b68$var$p(290, a));
    }
    return a;
}
function $0af0d0faab426b68$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0af0d0faab426b68$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0af0d0faab426b68$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0af0d0faab426b68$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0af0d0faab426b68$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0af0d0faab426b68$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0af0d0faab426b68$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0af0d0faab426b68$var$Ha && $0af0d0faab426b68$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0af0d0faab426b68$var$sh(a, b, c), d.return = a, d;
        d = $0af0d0faab426b68$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0af0d0faab426b68$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0af0d0faab426b68$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0af0d0faab426b68$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0af0d0faab426b68$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0af0d0faab426b68$var$va:
                    return c = $0af0d0faab426b68$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0af0d0faab426b68$var$sh(a, null, b), c.return = a, c;
                case $0af0d0faab426b68$var$wa:
                    return b = $0af0d0faab426b68$var$zh(b, a.mode, c), b.return = a, b;
                case $0af0d0faab426b68$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0af0d0faab426b68$var$eb(b) || $0af0d0faab426b68$var$Ka(b)) return b = $0af0d0faab426b68$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0af0d0faab426b68$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0af0d0faab426b68$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0af0d0faab426b68$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0af0d0faab426b68$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0af0d0faab426b68$var$eb(c) || $0af0d0faab426b68$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0af0d0faab426b68$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0af0d0faab426b68$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0af0d0faab426b68$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0af0d0faab426b68$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0af0d0faab426b68$var$eb(d) || $0af0d0faab426b68$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0af0d0faab426b68$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0af0d0faab426b68$var$Ka(h);
        if ("function" !== typeof l) throw Error($0af0d0faab426b68$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0af0d0faab426b68$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0af0d0faab426b68$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0af0d0faab426b68$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0af0d0faab426b68$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0af0d0faab426b68$var$Ha && $0af0d0faab426b68$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0af0d0faab426b68$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0af0d0faab426b68$var$ya ? (d = $0af0d0faab426b68$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0af0d0faab426b68$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0af0d0faab426b68$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0af0d0faab426b68$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0af0d0faab426b68$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0af0d0faab426b68$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0af0d0faab426b68$var$eb(f)) return n(a, d, f, h);
            if ($0af0d0faab426b68$var$Ka(f)) return t(a, d, f, h);
            $0af0d0faab426b68$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0af0d0faab426b68$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0af0d0faab426b68$var$Bh = $0af0d0faab426b68$var$vh(!0), $0af0d0faab426b68$var$Ch = $0af0d0faab426b68$var$vh(!1), $0af0d0faab426b68$var$Dh = {}, $0af0d0faab426b68$var$Eh = $0af0d0faab426b68$var$Uf($0af0d0faab426b68$var$Dh), $0af0d0faab426b68$var$Fh = $0af0d0faab426b68$var$Uf($0af0d0faab426b68$var$Dh), $0af0d0faab426b68$var$Gh = $0af0d0faab426b68$var$Uf($0af0d0faab426b68$var$Dh);
function $0af0d0faab426b68$var$Hh(a) {
    if (a === $0af0d0faab426b68$var$Dh) throw Error($0af0d0faab426b68$var$p(174));
    return a;
}
function $0af0d0faab426b68$var$Ih(a, b) {
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Gh, b);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Fh, a);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Eh, $0af0d0faab426b68$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0af0d0faab426b68$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0af0d0faab426b68$var$lb(b, a);
    }
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Eh);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Eh, b);
}
function $0af0d0faab426b68$var$Jh() {
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Eh);
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Fh);
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Gh);
}
function $0af0d0faab426b68$var$Kh(a) {
    $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Gh.current);
    var b = $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Eh.current);
    var c = $0af0d0faab426b68$var$lb(b, a.type);
    b !== c && ($0af0d0faab426b68$var$G($0af0d0faab426b68$var$Fh, a), $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Eh, c));
}
function $0af0d0faab426b68$var$Lh(a) {
    $0af0d0faab426b68$var$Fh.current === a && ($0af0d0faab426b68$var$E($0af0d0faab426b68$var$Eh), $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Fh));
}
var $0af0d0faab426b68$var$M = $0af0d0faab426b68$var$Uf(0);
function $0af0d0faab426b68$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0af0d0faab426b68$var$Nh = [];
function $0af0d0faab426b68$var$Oh() {
    for(var a = 0; a < $0af0d0faab426b68$var$Nh.length; a++)$0af0d0faab426b68$var$Nh[a]._workInProgressVersionPrimary = null;
    $0af0d0faab426b68$var$Nh.length = 0;
}
var $0af0d0faab426b68$var$Ph = $0af0d0faab426b68$var$ua.ReactCurrentDispatcher, $0af0d0faab426b68$var$Qh = $0af0d0faab426b68$var$ua.ReactCurrentBatchConfig, $0af0d0faab426b68$var$Rh = 0, $0af0d0faab426b68$var$N = null, $0af0d0faab426b68$var$O = null, $0af0d0faab426b68$var$P = null, $0af0d0faab426b68$var$Sh = !1, $0af0d0faab426b68$var$Th = !1, $0af0d0faab426b68$var$Uh = 0, $0af0d0faab426b68$var$Vh = 0;
function $0af0d0faab426b68$var$Q() {
    throw Error($0af0d0faab426b68$var$p(321));
}
function $0af0d0faab426b68$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0af0d0faab426b68$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0af0d0faab426b68$var$Xh(a, b, c, d, e, f) {
    $0af0d0faab426b68$var$Rh = f;
    $0af0d0faab426b68$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0af0d0faab426b68$var$Ph.current = null === a || null === a.memoizedState ? $0af0d0faab426b68$var$Yh : $0af0d0faab426b68$var$Zh;
    a = c(d, e);
    if ($0af0d0faab426b68$var$Th) {
        f = 0;
        do {
            $0af0d0faab426b68$var$Th = !1;
            $0af0d0faab426b68$var$Uh = 0;
            if (25 <= f) throw Error($0af0d0faab426b68$var$p(301));
            f += 1;
            $0af0d0faab426b68$var$P = $0af0d0faab426b68$var$O = null;
            b.updateQueue = null;
            $0af0d0faab426b68$var$Ph.current = $0af0d0faab426b68$var$$h;
            a = c(d, e);
        }while ($0af0d0faab426b68$var$Th);
    }
    $0af0d0faab426b68$var$Ph.current = $0af0d0faab426b68$var$ai;
    b = null !== $0af0d0faab426b68$var$O && null !== $0af0d0faab426b68$var$O.next;
    $0af0d0faab426b68$var$Rh = 0;
    $0af0d0faab426b68$var$P = $0af0d0faab426b68$var$O = $0af0d0faab426b68$var$N = null;
    $0af0d0faab426b68$var$Sh = !1;
    if (b) throw Error($0af0d0faab426b68$var$p(300));
    return a;
}
function $0af0d0faab426b68$var$bi() {
    var a = 0 !== $0af0d0faab426b68$var$Uh;
    $0af0d0faab426b68$var$Uh = 0;
    return a;
}
function $0af0d0faab426b68$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0af0d0faab426b68$var$P ? $0af0d0faab426b68$var$N.memoizedState = $0af0d0faab426b68$var$P = a : $0af0d0faab426b68$var$P = $0af0d0faab426b68$var$P.next = a;
    return $0af0d0faab426b68$var$P;
}
function $0af0d0faab426b68$var$di() {
    if (null === $0af0d0faab426b68$var$O) {
        var a = $0af0d0faab426b68$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0af0d0faab426b68$var$O.next;
    var b = null === $0af0d0faab426b68$var$P ? $0af0d0faab426b68$var$N.memoizedState : $0af0d0faab426b68$var$P.next;
    if (null !== b) $0af0d0faab426b68$var$P = b, $0af0d0faab426b68$var$O = a;
    else {
        if (null === a) throw Error($0af0d0faab426b68$var$p(310));
        $0af0d0faab426b68$var$O = a;
        a = {
            memoizedState: $0af0d0faab426b68$var$O.memoizedState,
            baseState: $0af0d0faab426b68$var$O.baseState,
            baseQueue: $0af0d0faab426b68$var$O.baseQueue,
            queue: $0af0d0faab426b68$var$O.queue,
            next: null
        };
        null === $0af0d0faab426b68$var$P ? $0af0d0faab426b68$var$N.memoizedState = $0af0d0faab426b68$var$P = a : $0af0d0faab426b68$var$P = $0af0d0faab426b68$var$P.next = a;
    }
    return $0af0d0faab426b68$var$P;
}
function $0af0d0faab426b68$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0af0d0faab426b68$var$fi(a) {
    var b = $0af0d0faab426b68$var$di(), c = b.queue;
    if (null === c) throw Error($0af0d0faab426b68$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0af0d0faab426b68$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0af0d0faab426b68$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0af0d0faab426b68$var$N.lanes |= m;
                $0af0d0faab426b68$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0af0d0faab426b68$var$He(d, b.memoizedState) || ($0af0d0faab426b68$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0af0d0faab426b68$var$N.lanes |= f, $0af0d0faab426b68$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0af0d0faab426b68$var$gi(a) {
    var b = $0af0d0faab426b68$var$di(), c = b.queue;
    if (null === c) throw Error($0af0d0faab426b68$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0af0d0faab426b68$var$He(f, b.memoizedState) || ($0af0d0faab426b68$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0af0d0faab426b68$var$hi() {}
function $0af0d0faab426b68$var$ii(a, b) {
    var c = $0af0d0faab426b68$var$N, d = $0af0d0faab426b68$var$di(), e = b(), f = !$0af0d0faab426b68$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0af0d0faab426b68$var$Ug = !0);
    d = d.queue;
    $0af0d0faab426b68$var$ji($0af0d0faab426b68$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0af0d0faab426b68$var$P && $0af0d0faab426b68$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0af0d0faab426b68$var$li(9, $0af0d0faab426b68$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0af0d0faab426b68$var$R) throw Error($0af0d0faab426b68$var$p(349));
        0 !== ($0af0d0faab426b68$var$Rh & 30) || $0af0d0faab426b68$var$ni(c, b, e);
    }
    return e;
}
function $0af0d0faab426b68$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0af0d0faab426b68$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0af0d0faab426b68$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0af0d0faab426b68$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0af0d0faab426b68$var$oi(b) && $0af0d0faab426b68$var$pi(a);
}
function $0af0d0faab426b68$var$ki(a, b, c) {
    return c(function() {
        $0af0d0faab426b68$var$oi(b) && $0af0d0faab426b68$var$pi(a);
    });
}
function $0af0d0faab426b68$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0af0d0faab426b68$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0af0d0faab426b68$var$pi(a) {
    var b = $0af0d0faab426b68$var$Zg(a, 1);
    null !== b && $0af0d0faab426b68$var$mh(b, a, 1, -1);
}
function $0af0d0faab426b68$var$qi(a) {
    var b = $0af0d0faab426b68$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0af0d0faab426b68$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0af0d0faab426b68$var$ri.bind(null, $0af0d0faab426b68$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0af0d0faab426b68$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0af0d0faab426b68$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0af0d0faab426b68$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0af0d0faab426b68$var$si() {
    return $0af0d0faab426b68$var$di().memoizedState;
}
function $0af0d0faab426b68$var$ti(a, b, c, d) {
    var e = $0af0d0faab426b68$var$ci();
    $0af0d0faab426b68$var$N.flags |= a;
    e.memoizedState = $0af0d0faab426b68$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0af0d0faab426b68$var$ui(a, b, c, d) {
    var e = $0af0d0faab426b68$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0af0d0faab426b68$var$O) {
        var g = $0af0d0faab426b68$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0af0d0faab426b68$var$Wh(d, g.deps)) {
            e.memoizedState = $0af0d0faab426b68$var$li(b, c, f, d);
            return;
        }
    }
    $0af0d0faab426b68$var$N.flags |= a;
    e.memoizedState = $0af0d0faab426b68$var$li(1 | b, c, f, d);
}
function $0af0d0faab426b68$var$vi(a, b) {
    return $0af0d0faab426b68$var$ti(8390656, 8, a, b);
}
function $0af0d0faab426b68$var$ji(a, b) {
    return $0af0d0faab426b68$var$ui(2048, 8, a, b);
}
function $0af0d0faab426b68$var$wi(a, b) {
    return $0af0d0faab426b68$var$ui(4, 2, a, b);
}
function $0af0d0faab426b68$var$xi(a, b) {
    return $0af0d0faab426b68$var$ui(4, 4, a, b);
}
function $0af0d0faab426b68$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0af0d0faab426b68$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0af0d0faab426b68$var$ui(4, 4, $0af0d0faab426b68$var$yi.bind(null, b, a), c);
}
function $0af0d0faab426b68$var$Ai() {}
function $0af0d0faab426b68$var$Bi(a, b) {
    var c = $0af0d0faab426b68$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0af0d0faab426b68$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0af0d0faab426b68$var$Ci(a, b) {
    var c = $0af0d0faab426b68$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0af0d0faab426b68$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0af0d0faab426b68$var$Di(a, b, c) {
    if (0 === ($0af0d0faab426b68$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0af0d0faab426b68$var$Ug = !0), a.memoizedState = c;
    $0af0d0faab426b68$var$He(c, b) || (c = $0af0d0faab426b68$var$yc(), $0af0d0faab426b68$var$N.lanes |= c, $0af0d0faab426b68$var$hh |= c, a.baseState = !0);
    return b;
}
function $0af0d0faab426b68$var$Ei(a, b) {
    var c = $0af0d0faab426b68$var$C;
    $0af0d0faab426b68$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0af0d0faab426b68$var$Qh.transition;
    $0af0d0faab426b68$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0af0d0faab426b68$var$C = c, $0af0d0faab426b68$var$Qh.transition = d;
    }
}
function $0af0d0faab426b68$var$Fi() {
    return $0af0d0faab426b68$var$di().memoizedState;
}
function $0af0d0faab426b68$var$Gi(a, b, c) {
    var d = $0af0d0faab426b68$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0af0d0faab426b68$var$Hi(a)) $0af0d0faab426b68$var$Ii(b, c);
    else if (c = $0af0d0faab426b68$var$Yg(a, b, c, d), null !== c) {
        var e = $0af0d0faab426b68$var$L();
        $0af0d0faab426b68$var$mh(c, a, d, e);
        $0af0d0faab426b68$var$Ji(c, b, d);
    }
}
function $0af0d0faab426b68$var$ri(a, b, c) {
    var d = $0af0d0faab426b68$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0af0d0faab426b68$var$Hi(a)) $0af0d0faab426b68$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0af0d0faab426b68$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0af0d0faab426b68$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0af0d0faab426b68$var$Yg(a, b, e, d);
        null !== c && (e = $0af0d0faab426b68$var$L(), $0af0d0faab426b68$var$mh(c, a, d, e), $0af0d0faab426b68$var$Ji(c, b, d));
    }
}
function $0af0d0faab426b68$var$Hi(a) {
    var b = a.alternate;
    return a === $0af0d0faab426b68$var$N || null !== b && b === $0af0d0faab426b68$var$N;
}
function $0af0d0faab426b68$var$Ii(a, b) {
    $0af0d0faab426b68$var$Th = $0af0d0faab426b68$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0af0d0faab426b68$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0af0d0faab426b68$var$Cc(a, c);
    }
}
var $0af0d0faab426b68$var$ai = {
    readContext: $0af0d0faab426b68$var$Vg,
    useCallback: $0af0d0faab426b68$var$Q,
    useContext: $0af0d0faab426b68$var$Q,
    useEffect: $0af0d0faab426b68$var$Q,
    useImperativeHandle: $0af0d0faab426b68$var$Q,
    useInsertionEffect: $0af0d0faab426b68$var$Q,
    useLayoutEffect: $0af0d0faab426b68$var$Q,
    useMemo: $0af0d0faab426b68$var$Q,
    useReducer: $0af0d0faab426b68$var$Q,
    useRef: $0af0d0faab426b68$var$Q,
    useState: $0af0d0faab426b68$var$Q,
    useDebugValue: $0af0d0faab426b68$var$Q,
    useDeferredValue: $0af0d0faab426b68$var$Q,
    useTransition: $0af0d0faab426b68$var$Q,
    useMutableSource: $0af0d0faab426b68$var$Q,
    useSyncExternalStore: $0af0d0faab426b68$var$Q,
    useId: $0af0d0faab426b68$var$Q,
    unstable_isNewReconciler: !1
}, $0af0d0faab426b68$var$Yh = {
    readContext: $0af0d0faab426b68$var$Vg,
    useCallback: function(a, b) {
        $0af0d0faab426b68$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0af0d0faab426b68$var$Vg,
    useEffect: $0af0d0faab426b68$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0af0d0faab426b68$var$ti(4194308, 4, $0af0d0faab426b68$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0af0d0faab426b68$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0af0d0faab426b68$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0af0d0faab426b68$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0af0d0faab426b68$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0af0d0faab426b68$var$Gi.bind(null, $0af0d0faab426b68$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0af0d0faab426b68$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0af0d0faab426b68$var$qi,
    useDebugValue: $0af0d0faab426b68$var$Ai,
    useDeferredValue: function(a) {
        return $0af0d0faab426b68$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0af0d0faab426b68$var$qi(!1), b = a[0];
        a = $0af0d0faab426b68$var$Ei.bind(null, a[1]);
        $0af0d0faab426b68$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0af0d0faab426b68$var$N, e = $0af0d0faab426b68$var$ci();
        if ($0af0d0faab426b68$var$I) {
            if (void 0 === c) throw Error($0af0d0faab426b68$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0af0d0faab426b68$var$R) throw Error($0af0d0faab426b68$var$p(349));
            0 !== ($0af0d0faab426b68$var$Rh & 30) || $0af0d0faab426b68$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0af0d0faab426b68$var$vi($0af0d0faab426b68$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0af0d0faab426b68$var$li(9, $0af0d0faab426b68$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0af0d0faab426b68$var$ci(), b = $0af0d0faab426b68$var$R.identifierPrefix;
        if ($0af0d0faab426b68$var$I) {
            var c = $0af0d0faab426b68$var$sg;
            var d = $0af0d0faab426b68$var$rg;
            c = (d & ~(1 << 32 - $0af0d0faab426b68$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0af0d0faab426b68$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0af0d0faab426b68$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0af0d0faab426b68$var$Zh = {
    readContext: $0af0d0faab426b68$var$Vg,
    useCallback: $0af0d0faab426b68$var$Bi,
    useContext: $0af0d0faab426b68$var$Vg,
    useEffect: $0af0d0faab426b68$var$ji,
    useImperativeHandle: $0af0d0faab426b68$var$zi,
    useInsertionEffect: $0af0d0faab426b68$var$wi,
    useLayoutEffect: $0af0d0faab426b68$var$xi,
    useMemo: $0af0d0faab426b68$var$Ci,
    useReducer: $0af0d0faab426b68$var$fi,
    useRef: $0af0d0faab426b68$var$si,
    useState: function() {
        return $0af0d0faab426b68$var$fi($0af0d0faab426b68$var$ei);
    },
    useDebugValue: $0af0d0faab426b68$var$Ai,
    useDeferredValue: function(a) {
        var b = $0af0d0faab426b68$var$di();
        return $0af0d0faab426b68$var$Di(b, $0af0d0faab426b68$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0af0d0faab426b68$var$fi($0af0d0faab426b68$var$ei)[0], b = $0af0d0faab426b68$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0af0d0faab426b68$var$hi,
    useSyncExternalStore: $0af0d0faab426b68$var$ii,
    useId: $0af0d0faab426b68$var$Fi,
    unstable_isNewReconciler: !1
}, $0af0d0faab426b68$var$$h = {
    readContext: $0af0d0faab426b68$var$Vg,
    useCallback: $0af0d0faab426b68$var$Bi,
    useContext: $0af0d0faab426b68$var$Vg,
    useEffect: $0af0d0faab426b68$var$ji,
    useImperativeHandle: $0af0d0faab426b68$var$zi,
    useInsertionEffect: $0af0d0faab426b68$var$wi,
    useLayoutEffect: $0af0d0faab426b68$var$xi,
    useMemo: $0af0d0faab426b68$var$Ci,
    useReducer: $0af0d0faab426b68$var$gi,
    useRef: $0af0d0faab426b68$var$si,
    useState: function() {
        return $0af0d0faab426b68$var$gi($0af0d0faab426b68$var$ei);
    },
    useDebugValue: $0af0d0faab426b68$var$Ai,
    useDeferredValue: function(a) {
        var b = $0af0d0faab426b68$var$di();
        return null === $0af0d0faab426b68$var$O ? b.memoizedState = a : $0af0d0faab426b68$var$Di(b, $0af0d0faab426b68$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0af0d0faab426b68$var$gi($0af0d0faab426b68$var$ei)[0], b = $0af0d0faab426b68$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0af0d0faab426b68$var$hi,
    useSyncExternalStore: $0af0d0faab426b68$var$ii,
    useId: $0af0d0faab426b68$var$Fi,
    unstable_isNewReconciler: !1
};
function $0af0d0faab426b68$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0af0d0faab426b68$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0af0d0faab426b68$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0af0d0faab426b68$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0af0d0faab426b68$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0af0d0faab426b68$var$Oi(a, b, c) {
    c = $0af0d0faab426b68$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0af0d0faab426b68$var$Pi || ($0af0d0faab426b68$var$Pi = !0, $0af0d0faab426b68$var$Qi = d);
        $0af0d0faab426b68$var$Mi(a, b);
    };
    return c;
}
function $0af0d0faab426b68$var$Ri(a, b, c) {
    c = $0af0d0faab426b68$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0af0d0faab426b68$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0af0d0faab426b68$var$Mi(a, b);
        "function" !== typeof d && (null === $0af0d0faab426b68$var$Si ? $0af0d0faab426b68$var$Si = new Set([
            this
        ]) : $0af0d0faab426b68$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0af0d0faab426b68$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0af0d0faab426b68$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0af0d0faab426b68$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0af0d0faab426b68$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0af0d0faab426b68$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0af0d0faab426b68$var$ch(-1, 1), b.tag = 2, $0af0d0faab426b68$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0af0d0faab426b68$var$Xi = $0af0d0faab426b68$var$ua.ReactCurrentOwner, $0af0d0faab426b68$var$Ug = !1;
function $0af0d0faab426b68$var$Yi(a, b, c, d) {
    b.child = null === a ? $0af0d0faab426b68$var$Ch(b, null, c, d) : $0af0d0faab426b68$var$Bh(b, a.child, c, d);
}
function $0af0d0faab426b68$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0af0d0faab426b68$var$Tg(b, e);
    d = $0af0d0faab426b68$var$Xh(a, b, c, d, f, e);
    c = $0af0d0faab426b68$var$bi();
    if (null !== a && !$0af0d0faab426b68$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0af0d0faab426b68$var$$i(a, b, e);
    $0af0d0faab426b68$var$I && c && $0af0d0faab426b68$var$vg(b);
    b.flags |= 1;
    $0af0d0faab426b68$var$Yi(a, b, d, e);
    return b.child;
}
function $0af0d0faab426b68$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0af0d0faab426b68$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0af0d0faab426b68$var$cj(a, b, f, d, e);
        a = $0af0d0faab426b68$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0af0d0faab426b68$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0af0d0faab426b68$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0af0d0faab426b68$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0af0d0faab426b68$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0af0d0faab426b68$var$Ie(f, d) && a.ref === b.ref) {
            if ($0af0d0faab426b68$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0af0d0faab426b68$var$Ug = !0);
            else return b.lanes = a.lanes, $0af0d0faab426b68$var$$i(a, b, e);
        }
    }
    return $0af0d0faab426b68$var$dj(a, b, c, d, e);
}
function $0af0d0faab426b68$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0af0d0faab426b68$var$G($0af0d0faab426b68$var$fj, $0af0d0faab426b68$var$gj), $0af0d0faab426b68$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0af0d0faab426b68$var$G($0af0d0faab426b68$var$fj, $0af0d0faab426b68$var$gj), $0af0d0faab426b68$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0af0d0faab426b68$var$G($0af0d0faab426b68$var$fj, $0af0d0faab426b68$var$gj);
            $0af0d0faab426b68$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0af0d0faab426b68$var$G($0af0d0faab426b68$var$fj, $0af0d0faab426b68$var$gj), $0af0d0faab426b68$var$gj |= d;
    $0af0d0faab426b68$var$Yi(a, b, e, c);
    return b.child;
}
function $0af0d0faab426b68$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0af0d0faab426b68$var$dj(a, b, c, d, e) {
    var f = $0af0d0faab426b68$var$Zf(c) ? $0af0d0faab426b68$var$Xf : $0af0d0faab426b68$var$H.current;
    f = $0af0d0faab426b68$var$Yf(b, f);
    $0af0d0faab426b68$var$Tg(b, e);
    c = $0af0d0faab426b68$var$Xh(a, b, c, d, f, e);
    d = $0af0d0faab426b68$var$bi();
    if (null !== a && !$0af0d0faab426b68$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0af0d0faab426b68$var$$i(a, b, e);
    $0af0d0faab426b68$var$I && d && $0af0d0faab426b68$var$vg(b);
    b.flags |= 1;
    $0af0d0faab426b68$var$Yi(a, b, c, e);
    return b.child;
}
function $0af0d0faab426b68$var$ij(a, b, c, d, e) {
    if ($0af0d0faab426b68$var$Zf(c)) {
        var f = !0;
        $0af0d0faab426b68$var$cg(b);
    } else f = !1;
    $0af0d0faab426b68$var$Tg(b, e);
    if (null === b.stateNode) $0af0d0faab426b68$var$jj(a, b), $0af0d0faab426b68$var$ph(b, c, d), $0af0d0faab426b68$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0af0d0faab426b68$var$Vg(l) : (l = $0af0d0faab426b68$var$Zf(c) ? $0af0d0faab426b68$var$Xf : $0af0d0faab426b68$var$H.current, l = $0af0d0faab426b68$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0af0d0faab426b68$var$qh(b, g, d, l);
        $0af0d0faab426b68$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0af0d0faab426b68$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0af0d0faab426b68$var$Wf.current || $0af0d0faab426b68$var$$g ? ("function" === typeof m && ($0af0d0faab426b68$var$kh(b, c, m, d), k = b.memoizedState), (h = $0af0d0faab426b68$var$$g || $0af0d0faab426b68$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0af0d0faab426b68$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0af0d0faab426b68$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0af0d0faab426b68$var$Vg(k) : (k = $0af0d0faab426b68$var$Zf(c) ? $0af0d0faab426b68$var$Xf : $0af0d0faab426b68$var$H.current, k = $0af0d0faab426b68$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0af0d0faab426b68$var$qh(b, g, d, k);
        $0af0d0faab426b68$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0af0d0faab426b68$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0af0d0faab426b68$var$Wf.current || $0af0d0faab426b68$var$$g ? ("function" === typeof y && ($0af0d0faab426b68$var$kh(b, c, y, d), n = b.memoizedState), (l = $0af0d0faab426b68$var$$g || $0af0d0faab426b68$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0af0d0faab426b68$var$kj(a, b, c, d, f, e);
}
function $0af0d0faab426b68$var$kj(a, b, c, d, e, f) {
    $0af0d0faab426b68$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0af0d0faab426b68$var$dg(b, c, !1), $0af0d0faab426b68$var$$i(a, b, f);
    d = b.stateNode;
    $0af0d0faab426b68$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0af0d0faab426b68$var$Bh(b, a.child, null, f), b.child = $0af0d0faab426b68$var$Bh(b, null, h, f)) : $0af0d0faab426b68$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0af0d0faab426b68$var$dg(b, c, !0);
    return b.child;
}
function $0af0d0faab426b68$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0af0d0faab426b68$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0af0d0faab426b68$var$ag(a, b.context, !1);
    $0af0d0faab426b68$var$Ih(a, b.containerInfo);
}
function $0af0d0faab426b68$var$mj(a, b, c, d, e) {
    $0af0d0faab426b68$var$Ig();
    $0af0d0faab426b68$var$Jg(e);
    b.flags |= 256;
    $0af0d0faab426b68$var$Yi(a, b, c, d);
    return b.child;
}
var $0af0d0faab426b68$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0af0d0faab426b68$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0af0d0faab426b68$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0af0d0faab426b68$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, e & 1);
    if (null === a) {
        $0af0d0faab426b68$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0af0d0faab426b68$var$qj(g, d, 0, null), a = $0af0d0faab426b68$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0af0d0faab426b68$var$oj(c), b.memoizedState = $0af0d0faab426b68$var$nj, a) : $0af0d0faab426b68$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0af0d0faab426b68$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0af0d0faab426b68$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0af0d0faab426b68$var$wh(h, f) : (f = $0af0d0faab426b68$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0af0d0faab426b68$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0af0d0faab426b68$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0af0d0faab426b68$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0af0d0faab426b68$var$rj(a, b) {
    b = $0af0d0faab426b68$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0af0d0faab426b68$var$tj(a, b, c, d) {
    null !== d && $0af0d0faab426b68$var$Jg(d);
    $0af0d0faab426b68$var$Bh(b, a.child, null, c);
    a = $0af0d0faab426b68$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0af0d0faab426b68$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0af0d0faab426b68$var$Li(Error($0af0d0faab426b68$var$p(422))), $0af0d0faab426b68$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0af0d0faab426b68$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0af0d0faab426b68$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0af0d0faab426b68$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0af0d0faab426b68$var$oj(g);
        b.memoizedState = $0af0d0faab426b68$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0af0d0faab426b68$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0af0d0faab426b68$var$p(419));
        d = $0af0d0faab426b68$var$Li(f, d, void 0);
        return $0af0d0faab426b68$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0af0d0faab426b68$var$Ug || h) {
        d = $0af0d0faab426b68$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0af0d0faab426b68$var$Zg(a, e), $0af0d0faab426b68$var$mh(d, a, e, -1));
        }
        $0af0d0faab426b68$var$uj();
        d = $0af0d0faab426b68$var$Li(Error($0af0d0faab426b68$var$p(421)));
        return $0af0d0faab426b68$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0af0d0faab426b68$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$Lf(e.nextSibling);
    $0af0d0faab426b68$var$xg = b;
    $0af0d0faab426b68$var$I = !0;
    $0af0d0faab426b68$var$zg = null;
    null !== a && ($0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$rg, $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$sg, $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$qg, $0af0d0faab426b68$var$rg = a.id, $0af0d0faab426b68$var$sg = a.overflow, $0af0d0faab426b68$var$qg = b);
    b = $0af0d0faab426b68$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0af0d0faab426b68$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0af0d0faab426b68$var$Sg(a.return, b, c);
}
function $0af0d0faab426b68$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0af0d0faab426b68$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0af0d0faab426b68$var$Yi(a, b, d.children, c);
    d = $0af0d0faab426b68$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0af0d0faab426b68$var$wj(a, c, b);
            else if (19 === a.tag) $0af0d0faab426b68$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0af0d0faab426b68$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0af0d0faab426b68$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0af0d0faab426b68$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0af0d0faab426b68$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0af0d0faab426b68$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0af0d0faab426b68$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0af0d0faab426b68$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0af0d0faab426b68$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0af0d0faab426b68$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0af0d0faab426b68$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0af0d0faab426b68$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0af0d0faab426b68$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0af0d0faab426b68$var$lj(b);
            $0af0d0faab426b68$var$Ig();
            break;
        case 5:
            $0af0d0faab426b68$var$Kh(b);
            break;
        case 1:
            $0af0d0faab426b68$var$Zf(b.type) && $0af0d0faab426b68$var$cg(b);
            break;
        case 4:
            $0af0d0faab426b68$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, $0af0d0faab426b68$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0af0d0faab426b68$var$pj(a, b, c);
                $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, $0af0d0faab426b68$var$M.current & 1);
                a = $0af0d0faab426b68$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, $0af0d0faab426b68$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0af0d0faab426b68$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, $0af0d0faab426b68$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0af0d0faab426b68$var$ej(a, b, c);
    }
    return $0af0d0faab426b68$var$$i(a, b, c);
}
var $0af0d0faab426b68$var$Aj, $0af0d0faab426b68$var$Bj, $0af0d0faab426b68$var$Cj, $0af0d0faab426b68$var$Dj;
$0af0d0faab426b68$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0af0d0faab426b68$var$Bj = function() {};
$0af0d0faab426b68$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0af0d0faab426b68$var$Ya(a, e);
                d = $0af0d0faab426b68$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0af0d0faab426b68$var$A({}, e, {
                    value: void 0
                });
                d = $0af0d0faab426b68$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0af0d0faab426b68$var$gb(a, e);
                d = $0af0d0faab426b68$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0af0d0faab426b68$var$Bf);
        }
        $0af0d0faab426b68$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0af0d0faab426b68$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0af0d0faab426b68$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0af0d0faab426b68$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0af0d0faab426b68$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0af0d0faab426b68$var$Ej(a, b) {
    if (!$0af0d0faab426b68$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0af0d0faab426b68$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0af0d0faab426b68$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0af0d0faab426b68$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0af0d0faab426b68$var$S(b), null;
        case 1:
            return $0af0d0faab426b68$var$Zf(b.type) && $0af0d0faab426b68$var$$f(), $0af0d0faab426b68$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0af0d0faab426b68$var$Jh();
            $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf);
            $0af0d0faab426b68$var$E($0af0d0faab426b68$var$H);
            $0af0d0faab426b68$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0af0d0faab426b68$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0af0d0faab426b68$var$zg && ($0af0d0faab426b68$var$Gj($0af0d0faab426b68$var$zg), $0af0d0faab426b68$var$zg = null));
            $0af0d0faab426b68$var$Bj(a, b);
            $0af0d0faab426b68$var$S(b);
            return null;
        case 5:
            $0af0d0faab426b68$var$Lh(b);
            var e = $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0af0d0faab426b68$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0af0d0faab426b68$var$p(166));
                    $0af0d0faab426b68$var$S(b);
                    return null;
                }
                a = $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Eh.current);
                if ($0af0d0faab426b68$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0af0d0faab426b68$var$Of] = b;
                    d[$0af0d0faab426b68$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0af0d0faab426b68$var$D("cancel", d);
                            $0af0d0faab426b68$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0af0d0faab426b68$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0af0d0faab426b68$var$lf.length; e++)$0af0d0faab426b68$var$D($0af0d0faab426b68$var$lf[e], d);
                            break;
                        case "source":
                            $0af0d0faab426b68$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0af0d0faab426b68$var$D("error", d);
                            $0af0d0faab426b68$var$D("load", d);
                            break;
                        case "details":
                            $0af0d0faab426b68$var$D("toggle", d);
                            break;
                        case "input":
                            $0af0d0faab426b68$var$Za(d, f);
                            $0af0d0faab426b68$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0af0d0faab426b68$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0af0d0faab426b68$var$hb(d, f), $0af0d0faab426b68$var$D("invalid", d);
                    }
                    $0af0d0faab426b68$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0af0d0faab426b68$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0af0d0faab426b68$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0af0d0faab426b68$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0af0d0faab426b68$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0af0d0faab426b68$var$Va(d);
                            $0af0d0faab426b68$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0af0d0faab426b68$var$Va(d);
                            $0af0d0faab426b68$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0af0d0faab426b68$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0af0d0faab426b68$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0af0d0faab426b68$var$Of] = b;
                    a[$0af0d0faab426b68$var$Pf] = d;
                    $0af0d0faab426b68$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0af0d0faab426b68$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0af0d0faab426b68$var$D("cancel", a);
                                $0af0d0faab426b68$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0af0d0faab426b68$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0af0d0faab426b68$var$lf.length; e++)$0af0d0faab426b68$var$D($0af0d0faab426b68$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0af0d0faab426b68$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0af0d0faab426b68$var$D("error", a);
                                $0af0d0faab426b68$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0af0d0faab426b68$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0af0d0faab426b68$var$Za(a, d);
                                e = $0af0d0faab426b68$var$Ya(a, d);
                                $0af0d0faab426b68$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0af0d0faab426b68$var$A({}, d, {
                                    value: void 0
                                });
                                $0af0d0faab426b68$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0af0d0faab426b68$var$hb(a, d);
                                e = $0af0d0faab426b68$var$gb(a, d);
                                $0af0d0faab426b68$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0af0d0faab426b68$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0af0d0faab426b68$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0af0d0faab426b68$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0af0d0faab426b68$var$ob(a, k) : "number" === typeof k && $0af0d0faab426b68$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0af0d0faab426b68$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0af0d0faab426b68$var$D("scroll", a) : null != k && $0af0d0faab426b68$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0af0d0faab426b68$var$Va(a);
                                $0af0d0faab426b68$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0af0d0faab426b68$var$Va(a);
                                $0af0d0faab426b68$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0af0d0faab426b68$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0af0d0faab426b68$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0af0d0faab426b68$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0af0d0faab426b68$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0af0d0faab426b68$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0af0d0faab426b68$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0af0d0faab426b68$var$p(166));
                c = $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Gh.current);
                $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Eh.current);
                if ($0af0d0faab426b68$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0af0d0faab426b68$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0af0d0faab426b68$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0af0d0faab426b68$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0af0d0faab426b68$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0af0d0faab426b68$var$Of] = b, b.stateNode = d;
            }
            $0af0d0faab426b68$var$S(b);
            return null;
        case 13:
            $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0af0d0faab426b68$var$I && null !== $0af0d0faab426b68$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0af0d0faab426b68$var$Hg(), $0af0d0faab426b68$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0af0d0faab426b68$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0af0d0faab426b68$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0af0d0faab426b68$var$p(317));
                        f[$0af0d0faab426b68$var$Of] = b;
                    } else $0af0d0faab426b68$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0af0d0faab426b68$var$S(b);
                    f = !1;
                } else null !== $0af0d0faab426b68$var$zg && ($0af0d0faab426b68$var$Gj($0af0d0faab426b68$var$zg), $0af0d0faab426b68$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0af0d0faab426b68$var$M.current & 1) ? 0 === $0af0d0faab426b68$var$T && ($0af0d0faab426b68$var$T = 3) : $0af0d0faab426b68$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0af0d0faab426b68$var$S(b);
            return null;
        case 4:
            return $0af0d0faab426b68$var$Jh(), $0af0d0faab426b68$var$Bj(a, b), null === a && $0af0d0faab426b68$var$sf(b.stateNode.containerInfo), $0af0d0faab426b68$var$S(b), null;
        case 10:
            return $0af0d0faab426b68$var$Rg(b.type._context), $0af0d0faab426b68$var$S(b), null;
        case 17:
            return $0af0d0faab426b68$var$Zf(b.type) && $0af0d0faab426b68$var$$f(), $0af0d0faab426b68$var$S(b), null;
        case 19:
            $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M);
            f = b.memoizedState;
            if (null === f) return $0af0d0faab426b68$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0af0d0faab426b68$var$Ej(f, !1);
                else {
                    if (0 !== $0af0d0faab426b68$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0af0d0faab426b68$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0af0d0faab426b68$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, $0af0d0faab426b68$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0af0d0faab426b68$var$B() > $0af0d0faab426b68$var$Hj && (b.flags |= 128, d = !0, $0af0d0faab426b68$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0af0d0faab426b68$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0af0d0faab426b68$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0af0d0faab426b68$var$I) return $0af0d0faab426b68$var$S(b), null;
                    } else 2 * $0af0d0faab426b68$var$B() - f.renderingStartTime > $0af0d0faab426b68$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0af0d0faab426b68$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0af0d0faab426b68$var$B(), b.sibling = null, c = $0af0d0faab426b68$var$M.current, $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, d ? c & 1 | 2 : c & 1), b;
            $0af0d0faab426b68$var$S(b);
            return null;
        case 22:
        case 23:
            return $0af0d0faab426b68$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0af0d0faab426b68$var$gj & 1073741824) && ($0af0d0faab426b68$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0af0d0faab426b68$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0af0d0faab426b68$var$p(156, b.tag));
}
function $0af0d0faab426b68$var$Jj(a, b) {
    $0af0d0faab426b68$var$wg(b);
    switch(b.tag){
        case 1:
            return $0af0d0faab426b68$var$Zf(b.type) && $0af0d0faab426b68$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0af0d0faab426b68$var$Jh(), $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf), $0af0d0faab426b68$var$E($0af0d0faab426b68$var$H), $0af0d0faab426b68$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0af0d0faab426b68$var$Lh(b), null;
        case 13:
            $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0af0d0faab426b68$var$p(340));
                $0af0d0faab426b68$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M), null;
        case 4:
            return $0af0d0faab426b68$var$Jh(), null;
        case 10:
            return $0af0d0faab426b68$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0af0d0faab426b68$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0af0d0faab426b68$var$Kj = !1, $0af0d0faab426b68$var$U = !1, $0af0d0faab426b68$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0af0d0faab426b68$var$V = null;
function $0af0d0faab426b68$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0af0d0faab426b68$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0af0d0faab426b68$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0af0d0faab426b68$var$W(a, b, d);
    }
}
var $0af0d0faab426b68$var$Oj = !1;
function $0af0d0faab426b68$var$Pj(a, b) {
    $0af0d0faab426b68$var$Cf = $0af0d0faab426b68$var$dd;
    a = $0af0d0faab426b68$var$Me();
    if ($0af0d0faab426b68$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0af0d0faab426b68$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0af0d0faab426b68$var$dd = !1;
    for($0af0d0faab426b68$var$V = b; null !== $0af0d0faab426b68$var$V;)if (b = $0af0d0faab426b68$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0af0d0faab426b68$var$V = a;
    else for(; null !== $0af0d0faab426b68$var$V;){
        b = $0af0d0faab426b68$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0af0d0faab426b68$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0af0d0faab426b68$var$p(163));
            }
        } catch (F) {
            $0af0d0faab426b68$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0af0d0faab426b68$var$V = a;
            break;
        }
        $0af0d0faab426b68$var$V = b.return;
    }
    n = $0af0d0faab426b68$var$Oj;
    $0af0d0faab426b68$var$Oj = !1;
    return n;
}
function $0af0d0faab426b68$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0af0d0faab426b68$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0af0d0faab426b68$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0af0d0faab426b68$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0af0d0faab426b68$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0af0d0faab426b68$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0af0d0faab426b68$var$Of], delete b[$0af0d0faab426b68$var$Pf], delete b[$0af0d0faab426b68$var$of], delete b[$0af0d0faab426b68$var$Qf], delete b[$0af0d0faab426b68$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0af0d0faab426b68$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0af0d0faab426b68$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0af0d0faab426b68$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0af0d0faab426b68$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0af0d0faab426b68$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0af0d0faab426b68$var$Wj(a, b, c), a = a.sibling; null !== a;)$0af0d0faab426b68$var$Wj(a, b, c), a = a.sibling;
}
function $0af0d0faab426b68$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0af0d0faab426b68$var$Xj(a, b, c), a = a.sibling; null !== a;)$0af0d0faab426b68$var$Xj(a, b, c), a = a.sibling;
}
var $0af0d0faab426b68$var$X = null, $0af0d0faab426b68$var$Yj = !1;
function $0af0d0faab426b68$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0af0d0faab426b68$var$ak(a, b, c), c = c.sibling;
}
function $0af0d0faab426b68$var$ak(a, b, c) {
    if ($0af0d0faab426b68$var$lc && "function" === typeof $0af0d0faab426b68$var$lc.onCommitFiberUnmount) try {
        $0af0d0faab426b68$var$lc.onCommitFiberUnmount($0af0d0faab426b68$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0af0d0faab426b68$var$U || $0af0d0faab426b68$var$Mj(c, b);
        case 6:
            var d = $0af0d0faab426b68$var$X, e = $0af0d0faab426b68$var$Yj;
            $0af0d0faab426b68$var$X = null;
            $0af0d0faab426b68$var$Zj(a, b, c);
            $0af0d0faab426b68$var$X = d;
            $0af0d0faab426b68$var$Yj = e;
            null !== $0af0d0faab426b68$var$X && ($0af0d0faab426b68$var$Yj ? (a = $0af0d0faab426b68$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0af0d0faab426b68$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0af0d0faab426b68$var$X && ($0af0d0faab426b68$var$Yj ? (a = $0af0d0faab426b68$var$X, c = c.stateNode, 8 === a.nodeType ? $0af0d0faab426b68$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0af0d0faab426b68$var$Kf(a, c), $0af0d0faab426b68$var$bd(a)) : $0af0d0faab426b68$var$Kf($0af0d0faab426b68$var$X, c.stateNode));
            break;
        case 4:
            d = $0af0d0faab426b68$var$X;
            e = $0af0d0faab426b68$var$Yj;
            $0af0d0faab426b68$var$X = c.stateNode.containerInfo;
            $0af0d0faab426b68$var$Yj = !0;
            $0af0d0faab426b68$var$Zj(a, b, c);
            $0af0d0faab426b68$var$X = d;
            $0af0d0faab426b68$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0af0d0faab426b68$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0af0d0faab426b68$var$Nj(c, b, g) : 0 !== (f & 4) && $0af0d0faab426b68$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0af0d0faab426b68$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0af0d0faab426b68$var$U && ($0af0d0faab426b68$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0af0d0faab426b68$var$W(c, b, h);
            }
            $0af0d0faab426b68$var$Zj(a, b, c);
            break;
        case 21:
            $0af0d0faab426b68$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0af0d0faab426b68$var$U = (d = $0af0d0faab426b68$var$U) || null !== c.memoizedState, $0af0d0faab426b68$var$Zj(a, b, c), $0af0d0faab426b68$var$U = d) : $0af0d0faab426b68$var$Zj(a, b, c);
            break;
        default:
            $0af0d0faab426b68$var$Zj(a, b, c);
    }
}
function $0af0d0faab426b68$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0af0d0faab426b68$var$Lj);
        b.forEach(function(b) {
            var d = $0af0d0faab426b68$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0af0d0faab426b68$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0af0d0faab426b68$var$X = h.stateNode;
                        $0af0d0faab426b68$var$Yj = !1;
                        break a;
                    case 3:
                        $0af0d0faab426b68$var$X = h.stateNode.containerInfo;
                        $0af0d0faab426b68$var$Yj = !0;
                        break a;
                    case 4:
                        $0af0d0faab426b68$var$X = h.stateNode.containerInfo;
                        $0af0d0faab426b68$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0af0d0faab426b68$var$X) throw Error($0af0d0faab426b68$var$p(160));
            $0af0d0faab426b68$var$ak(f, g, e);
            $0af0d0faab426b68$var$X = null;
            $0af0d0faab426b68$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0af0d0faab426b68$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0af0d0faab426b68$var$ek(b, a), b = b.sibling;
}
function $0af0d0faab426b68$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            if (d & 4) {
                try {
                    $0af0d0faab426b68$var$Qj(3, a, a.return), $0af0d0faab426b68$var$Rj(3, a);
                } catch (t) {
                    $0af0d0faab426b68$var$W(a, a.return, t);
                }
                try {
                    $0af0d0faab426b68$var$Qj(5, a, a.return);
                } catch (t) {
                    $0af0d0faab426b68$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            d & 512 && null !== c && $0af0d0faab426b68$var$Mj(c, c.return);
            break;
        case 5:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            d & 512 && null !== c && $0af0d0faab426b68$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0af0d0faab426b68$var$ob(e, "");
                } catch (t) {
                    $0af0d0faab426b68$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0af0d0faab426b68$var$ab(e, f);
                    $0af0d0faab426b68$var$vb(h, g);
                    var l = $0af0d0faab426b68$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0af0d0faab426b68$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0af0d0faab426b68$var$nb(e, q) : "children" === m ? $0af0d0faab426b68$var$ob(e, q) : $0af0d0faab426b68$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0af0d0faab426b68$var$bb(e, f);
                            break;
                        case "textarea":
                            $0af0d0faab426b68$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0af0d0faab426b68$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0af0d0faab426b68$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0af0d0faab426b68$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0af0d0faab426b68$var$Pf] = f;
                } catch (t) {
                    $0af0d0faab426b68$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0af0d0faab426b68$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0af0d0faab426b68$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0af0d0faab426b68$var$bd(b.containerInfo);
            } catch (t) {
                $0af0d0faab426b68$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            break;
        case 13:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0af0d0faab426b68$var$gk = $0af0d0faab426b68$var$B()));
            d & 4 && $0af0d0faab426b68$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0af0d0faab426b68$var$U = (l = $0af0d0faab426b68$var$U) || m, $0af0d0faab426b68$var$dk(b, a), $0af0d0faab426b68$var$U = l) : $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0af0d0faab426b68$var$V = a, m = a.child; null !== m;){
                    for(q = $0af0d0faab426b68$var$V = m; null !== $0af0d0faab426b68$var$V;){
                        r = $0af0d0faab426b68$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0af0d0faab426b68$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0af0d0faab426b68$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0af0d0faab426b68$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0af0d0faab426b68$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0af0d0faab426b68$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0af0d0faab426b68$var$V = y) : $0af0d0faab426b68$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0af0d0faab426b68$var$rb("display", g));
                            } catch (t) {
                                $0af0d0faab426b68$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0af0d0faab426b68$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            d & 4 && $0af0d0faab426b68$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0af0d0faab426b68$var$dk(b, a), $0af0d0faab426b68$var$fk(a);
    }
}
function $0af0d0faab426b68$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0af0d0faab426b68$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0af0d0faab426b68$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0af0d0faab426b68$var$ob(e, ""), d.flags &= -33);
                    var f = $0af0d0faab426b68$var$Vj(a);
                    $0af0d0faab426b68$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0af0d0faab426b68$var$Vj(a);
                    $0af0d0faab426b68$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0af0d0faab426b68$var$p(161));
            }
        } catch (k) {
            $0af0d0faab426b68$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0af0d0faab426b68$var$ik(a, b, c) {
    $0af0d0faab426b68$var$V = a;
    $0af0d0faab426b68$var$jk(a, b, c);
}
function $0af0d0faab426b68$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0af0d0faab426b68$var$V;){
        var e = $0af0d0faab426b68$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0af0d0faab426b68$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0af0d0faab426b68$var$U;
                h = $0af0d0faab426b68$var$Kj;
                var l = $0af0d0faab426b68$var$U;
                $0af0d0faab426b68$var$Kj = g;
                if (($0af0d0faab426b68$var$U = k) && !l) for($0af0d0faab426b68$var$V = e; null !== $0af0d0faab426b68$var$V;)g = $0af0d0faab426b68$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0af0d0faab426b68$var$kk(e) : null !== k ? (k.return = g, $0af0d0faab426b68$var$V = k) : $0af0d0faab426b68$var$kk(e);
                for(; null !== f;)$0af0d0faab426b68$var$V = f, $0af0d0faab426b68$var$jk(f, b, c), f = f.sibling;
                $0af0d0faab426b68$var$V = e;
                $0af0d0faab426b68$var$Kj = h;
                $0af0d0faab426b68$var$U = l;
            }
            $0af0d0faab426b68$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0af0d0faab426b68$var$V = f) : $0af0d0faab426b68$var$lk(a, b, c);
    }
}
function $0af0d0faab426b68$var$lk(a) {
    for(; null !== $0af0d0faab426b68$var$V;){
        var b = $0af0d0faab426b68$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0af0d0faab426b68$var$U || $0af0d0faab426b68$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0af0d0faab426b68$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0af0d0faab426b68$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0af0d0faab426b68$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0af0d0faab426b68$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0af0d0faab426b68$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0af0d0faab426b68$var$p(163));
                }
                $0af0d0faab426b68$var$U || b.flags & 512 && $0af0d0faab426b68$var$Sj(b);
            } catch (r) {
                $0af0d0faab426b68$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0af0d0faab426b68$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0af0d0faab426b68$var$V = c;
            break;
        }
        $0af0d0faab426b68$var$V = b.return;
    }
}
function $0af0d0faab426b68$var$hk(a) {
    for(; null !== $0af0d0faab426b68$var$V;){
        var b = $0af0d0faab426b68$var$V;
        if (b === a) {
            $0af0d0faab426b68$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0af0d0faab426b68$var$V = c;
            break;
        }
        $0af0d0faab426b68$var$V = b.return;
    }
}
function $0af0d0faab426b68$var$kk(a) {
    for(; null !== $0af0d0faab426b68$var$V;){
        var b = $0af0d0faab426b68$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0af0d0faab426b68$var$Rj(4, b);
                    } catch (k) {
                        $0af0d0faab426b68$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0af0d0faab426b68$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0af0d0faab426b68$var$Sj(b);
                    } catch (k) {
                        $0af0d0faab426b68$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0af0d0faab426b68$var$Sj(b);
                    } catch (k) {
                        $0af0d0faab426b68$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0af0d0faab426b68$var$W(b, b.return, k);
        }
        if (b === a) {
            $0af0d0faab426b68$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0af0d0faab426b68$var$V = h;
            break;
        }
        $0af0d0faab426b68$var$V = b.return;
    }
}
var $0af0d0faab426b68$var$mk = Math.ceil, $0af0d0faab426b68$var$nk = $0af0d0faab426b68$var$ua.ReactCurrentDispatcher, $0af0d0faab426b68$var$ok = $0af0d0faab426b68$var$ua.ReactCurrentOwner, $0af0d0faab426b68$var$pk = $0af0d0faab426b68$var$ua.ReactCurrentBatchConfig, $0af0d0faab426b68$var$K = 0, $0af0d0faab426b68$var$R = null, $0af0d0faab426b68$var$Y = null, $0af0d0faab426b68$var$Z = 0, $0af0d0faab426b68$var$gj = 0, $0af0d0faab426b68$var$fj = $0af0d0faab426b68$var$Uf(0), $0af0d0faab426b68$var$T = 0, $0af0d0faab426b68$var$qk = null, $0af0d0faab426b68$var$hh = 0, $0af0d0faab426b68$var$rk = 0, $0af0d0faab426b68$var$sk = 0, $0af0d0faab426b68$var$tk = null, $0af0d0faab426b68$var$uk = null, $0af0d0faab426b68$var$gk = 0, $0af0d0faab426b68$var$Hj = Infinity, $0af0d0faab426b68$var$vk = null, $0af0d0faab426b68$var$Pi = !1, $0af0d0faab426b68$var$Qi = null, $0af0d0faab426b68$var$Si = null, $0af0d0faab426b68$var$wk = !1, $0af0d0faab426b68$var$xk = null, $0af0d0faab426b68$var$yk = 0, $0af0d0faab426b68$var$zk = 0, $0af0d0faab426b68$var$Ak = null, $0af0d0faab426b68$var$Bk = -1, $0af0d0faab426b68$var$Ck = 0;
function $0af0d0faab426b68$var$L() {
    return 0 !== ($0af0d0faab426b68$var$K & 6) ? $0af0d0faab426b68$var$B() : -1 !== $0af0d0faab426b68$var$Bk ? $0af0d0faab426b68$var$Bk : $0af0d0faab426b68$var$Bk = $0af0d0faab426b68$var$B();
}
function $0af0d0faab426b68$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0af0d0faab426b68$var$K & 2) && 0 !== $0af0d0faab426b68$var$Z) return $0af0d0faab426b68$var$Z & -$0af0d0faab426b68$var$Z;
    if (null !== $0af0d0faab426b68$var$Kg.transition) return 0 === $0af0d0faab426b68$var$Ck && ($0af0d0faab426b68$var$Ck = $0af0d0faab426b68$var$yc()), $0af0d0faab426b68$var$Ck;
    a = $0af0d0faab426b68$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0af0d0faab426b68$var$jd(a.type);
    return a;
}
function $0af0d0faab426b68$var$mh(a, b, c, d) {
    if (50 < $0af0d0faab426b68$var$zk) throw $0af0d0faab426b68$var$zk = 0, $0af0d0faab426b68$var$Ak = null, Error($0af0d0faab426b68$var$p(185));
    $0af0d0faab426b68$var$Ac(a, c, d);
    if (0 === ($0af0d0faab426b68$var$K & 2) || a !== $0af0d0faab426b68$var$R) a === $0af0d0faab426b68$var$R && (0 === ($0af0d0faab426b68$var$K & 2) && ($0af0d0faab426b68$var$rk |= c), 4 === $0af0d0faab426b68$var$T && $0af0d0faab426b68$var$Dk(a, $0af0d0faab426b68$var$Z)), $0af0d0faab426b68$var$Ek(a, d), 1 === c && 0 === $0af0d0faab426b68$var$K && 0 === (b.mode & 1) && ($0af0d0faab426b68$var$Hj = $0af0d0faab426b68$var$B() + 500, $0af0d0faab426b68$var$fg && $0af0d0faab426b68$var$jg());
}
function $0af0d0faab426b68$var$Ek(a, b) {
    var c = a.callbackNode;
    $0af0d0faab426b68$var$wc(a, b);
    var d = $0af0d0faab426b68$var$uc(a, a === $0af0d0faab426b68$var$R ? $0af0d0faab426b68$var$Z : 0);
    if (0 === d) null !== c && $0af0d0faab426b68$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0af0d0faab426b68$var$bc(c);
        if (1 === b) 0 === a.tag ? $0af0d0faab426b68$var$ig($0af0d0faab426b68$var$Fk.bind(null, a)) : $0af0d0faab426b68$var$hg($0af0d0faab426b68$var$Fk.bind(null, a)), $0af0d0faab426b68$var$Jf(function() {
            0 === ($0af0d0faab426b68$var$K & 6) && $0af0d0faab426b68$var$jg();
        }), c = null;
        else {
            switch($0af0d0faab426b68$var$Dc(d)){
                case 1:
                    c = $0af0d0faab426b68$var$fc;
                    break;
                case 4:
                    c = $0af0d0faab426b68$var$gc;
                    break;
                case 16:
                    c = $0af0d0faab426b68$var$hc;
                    break;
                case 536870912:
                    c = $0af0d0faab426b68$var$jc;
                    break;
                default:
                    c = $0af0d0faab426b68$var$hc;
            }
            c = $0af0d0faab426b68$var$Gk(c, $0af0d0faab426b68$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0af0d0faab426b68$var$Hk(a, b) {
    $0af0d0faab426b68$var$Bk = -1;
    $0af0d0faab426b68$var$Ck = 0;
    if (0 !== ($0af0d0faab426b68$var$K & 6)) throw Error($0af0d0faab426b68$var$p(327));
    var c = a.callbackNode;
    if ($0af0d0faab426b68$var$Ik() && a.callbackNode !== c) return null;
    var d = $0af0d0faab426b68$var$uc(a, a === $0af0d0faab426b68$var$R ? $0af0d0faab426b68$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0af0d0faab426b68$var$Jk(a, d);
    else {
        b = d;
        var e = $0af0d0faab426b68$var$K;
        $0af0d0faab426b68$var$K |= 2;
        var f = $0af0d0faab426b68$var$Kk();
        if ($0af0d0faab426b68$var$R !== a || $0af0d0faab426b68$var$Z !== b) $0af0d0faab426b68$var$vk = null, $0af0d0faab426b68$var$Hj = $0af0d0faab426b68$var$B() + 500, $0af0d0faab426b68$var$Lk(a, b);
        for(;;)try {
            $0af0d0faab426b68$var$Mk();
            break;
        } catch (h) {
            $0af0d0faab426b68$var$Nk(a, h);
        }
        $0af0d0faab426b68$var$Qg();
        $0af0d0faab426b68$var$nk.current = f;
        $0af0d0faab426b68$var$K = e;
        null !== $0af0d0faab426b68$var$Y ? b = 0 : ($0af0d0faab426b68$var$R = null, $0af0d0faab426b68$var$Z = 0, b = $0af0d0faab426b68$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0af0d0faab426b68$var$xc(a), 0 !== e && (d = e, b = $0af0d0faab426b68$var$Ok(a, e)));
        if (1 === b) throw c = $0af0d0faab426b68$var$qk, $0af0d0faab426b68$var$Lk(a, 0), $0af0d0faab426b68$var$Dk(a, d), $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B()), c;
        if (6 === b) $0af0d0faab426b68$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0af0d0faab426b68$var$Pk(e) && (b = $0af0d0faab426b68$var$Jk(a, d), 2 === b && (f = $0af0d0faab426b68$var$xc(a), 0 !== f && (d = f, b = $0af0d0faab426b68$var$Ok(a, f))), 1 === b)) throw c = $0af0d0faab426b68$var$qk, $0af0d0faab426b68$var$Lk(a, 0), $0af0d0faab426b68$var$Dk(a, d), $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0af0d0faab426b68$var$p(345));
                case 2:
                    $0af0d0faab426b68$var$Qk(a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk);
                    break;
                case 3:
                    $0af0d0faab426b68$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0af0d0faab426b68$var$gk + 500 - $0af0d0faab426b68$var$B(), 10 < b)) {
                        if (0 !== $0af0d0faab426b68$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0af0d0faab426b68$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0af0d0faab426b68$var$Ff($0af0d0faab426b68$var$Qk.bind(null, a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk), b);
                        break;
                    }
                    $0af0d0faab426b68$var$Qk(a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk);
                    break;
                case 4:
                    $0af0d0faab426b68$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0af0d0faab426b68$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0af0d0faab426b68$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0af0d0faab426b68$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0af0d0faab426b68$var$Ff($0af0d0faab426b68$var$Qk.bind(null, a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk), d);
                        break;
                    }
                    $0af0d0faab426b68$var$Qk(a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk);
                    break;
                case 5:
                    $0af0d0faab426b68$var$Qk(a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk);
                    break;
                default:
                    throw Error($0af0d0faab426b68$var$p(329));
            }
        }
    }
    $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B());
    return a.callbackNode === c ? $0af0d0faab426b68$var$Hk.bind(null, a) : null;
}
function $0af0d0faab426b68$var$Ok(a, b) {
    var c = $0af0d0faab426b68$var$tk;
    a.current.memoizedState.isDehydrated && ($0af0d0faab426b68$var$Lk(a, b).flags |= 256);
    a = $0af0d0faab426b68$var$Jk(a, b);
    2 !== a && (b = $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$uk = c, null !== b && $0af0d0faab426b68$var$Gj(b));
    return a;
}
function $0af0d0faab426b68$var$Gj(a) {
    null === $0af0d0faab426b68$var$uk ? $0af0d0faab426b68$var$uk = a : $0af0d0faab426b68$var$uk.push.apply($0af0d0faab426b68$var$uk, a);
}
function $0af0d0faab426b68$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0af0d0faab426b68$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0af0d0faab426b68$var$Dk(a, b) {
    b &= ~$0af0d0faab426b68$var$sk;
    b &= ~$0af0d0faab426b68$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0af0d0faab426b68$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0af0d0faab426b68$var$Fk(a) {
    if (0 !== ($0af0d0faab426b68$var$K & 6)) throw Error($0af0d0faab426b68$var$p(327));
    $0af0d0faab426b68$var$Ik();
    var b = $0af0d0faab426b68$var$uc(a, 0);
    if (0 === (b & 1)) return $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B()), null;
    var c = $0af0d0faab426b68$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0af0d0faab426b68$var$xc(a);
        0 !== d && (b = d, c = $0af0d0faab426b68$var$Ok(a, d));
    }
    if (1 === c) throw c = $0af0d0faab426b68$var$qk, $0af0d0faab426b68$var$Lk(a, 0), $0af0d0faab426b68$var$Dk(a, b), $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B()), c;
    if (6 === c) throw Error($0af0d0faab426b68$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0af0d0faab426b68$var$Qk(a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk);
    $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B());
    return null;
}
function $0af0d0faab426b68$var$Rk(a, b) {
    var c = $0af0d0faab426b68$var$K;
    $0af0d0faab426b68$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0af0d0faab426b68$var$K = c, 0 === $0af0d0faab426b68$var$K && ($0af0d0faab426b68$var$Hj = $0af0d0faab426b68$var$B() + 500, $0af0d0faab426b68$var$fg && $0af0d0faab426b68$var$jg());
    }
}
function $0af0d0faab426b68$var$Sk(a) {
    null !== $0af0d0faab426b68$var$xk && 0 === $0af0d0faab426b68$var$xk.tag && 0 === ($0af0d0faab426b68$var$K & 6) && $0af0d0faab426b68$var$Ik();
    var b = $0af0d0faab426b68$var$K;
    $0af0d0faab426b68$var$K |= 1;
    var c = $0af0d0faab426b68$var$pk.transition, d = $0af0d0faab426b68$var$C;
    try {
        if ($0af0d0faab426b68$var$pk.transition = null, $0af0d0faab426b68$var$C = 1, a) return a();
    } finally{
        $0af0d0faab426b68$var$C = d, $0af0d0faab426b68$var$pk.transition = c, $0af0d0faab426b68$var$K = b, 0 === ($0af0d0faab426b68$var$K & 6) && $0af0d0faab426b68$var$jg();
    }
}
function $0af0d0faab426b68$var$Ij() {
    $0af0d0faab426b68$var$gj = $0af0d0faab426b68$var$fj.current;
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$fj);
}
function $0af0d0faab426b68$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0af0d0faab426b68$var$Gf(c));
    if (null !== $0af0d0faab426b68$var$Y) for(c = $0af0d0faab426b68$var$Y.return; null !== c;){
        var d = c;
        $0af0d0faab426b68$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0af0d0faab426b68$var$$f();
                break;
            case 3:
                $0af0d0faab426b68$var$Jh();
                $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf);
                $0af0d0faab426b68$var$E($0af0d0faab426b68$var$H);
                $0af0d0faab426b68$var$Oh();
                break;
            case 5:
                $0af0d0faab426b68$var$Lh(d);
                break;
            case 4:
                $0af0d0faab426b68$var$Jh();
                break;
            case 13:
                $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M);
                break;
            case 19:
                $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M);
                break;
            case 10:
                $0af0d0faab426b68$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0af0d0faab426b68$var$Ij();
        }
        c = c.return;
    }
    $0af0d0faab426b68$var$R = a;
    $0af0d0faab426b68$var$Y = a = $0af0d0faab426b68$var$wh(a.current, null);
    $0af0d0faab426b68$var$Z = $0af0d0faab426b68$var$gj = b;
    $0af0d0faab426b68$var$T = 0;
    $0af0d0faab426b68$var$qk = null;
    $0af0d0faab426b68$var$sk = $0af0d0faab426b68$var$rk = $0af0d0faab426b68$var$hh = 0;
    $0af0d0faab426b68$var$uk = $0af0d0faab426b68$var$tk = null;
    if (null !== $0af0d0faab426b68$var$Wg) {
        for(b = 0; b < $0af0d0faab426b68$var$Wg.length; b++)if (c = $0af0d0faab426b68$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0af0d0faab426b68$var$Wg = null;
    }
    return a;
}
function $0af0d0faab426b68$var$Nk(a, b) {
    do {
        var c = $0af0d0faab426b68$var$Y;
        try {
            $0af0d0faab426b68$var$Qg();
            $0af0d0faab426b68$var$Ph.current = $0af0d0faab426b68$var$ai;
            if ($0af0d0faab426b68$var$Sh) {
                for(var d = $0af0d0faab426b68$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0af0d0faab426b68$var$Sh = !1;
            }
            $0af0d0faab426b68$var$Rh = 0;
            $0af0d0faab426b68$var$P = $0af0d0faab426b68$var$O = $0af0d0faab426b68$var$N = null;
            $0af0d0faab426b68$var$Th = !1;
            $0af0d0faab426b68$var$Uh = 0;
            $0af0d0faab426b68$var$ok.current = null;
            if (null === c || null === c.return) {
                $0af0d0faab426b68$var$T = 1;
                $0af0d0faab426b68$var$qk = b;
                $0af0d0faab426b68$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0af0d0faab426b68$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0af0d0faab426b68$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0af0d0faab426b68$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0af0d0faab426b68$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0af0d0faab426b68$var$Ti(f, l, b);
                            $0af0d0faab426b68$var$uj();
                            break a;
                        }
                        k = Error($0af0d0faab426b68$var$p(426));
                    }
                } else if ($0af0d0faab426b68$var$I && h.mode & 1) {
                    var J = $0af0d0faab426b68$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0af0d0faab426b68$var$Wi(J, g, h, f, b);
                        $0af0d0faab426b68$var$Jg($0af0d0faab426b68$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0af0d0faab426b68$var$Ki(k, h);
                4 !== $0af0d0faab426b68$var$T && ($0af0d0faab426b68$var$T = 2);
                null === $0af0d0faab426b68$var$tk ? $0af0d0faab426b68$var$tk = [
                    f
                ] : $0af0d0faab426b68$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0af0d0faab426b68$var$Oi(f, k, b);
                            $0af0d0faab426b68$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0af0d0faab426b68$var$Si || !$0af0d0faab426b68$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0af0d0faab426b68$var$Ri(f, h, b);
                                $0af0d0faab426b68$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0af0d0faab426b68$var$Tk(c);
        } catch (na) {
            b = na;
            $0af0d0faab426b68$var$Y === c && null !== c && ($0af0d0faab426b68$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0af0d0faab426b68$var$Kk() {
    var a = $0af0d0faab426b68$var$nk.current;
    $0af0d0faab426b68$var$nk.current = $0af0d0faab426b68$var$ai;
    return null === a ? $0af0d0faab426b68$var$ai : a;
}
function $0af0d0faab426b68$var$uj() {
    if (0 === $0af0d0faab426b68$var$T || 3 === $0af0d0faab426b68$var$T || 2 === $0af0d0faab426b68$var$T) $0af0d0faab426b68$var$T = 4;
    null === $0af0d0faab426b68$var$R || 0 === ($0af0d0faab426b68$var$hh & 268435455) && 0 === ($0af0d0faab426b68$var$rk & 268435455) || $0af0d0faab426b68$var$Dk($0af0d0faab426b68$var$R, $0af0d0faab426b68$var$Z);
}
function $0af0d0faab426b68$var$Jk(a, b) {
    var c = $0af0d0faab426b68$var$K;
    $0af0d0faab426b68$var$K |= 2;
    var d = $0af0d0faab426b68$var$Kk();
    if ($0af0d0faab426b68$var$R !== a || $0af0d0faab426b68$var$Z !== b) $0af0d0faab426b68$var$vk = null, $0af0d0faab426b68$var$Lk(a, b);
    for(;;)try {
        $0af0d0faab426b68$var$Uk();
        break;
    } catch (e) {
        $0af0d0faab426b68$var$Nk(a, e);
    }
    $0af0d0faab426b68$var$Qg();
    $0af0d0faab426b68$var$K = c;
    $0af0d0faab426b68$var$nk.current = d;
    if (null !== $0af0d0faab426b68$var$Y) throw Error($0af0d0faab426b68$var$p(261));
    $0af0d0faab426b68$var$R = null;
    $0af0d0faab426b68$var$Z = 0;
    return $0af0d0faab426b68$var$T;
}
function $0af0d0faab426b68$var$Uk() {
    for(; null !== $0af0d0faab426b68$var$Y;)$0af0d0faab426b68$var$Vk($0af0d0faab426b68$var$Y);
}
function $0af0d0faab426b68$var$Mk() {
    for(; null !== $0af0d0faab426b68$var$Y && !$0af0d0faab426b68$var$cc();)$0af0d0faab426b68$var$Vk($0af0d0faab426b68$var$Y);
}
function $0af0d0faab426b68$var$Vk(a) {
    var b = $0af0d0faab426b68$var$Wk(a.alternate, a, $0af0d0faab426b68$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0af0d0faab426b68$var$Tk(a) : $0af0d0faab426b68$var$Y = b;
    $0af0d0faab426b68$var$ok.current = null;
}
function $0af0d0faab426b68$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0af0d0faab426b68$var$Fj(c, b, $0af0d0faab426b68$var$gj), null !== c) {
                $0af0d0faab426b68$var$Y = c;
                return;
            }
        } else {
            c = $0af0d0faab426b68$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0af0d0faab426b68$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0af0d0faab426b68$var$T = 6;
                $0af0d0faab426b68$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0af0d0faab426b68$var$Y = b;
            return;
        }
        $0af0d0faab426b68$var$Y = b = a;
    }while (null !== b);
    0 === $0af0d0faab426b68$var$T && ($0af0d0faab426b68$var$T = 5);
}
function $0af0d0faab426b68$var$Qk(a, b, c) {
    var d = $0af0d0faab426b68$var$C, e = $0af0d0faab426b68$var$pk.transition;
    try {
        $0af0d0faab426b68$var$pk.transition = null, $0af0d0faab426b68$var$C = 1, $0af0d0faab426b68$var$Xk(a, b, c, d);
    } finally{
        $0af0d0faab426b68$var$pk.transition = e, $0af0d0faab426b68$var$C = d;
    }
    return null;
}
function $0af0d0faab426b68$var$Xk(a, b, c, d) {
    do $0af0d0faab426b68$var$Ik();
    while (null !== $0af0d0faab426b68$var$xk);
    if (0 !== ($0af0d0faab426b68$var$K & 6)) throw Error($0af0d0faab426b68$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0af0d0faab426b68$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0af0d0faab426b68$var$Bc(a, f);
    a === $0af0d0faab426b68$var$R && ($0af0d0faab426b68$var$Y = $0af0d0faab426b68$var$R = null, $0af0d0faab426b68$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0af0d0faab426b68$var$wk || ($0af0d0faab426b68$var$wk = !0, $0af0d0faab426b68$var$Gk($0af0d0faab426b68$var$hc, function() {
        $0af0d0faab426b68$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0af0d0faab426b68$var$pk.transition;
        $0af0d0faab426b68$var$pk.transition = null;
        var g = $0af0d0faab426b68$var$C;
        $0af0d0faab426b68$var$C = 1;
        var h = $0af0d0faab426b68$var$K;
        $0af0d0faab426b68$var$K |= 4;
        $0af0d0faab426b68$var$ok.current = null;
        $0af0d0faab426b68$var$Pj(a, c);
        $0af0d0faab426b68$var$ek(c, a);
        $0af0d0faab426b68$var$Oe($0af0d0faab426b68$var$Df);
        $0af0d0faab426b68$var$dd = !!$0af0d0faab426b68$var$Cf;
        $0af0d0faab426b68$var$Df = $0af0d0faab426b68$var$Cf = null;
        a.current = c;
        $0af0d0faab426b68$var$ik(c, a, e);
        $0af0d0faab426b68$var$dc();
        $0af0d0faab426b68$var$K = h;
        $0af0d0faab426b68$var$C = g;
        $0af0d0faab426b68$var$pk.transition = f;
    } else a.current = c;
    $0af0d0faab426b68$var$wk && ($0af0d0faab426b68$var$wk = !1, $0af0d0faab426b68$var$xk = a, $0af0d0faab426b68$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0af0d0faab426b68$var$Si = null);
    $0af0d0faab426b68$var$mc(c.stateNode, d);
    $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0af0d0faab426b68$var$Pi) throw $0af0d0faab426b68$var$Pi = !1, a = $0af0d0faab426b68$var$Qi, $0af0d0faab426b68$var$Qi = null, a;
    0 !== ($0af0d0faab426b68$var$yk & 1) && 0 !== a.tag && $0af0d0faab426b68$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0af0d0faab426b68$var$Ak ? $0af0d0faab426b68$var$zk++ : ($0af0d0faab426b68$var$zk = 0, $0af0d0faab426b68$var$Ak = a) : $0af0d0faab426b68$var$zk = 0;
    $0af0d0faab426b68$var$jg();
    return null;
}
function $0af0d0faab426b68$var$Ik() {
    if (null !== $0af0d0faab426b68$var$xk) {
        var a = $0af0d0faab426b68$var$Dc($0af0d0faab426b68$var$yk), b = $0af0d0faab426b68$var$pk.transition, c = $0af0d0faab426b68$var$C;
        try {
            $0af0d0faab426b68$var$pk.transition = null;
            $0af0d0faab426b68$var$C = 16 > a ? 16 : a;
            if (null === $0af0d0faab426b68$var$xk) var d = !1;
            else {
                a = $0af0d0faab426b68$var$xk;
                $0af0d0faab426b68$var$xk = null;
                $0af0d0faab426b68$var$yk = 0;
                if (0 !== ($0af0d0faab426b68$var$K & 6)) throw Error($0af0d0faab426b68$var$p(331));
                var e = $0af0d0faab426b68$var$K;
                $0af0d0faab426b68$var$K |= 4;
                for($0af0d0faab426b68$var$V = a.current; null !== $0af0d0faab426b68$var$V;){
                    var f = $0af0d0faab426b68$var$V, g = f.child;
                    if (0 !== ($0af0d0faab426b68$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0af0d0faab426b68$var$V = l; null !== $0af0d0faab426b68$var$V;){
                                    var m = $0af0d0faab426b68$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0af0d0faab426b68$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0af0d0faab426b68$var$V = q;
                                    else for(; null !== $0af0d0faab426b68$var$V;){
                                        m = $0af0d0faab426b68$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0af0d0faab426b68$var$Tj(m);
                                        if (m === l) {
                                            $0af0d0faab426b68$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0af0d0faab426b68$var$V = r;
                                            break;
                                        }
                                        $0af0d0faab426b68$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0af0d0faab426b68$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0af0d0faab426b68$var$V = g;
                    else b: for(; null !== $0af0d0faab426b68$var$V;){
                        f = $0af0d0faab426b68$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0af0d0faab426b68$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0af0d0faab426b68$var$V = x;
                            break b;
                        }
                        $0af0d0faab426b68$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0af0d0faab426b68$var$V = w; null !== $0af0d0faab426b68$var$V;){
                    g = $0af0d0faab426b68$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0af0d0faab426b68$var$V = u;
                    else b: for(g = w; null !== $0af0d0faab426b68$var$V;){
                        h = $0af0d0faab426b68$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0af0d0faab426b68$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0af0d0faab426b68$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0af0d0faab426b68$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0af0d0faab426b68$var$V = F;
                            break b;
                        }
                        $0af0d0faab426b68$var$V = h.return;
                    }
                }
                $0af0d0faab426b68$var$K = e;
                $0af0d0faab426b68$var$jg();
                if ($0af0d0faab426b68$var$lc && "function" === typeof $0af0d0faab426b68$var$lc.onPostCommitFiberRoot) try {
                    $0af0d0faab426b68$var$lc.onPostCommitFiberRoot($0af0d0faab426b68$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0af0d0faab426b68$var$C = c, $0af0d0faab426b68$var$pk.transition = b;
        }
    }
    return !1;
}
function $0af0d0faab426b68$var$Yk(a, b, c) {
    b = $0af0d0faab426b68$var$Ki(c, b);
    b = $0af0d0faab426b68$var$Oi(a, b, 1);
    a = $0af0d0faab426b68$var$dh(a, b, 1);
    b = $0af0d0faab426b68$var$L();
    null !== a && ($0af0d0faab426b68$var$Ac(a, 1, b), $0af0d0faab426b68$var$Ek(a, b));
}
function $0af0d0faab426b68$var$W(a, b, c) {
    if (3 === a.tag) $0af0d0faab426b68$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0af0d0faab426b68$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0af0d0faab426b68$var$Si || !$0af0d0faab426b68$var$Si.has(d))) {
                a = $0af0d0faab426b68$var$Ki(c, a);
                a = $0af0d0faab426b68$var$Ri(b, a, 1);
                b = $0af0d0faab426b68$var$dh(b, a, 1);
                a = $0af0d0faab426b68$var$L();
                null !== b && ($0af0d0faab426b68$var$Ac(b, 1, a), $0af0d0faab426b68$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0af0d0faab426b68$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0af0d0faab426b68$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0af0d0faab426b68$var$R === a && ($0af0d0faab426b68$var$Z & c) === c && (4 === $0af0d0faab426b68$var$T || 3 === $0af0d0faab426b68$var$T && ($0af0d0faab426b68$var$Z & 130023424) === $0af0d0faab426b68$var$Z && 500 > $0af0d0faab426b68$var$B() - $0af0d0faab426b68$var$gk ? $0af0d0faab426b68$var$Lk(a, 0) : $0af0d0faab426b68$var$sk |= c);
    $0af0d0faab426b68$var$Ek(a, b);
}
function $0af0d0faab426b68$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0af0d0faab426b68$var$sc, $0af0d0faab426b68$var$sc <<= 1, 0 === ($0af0d0faab426b68$var$sc & 130023424) && ($0af0d0faab426b68$var$sc = 4194304)));
    var c = $0af0d0faab426b68$var$L();
    a = $0af0d0faab426b68$var$Zg(a, b);
    null !== a && ($0af0d0faab426b68$var$Ac(a, b, c), $0af0d0faab426b68$var$Ek(a, c));
}
function $0af0d0faab426b68$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0af0d0faab426b68$var$Zk(a, c);
}
function $0af0d0faab426b68$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0af0d0faab426b68$var$p(314));
    }
    null !== d && d.delete(b);
    $0af0d0faab426b68$var$Zk(a, c);
}
var $0af0d0faab426b68$var$Wk;
$0af0d0faab426b68$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0af0d0faab426b68$var$Wf.current) $0af0d0faab426b68$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0af0d0faab426b68$var$Ug = !1, $0af0d0faab426b68$var$zj(a, b, c);
            $0af0d0faab426b68$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0af0d0faab426b68$var$Ug = !1, $0af0d0faab426b68$var$I && 0 !== (b.flags & 1048576) && $0af0d0faab426b68$var$ug(b, $0af0d0faab426b68$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0af0d0faab426b68$var$jj(a, b);
            a = b.pendingProps;
            var e = $0af0d0faab426b68$var$Yf(b, $0af0d0faab426b68$var$H.current);
            $0af0d0faab426b68$var$Tg(b, c);
            e = $0af0d0faab426b68$var$Xh(null, b, d, a, e, c);
            var f = $0af0d0faab426b68$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0af0d0faab426b68$var$Zf(d) ? (f = !0, $0af0d0faab426b68$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0af0d0faab426b68$var$ah(b), e.updater = $0af0d0faab426b68$var$nh, b.stateNode = e, e._reactInternals = b, $0af0d0faab426b68$var$rh(b, d, a, c), b = $0af0d0faab426b68$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0af0d0faab426b68$var$I && f && $0af0d0faab426b68$var$vg(b), $0af0d0faab426b68$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0af0d0faab426b68$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0af0d0faab426b68$var$$k(d);
                a = $0af0d0faab426b68$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0af0d0faab426b68$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0af0d0faab426b68$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0af0d0faab426b68$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0af0d0faab426b68$var$aj(null, b, d, $0af0d0faab426b68$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0af0d0faab426b68$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0af0d0faab426b68$var$Lg(d, e), $0af0d0faab426b68$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0af0d0faab426b68$var$Lg(d, e), $0af0d0faab426b68$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0af0d0faab426b68$var$lj(b);
                if (null === a) throw Error($0af0d0faab426b68$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0af0d0faab426b68$var$bh(a, b);
                $0af0d0faab426b68$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0af0d0faab426b68$var$Ki(Error($0af0d0faab426b68$var$p(423)), b);
                        b = $0af0d0faab426b68$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0af0d0faab426b68$var$Ki(Error($0af0d0faab426b68$var$p(424)), b);
                        b = $0af0d0faab426b68$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$Lf(b.stateNode.containerInfo.firstChild), $0af0d0faab426b68$var$xg = b, $0af0d0faab426b68$var$I = !0, $0af0d0faab426b68$var$zg = null, c = $0af0d0faab426b68$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0af0d0faab426b68$var$Ig();
                    if (d === e) {
                        b = $0af0d0faab426b68$var$$i(a, b, c);
                        break a;
                    }
                    $0af0d0faab426b68$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0af0d0faab426b68$var$Kh(b), null === a && $0af0d0faab426b68$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0af0d0faab426b68$var$Ef(d, e) ? g = null : null !== f && $0af0d0faab426b68$var$Ef(d, f) && (b.flags |= 32), $0af0d0faab426b68$var$hj(a, b), $0af0d0faab426b68$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0af0d0faab426b68$var$Eg(b), null;
        case 13:
            return $0af0d0faab426b68$var$pj(a, b, c);
        case 4:
            return $0af0d0faab426b68$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0af0d0faab426b68$var$Bh(b, null, d, c) : $0af0d0faab426b68$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0af0d0faab426b68$var$Lg(d, e), $0af0d0faab426b68$var$Zi(a, b, d, e, c);
        case 7:
            return $0af0d0faab426b68$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0af0d0faab426b68$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0af0d0faab426b68$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0af0d0faab426b68$var$He(f.value, g)) {
                        if (f.children === e.children && !$0af0d0faab426b68$var$Wf.current) {
                            b = $0af0d0faab426b68$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0af0d0faab426b68$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0af0d0faab426b68$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0af0d0faab426b68$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0af0d0faab426b68$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0af0d0faab426b68$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0af0d0faab426b68$var$Tg(b, c), e = $0af0d0faab426b68$var$Vg(e), d = d(e), b.flags |= 1, $0af0d0faab426b68$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0af0d0faab426b68$var$Lg(d, b.pendingProps), e = $0af0d0faab426b68$var$Lg(d.type, e), $0af0d0faab426b68$var$aj(a, b, d, e, c);
        case 15:
            return $0af0d0faab426b68$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0af0d0faab426b68$var$Lg(d, e), $0af0d0faab426b68$var$jj(a, b), b.tag = 1, $0af0d0faab426b68$var$Zf(d) ? (a = !0, $0af0d0faab426b68$var$cg(b)) : a = !1, $0af0d0faab426b68$var$Tg(b, c), $0af0d0faab426b68$var$ph(b, d, e), $0af0d0faab426b68$var$rh(b, d, e, c), $0af0d0faab426b68$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0af0d0faab426b68$var$yj(a, b, c);
        case 22:
            return $0af0d0faab426b68$var$ej(a, b, c);
    }
    throw Error($0af0d0faab426b68$var$p(156, b.tag));
};
function $0af0d0faab426b68$var$Gk(a, b) {
    return $0af0d0faab426b68$var$ac(a, b);
}
function $0af0d0faab426b68$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0af0d0faab426b68$var$Bg(a, b, c, d) {
    return new $0af0d0faab426b68$var$al(a, b, c, d);
}
function $0af0d0faab426b68$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0af0d0faab426b68$var$$k(a) {
    if ("function" === typeof a) return $0af0d0faab426b68$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0af0d0faab426b68$var$Da) return 11;
        if (a === $0af0d0faab426b68$var$Ga) return 14;
    }
    return 2;
}
function $0af0d0faab426b68$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0af0d0faab426b68$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0af0d0faab426b68$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0af0d0faab426b68$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0af0d0faab426b68$var$ya:
            return $0af0d0faab426b68$var$Ah(c.children, e, f, b);
        case $0af0d0faab426b68$var$za:
            g = 8;
            e |= 8;
            break;
        case $0af0d0faab426b68$var$Aa:
            return a = $0af0d0faab426b68$var$Bg(12, c, b, e | 2), a.elementType = $0af0d0faab426b68$var$Aa, a.lanes = f, a;
        case $0af0d0faab426b68$var$Ea:
            return a = $0af0d0faab426b68$var$Bg(13, c, b, e), a.elementType = $0af0d0faab426b68$var$Ea, a.lanes = f, a;
        case $0af0d0faab426b68$var$Fa:
            return a = $0af0d0faab426b68$var$Bg(19, c, b, e), a.elementType = $0af0d0faab426b68$var$Fa, a.lanes = f, a;
        case $0af0d0faab426b68$var$Ia:
            return $0af0d0faab426b68$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0af0d0faab426b68$var$Ba:
                    g = 10;
                    break a;
                case $0af0d0faab426b68$var$Ca:
                    g = 9;
                    break a;
                case $0af0d0faab426b68$var$Da:
                    g = 11;
                    break a;
                case $0af0d0faab426b68$var$Ga:
                    g = 14;
                    break a;
                case $0af0d0faab426b68$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0af0d0faab426b68$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0af0d0faab426b68$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0af0d0faab426b68$var$Ah(a, b, c, d) {
    a = $0af0d0faab426b68$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0af0d0faab426b68$var$qj(a, b, c, d) {
    a = $0af0d0faab426b68$var$Bg(22, a, d, b);
    a.elementType = $0af0d0faab426b68$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0af0d0faab426b68$var$xh(a, b, c) {
    a = $0af0d0faab426b68$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0af0d0faab426b68$var$zh(a, b, c) {
    b = $0af0d0faab426b68$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0af0d0faab426b68$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0af0d0faab426b68$var$zc(0);
    this.expirationTimes = $0af0d0faab426b68$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0af0d0faab426b68$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0af0d0faab426b68$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0af0d0faab426b68$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0af0d0faab426b68$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0af0d0faab426b68$var$ah(f);
    return a;
}
function $0af0d0faab426b68$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0af0d0faab426b68$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0af0d0faab426b68$var$el(a) {
    if (!a) return $0af0d0faab426b68$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0af0d0faab426b68$var$Vb(a) !== a || 1 !== a.tag) throw Error($0af0d0faab426b68$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0af0d0faab426b68$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0af0d0faab426b68$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0af0d0faab426b68$var$Zf(c)) return $0af0d0faab426b68$var$bg(a, c, b);
    }
    return b;
}
function $0af0d0faab426b68$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0af0d0faab426b68$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0af0d0faab426b68$var$el(null);
    c = a.current;
    d = $0af0d0faab426b68$var$L();
    e = $0af0d0faab426b68$var$lh(c);
    f = $0af0d0faab426b68$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0af0d0faab426b68$var$dh(c, f, e);
    a.current.lanes = e;
    $0af0d0faab426b68$var$Ac(a, e, d);
    $0af0d0faab426b68$var$Ek(a, d);
    return a;
}
function $0af0d0faab426b68$var$gl(a, b, c, d) {
    var e = b.current, f = $0af0d0faab426b68$var$L(), g = $0af0d0faab426b68$var$lh(e);
    c = $0af0d0faab426b68$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0af0d0faab426b68$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0af0d0faab426b68$var$dh(e, b, g);
    null !== a && ($0af0d0faab426b68$var$mh(a, e, g, f), $0af0d0faab426b68$var$eh(a, e, g));
    return g;
}
function $0af0d0faab426b68$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0af0d0faab426b68$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0af0d0faab426b68$var$jl(a, b) {
    $0af0d0faab426b68$var$il(a, b);
    (a = a.alternate) && $0af0d0faab426b68$var$il(a, b);
}
function $0af0d0faab426b68$var$kl() {
    return null;
}
var $0af0d0faab426b68$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0af0d0faab426b68$var$ml(a) {
    this._internalRoot = a;
}
$0af0d0faab426b68$var$nl.prototype.render = $0af0d0faab426b68$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0af0d0faab426b68$var$p(409));
    $0af0d0faab426b68$var$gl(a, b, null, null);
};
$0af0d0faab426b68$var$nl.prototype.unmount = $0af0d0faab426b68$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0af0d0faab426b68$var$Sk(function() {
            $0af0d0faab426b68$var$gl(null, a, null, null);
        });
        b[$0af0d0faab426b68$var$uf] = null;
    }
};
function $0af0d0faab426b68$var$nl(a) {
    this._internalRoot = a;
}
$0af0d0faab426b68$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0af0d0faab426b68$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0af0d0faab426b68$var$Qc.length && 0 !== b && b < $0af0d0faab426b68$var$Qc[c].priority; c++);
        $0af0d0faab426b68$var$Qc.splice(c, 0, a);
        0 === c && $0af0d0faab426b68$var$Vc(a);
    }
};
function $0af0d0faab426b68$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0af0d0faab426b68$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0af0d0faab426b68$var$ql() {}
function $0af0d0faab426b68$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0af0d0faab426b68$var$hl(g);
                f.call(a);
            };
        }
        var g = $0af0d0faab426b68$var$fl(b, d, a, 0, null, !1, !1, "", $0af0d0faab426b68$var$ql);
        a._reactRootContainer = g;
        a[$0af0d0faab426b68$var$uf] = g.current;
        $0af0d0faab426b68$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0af0d0faab426b68$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0af0d0faab426b68$var$hl(k);
            h.call(a);
        };
    }
    var k = $0af0d0faab426b68$var$cl(a, 0, !1, null, null, !1, !1, "", $0af0d0faab426b68$var$ql);
    a._reactRootContainer = k;
    a[$0af0d0faab426b68$var$uf] = k.current;
    $0af0d0faab426b68$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0af0d0faab426b68$var$Sk(function() {
        $0af0d0faab426b68$var$gl(b, k, c, d);
    });
    return k;
}
function $0af0d0faab426b68$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0af0d0faab426b68$var$hl(g);
                h.call(a);
            };
        }
        $0af0d0faab426b68$var$gl(b, g, a, e);
    } else g = $0af0d0faab426b68$var$rl(c, b, a, e, d);
    return $0af0d0faab426b68$var$hl(g);
}
$0af0d0faab426b68$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0af0d0faab426b68$var$tc(b.pendingLanes);
                0 !== c && ($0af0d0faab426b68$var$Cc(b, c | 1), $0af0d0faab426b68$var$Ek(b, $0af0d0faab426b68$var$B()), 0 === ($0af0d0faab426b68$var$K & 6) && ($0af0d0faab426b68$var$Hj = $0af0d0faab426b68$var$B() + 500, $0af0d0faab426b68$var$jg()));
            }
            break;
        case 13:
            $0af0d0faab426b68$var$Sk(function() {
                var b = $0af0d0faab426b68$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0af0d0faab426b68$var$L();
                    $0af0d0faab426b68$var$mh(b, a, 1, c);
                }
            }), $0af0d0faab426b68$var$jl(a, 1);
    }
};
$0af0d0faab426b68$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0af0d0faab426b68$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0af0d0faab426b68$var$L();
            $0af0d0faab426b68$var$mh(b, a, 134217728, c);
        }
        $0af0d0faab426b68$var$jl(a, 134217728);
    }
};
$0af0d0faab426b68$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0af0d0faab426b68$var$lh(a), c = $0af0d0faab426b68$var$Zg(a, b);
        if (null !== c) {
            var d = $0af0d0faab426b68$var$L();
            $0af0d0faab426b68$var$mh(c, a, b, d);
        }
        $0af0d0faab426b68$var$jl(a, b);
    }
};
$0af0d0faab426b68$var$Hc = function() {
    return $0af0d0faab426b68$var$C;
};
$0af0d0faab426b68$var$Ic = function(a, b) {
    var c = $0af0d0faab426b68$var$C;
    try {
        return $0af0d0faab426b68$var$C = a, b();
    } finally{
        $0af0d0faab426b68$var$C = c;
    }
};
$0af0d0faab426b68$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0af0d0faab426b68$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0af0d0faab426b68$var$Db(d);
                        if (!e) throw Error($0af0d0faab426b68$var$p(90));
                        $0af0d0faab426b68$var$Wa(d);
                        $0af0d0faab426b68$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0af0d0faab426b68$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0af0d0faab426b68$var$fb(a, !!c.multiple, b, !1);
    }
};
$0af0d0faab426b68$var$Gb = $0af0d0faab426b68$var$Rk;
$0af0d0faab426b68$var$Hb = $0af0d0faab426b68$var$Sk;
var $0af0d0faab426b68$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0af0d0faab426b68$var$Cb,
        $0af0d0faab426b68$var$ue,
        $0af0d0faab426b68$var$Db,
        $0af0d0faab426b68$var$Eb,
        $0af0d0faab426b68$var$Fb,
        $0af0d0faab426b68$var$Rk
    ]
}, $0af0d0faab426b68$var$ul = {
    findFiberByHostInstance: $0af0d0faab426b68$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0af0d0faab426b68$var$vl = {
    bundleType: $0af0d0faab426b68$var$ul.bundleType,
    version: $0af0d0faab426b68$var$ul.version,
    rendererPackageName: $0af0d0faab426b68$var$ul.rendererPackageName,
    rendererConfig: $0af0d0faab426b68$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0af0d0faab426b68$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0af0d0faab426b68$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0af0d0faab426b68$var$ul.findFiberByHostInstance || $0af0d0faab426b68$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0af0d0faab426b68$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0af0d0faab426b68$var$wl.isDisabled && $0af0d0faab426b68$var$wl.supportsFiber) try {
        $0af0d0faab426b68$var$kc = $0af0d0faab426b68$var$wl.inject($0af0d0faab426b68$var$vl), $0af0d0faab426b68$var$lc = $0af0d0faab426b68$var$wl;
    } catch (a) {}
}
$0af0d0faab426b68$export$ae55be85d98224ed = $0af0d0faab426b68$var$tl;
$0af0d0faab426b68$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0af0d0faab426b68$var$ol(b)) throw Error($0af0d0faab426b68$var$p(200));
    return $0af0d0faab426b68$var$dl(a, b, null, c);
};
$0af0d0faab426b68$export$882461b6382ed46c = function(a, b) {
    if (!$0af0d0faab426b68$var$ol(a)) throw Error($0af0d0faab426b68$var$p(299));
    var c = !1, d = "", e = $0af0d0faab426b68$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0af0d0faab426b68$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0af0d0faab426b68$var$uf] = b.current;
    $0af0d0faab426b68$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0af0d0faab426b68$var$ml(b);
};
$0af0d0faab426b68$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0af0d0faab426b68$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0af0d0faab426b68$var$p(268, a));
    }
    a = $0af0d0faab426b68$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0af0d0faab426b68$export$cd75ccfd720a3cd4 = function(a) {
    return $0af0d0faab426b68$var$Sk(a);
};
$0af0d0faab426b68$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0af0d0faab426b68$var$pl(b)) throw Error($0af0d0faab426b68$var$p(200));
    return $0af0d0faab426b68$var$sl(null, a, b, !0, c);
};
$0af0d0faab426b68$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0af0d0faab426b68$var$ol(a)) throw Error($0af0d0faab426b68$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0af0d0faab426b68$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0af0d0faab426b68$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0af0d0faab426b68$var$uf] = b.current;
    $0af0d0faab426b68$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0af0d0faab426b68$var$nl(b);
};
$0af0d0faab426b68$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0af0d0faab426b68$var$pl(b)) throw Error($0af0d0faab426b68$var$p(200));
    return $0af0d0faab426b68$var$sl(null, a, b, !1, c);
};
$0af0d0faab426b68$export$502457920280e6be = function(a) {
    if (!$0af0d0faab426b68$var$pl(a)) throw Error($0af0d0faab426b68$var$p(40));
    return a._reactRootContainer ? ($0af0d0faab426b68$var$Sk(function() {
        $0af0d0faab426b68$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0af0d0faab426b68$var$uf] = null;
        });
    }), !0) : !1;
};
$0af0d0faab426b68$export$c78a37762a8d58e1 = $0af0d0faab426b68$var$Rk;
$0af0d0faab426b68$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0af0d0faab426b68$var$pl(c)) throw Error($0af0d0faab426b68$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0af0d0faab426b68$var$p(38));
    return $0af0d0faab426b68$var$sl(a, b, c, !1, d);
};
$0af0d0faab426b68$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("74qJ9", function(module, exports) {
"use strict";

module.exports = (parcelRequire("euVoi"));

});
parcelRegister("euVoi", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a8e062ac81949a09$export$c4744153514ff05d, (v) => $a8e062ac81949a09$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a8e062ac81949a09$export$3e506c1ccc9cc1a7, (v) => $a8e062ac81949a09$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a8e062ac81949a09$export$e26fe2ed2fa76875, (v) => $a8e062ac81949a09$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a8e062ac81949a09$export$502329bbf4b505b1, (v) => $a8e062ac81949a09$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a8e062ac81949a09$export$6e3807111c4874c4, (v) => $a8e062ac81949a09$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a8e062ac81949a09$export$c27134553091fb3a, (v) => $a8e062ac81949a09$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a8e062ac81949a09$export$33ee1acdc04fd2a2, (v) => $a8e062ac81949a09$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a8e062ac81949a09$export$b00a404bbd5edef2, (v) => $a8e062ac81949a09$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $a8e062ac81949a09$export$8352ce38b91d0c62, (v) => $a8e062ac81949a09$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a8e062ac81949a09$export$d66a1c1c77bd778b, (v) => $a8e062ac81949a09$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a8e062ac81949a09$export$d3dfb8e4810cb555, (v) => $a8e062ac81949a09$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $a8e062ac81949a09$export$839f9183b0465a69, (v) => $a8e062ac81949a09$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $a8e062ac81949a09$export$72fdf0e06517287b, (v) => $a8e062ac81949a09$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $a8e062ac81949a09$export$4b844e58a3e414b4, (v) => $a8e062ac81949a09$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a8e062ac81949a09$export$816d2913ae6b83b1, (v) => $a8e062ac81949a09$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a8e062ac81949a09$export$61bcfe829111a1d0, (v) => $a8e062ac81949a09$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a8e062ac81949a09$export$7ee8c9beb337bc3f, (v) => $a8e062ac81949a09$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a8e062ac81949a09$export$b5836b71941fa3ed, (v) => $a8e062ac81949a09$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a8e062ac81949a09$export$cf845f2c119da08a, (v) => $a8e062ac81949a09$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a8e062ac81949a09$export$c4744153514ff05d;
var $a8e062ac81949a09$export$3e506c1ccc9cc1a7;
var $a8e062ac81949a09$export$e26fe2ed2fa76875;
var $a8e062ac81949a09$export$502329bbf4b505b1;
var $a8e062ac81949a09$export$6e3807111c4874c4;
var $a8e062ac81949a09$export$c27134553091fb3a;
var $a8e062ac81949a09$export$33ee1acdc04fd2a2;
var $a8e062ac81949a09$export$b00a404bbd5edef2;
var $a8e062ac81949a09$export$8352ce38b91d0c62;
var $a8e062ac81949a09$export$d66a1c1c77bd778b;
var $a8e062ac81949a09$export$d3dfb8e4810cb555;
var $a8e062ac81949a09$export$839f9183b0465a69;
var $a8e062ac81949a09$export$72fdf0e06517287b;
var $a8e062ac81949a09$export$4b844e58a3e414b4;
var $a8e062ac81949a09$export$816d2913ae6b83b1;
var $a8e062ac81949a09$export$61bcfe829111a1d0;
var $a8e062ac81949a09$export$7ee8c9beb337bc3f;
var $a8e062ac81949a09$export$b5836b71941fa3ed;
var $a8e062ac81949a09$export$cf845f2c119da08a;
"use strict";
function $a8e062ac81949a09$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a8e062ac81949a09$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a8e062ac81949a09$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a8e062ac81949a09$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a8e062ac81949a09$var$g(C, c)) n < e && 0 > $a8e062ac81949a09$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a8e062ac81949a09$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a8e062ac81949a09$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a8e062ac81949a09$var$l = performance;
    $a8e062ac81949a09$export$c4744153514ff05d = function() {
        return $a8e062ac81949a09$var$l.now();
    };
} else {
    var $a8e062ac81949a09$var$p = Date, $a8e062ac81949a09$var$q = $a8e062ac81949a09$var$p.now();
    $a8e062ac81949a09$export$c4744153514ff05d = function() {
        return $a8e062ac81949a09$var$p.now() - $a8e062ac81949a09$var$q;
    };
}
var $a8e062ac81949a09$var$r = [], $a8e062ac81949a09$var$t = [], $a8e062ac81949a09$var$u = 1, $a8e062ac81949a09$var$v = null, $a8e062ac81949a09$var$y = 3, $a8e062ac81949a09$var$z = !1, $a8e062ac81949a09$var$A = !1, $a8e062ac81949a09$var$B = !1, $a8e062ac81949a09$var$D = "function" === typeof setTimeout ? setTimeout : null, $a8e062ac81949a09$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a8e062ac81949a09$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a8e062ac81949a09$var$G(a) {
    for(var b = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$t); null !== b;){
        if (null === b.callback) $a8e062ac81949a09$var$k($a8e062ac81949a09$var$t);
        else if (b.startTime <= a) $a8e062ac81949a09$var$k($a8e062ac81949a09$var$t), b.sortIndex = b.expirationTime, $a8e062ac81949a09$var$f($a8e062ac81949a09$var$r, b);
        else break;
        b = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$t);
    }
}
function $a8e062ac81949a09$var$H(a) {
    $a8e062ac81949a09$var$B = !1;
    $a8e062ac81949a09$var$G(a);
    if (!$a8e062ac81949a09$var$A) {
        if (null !== $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r)) $a8e062ac81949a09$var$A = !0, $a8e062ac81949a09$var$I($a8e062ac81949a09$var$J);
        else {
            var b = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$t);
            null !== b && $a8e062ac81949a09$var$K($a8e062ac81949a09$var$H, b.startTime - a);
        }
    }
}
function $a8e062ac81949a09$var$J(a, b) {
    $a8e062ac81949a09$var$A = !1;
    $a8e062ac81949a09$var$B && ($a8e062ac81949a09$var$B = !1, $a8e062ac81949a09$var$E($a8e062ac81949a09$var$L), $a8e062ac81949a09$var$L = -1);
    $a8e062ac81949a09$var$z = !0;
    var c = $a8e062ac81949a09$var$y;
    try {
        $a8e062ac81949a09$var$G(b);
        for($a8e062ac81949a09$var$v = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r); null !== $a8e062ac81949a09$var$v && (!($a8e062ac81949a09$var$v.expirationTime > b) || a && !$a8e062ac81949a09$var$M());){
            var d = $a8e062ac81949a09$var$v.callback;
            if ("function" === typeof d) {
                $a8e062ac81949a09$var$v.callback = null;
                $a8e062ac81949a09$var$y = $a8e062ac81949a09$var$v.priorityLevel;
                var e = d($a8e062ac81949a09$var$v.expirationTime <= b);
                b = $a8e062ac81949a09$export$c4744153514ff05d();
                "function" === typeof e ? $a8e062ac81949a09$var$v.callback = e : $a8e062ac81949a09$var$v === $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r) && $a8e062ac81949a09$var$k($a8e062ac81949a09$var$r);
                $a8e062ac81949a09$var$G(b);
            } else $a8e062ac81949a09$var$k($a8e062ac81949a09$var$r);
            $a8e062ac81949a09$var$v = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r);
        }
        if (null !== $a8e062ac81949a09$var$v) var w = !0;
        else {
            var m = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$t);
            null !== m && $a8e062ac81949a09$var$K($a8e062ac81949a09$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a8e062ac81949a09$var$v = null, $a8e062ac81949a09$var$y = c, $a8e062ac81949a09$var$z = !1;
    }
}
var $a8e062ac81949a09$var$N = !1, $a8e062ac81949a09$var$O = null, $a8e062ac81949a09$var$L = -1, $a8e062ac81949a09$var$P = 5, $a8e062ac81949a09$var$Q = -1;
function $a8e062ac81949a09$var$M() {
    return $a8e062ac81949a09$export$c4744153514ff05d() - $a8e062ac81949a09$var$Q < $a8e062ac81949a09$var$P ? !1 : !0;
}
function $a8e062ac81949a09$var$R() {
    if (null !== $a8e062ac81949a09$var$O) {
        var a = $a8e062ac81949a09$export$c4744153514ff05d();
        $a8e062ac81949a09$var$Q = a;
        var b = !0;
        try {
            b = $a8e062ac81949a09$var$O(!0, a);
        } finally{
            b ? $a8e062ac81949a09$var$S() : ($a8e062ac81949a09$var$N = !1, $a8e062ac81949a09$var$O = null);
        }
    } else $a8e062ac81949a09$var$N = !1;
}
var $a8e062ac81949a09$var$S;
if ("function" === typeof $a8e062ac81949a09$var$F) $a8e062ac81949a09$var$S = function() {
    $a8e062ac81949a09$var$F($a8e062ac81949a09$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a8e062ac81949a09$var$T = new MessageChannel, $a8e062ac81949a09$var$U = $a8e062ac81949a09$var$T.port2;
    $a8e062ac81949a09$var$T.port1.onmessage = $a8e062ac81949a09$var$R;
    $a8e062ac81949a09$var$S = function() {
        $a8e062ac81949a09$var$U.postMessage(null);
    };
} else $a8e062ac81949a09$var$S = function() {
    $a8e062ac81949a09$var$D($a8e062ac81949a09$var$R, 0);
};
function $a8e062ac81949a09$var$I(a) {
    $a8e062ac81949a09$var$O = a;
    $a8e062ac81949a09$var$N || ($a8e062ac81949a09$var$N = !0, $a8e062ac81949a09$var$S());
}
function $a8e062ac81949a09$var$K(a, b) {
    $a8e062ac81949a09$var$L = $a8e062ac81949a09$var$D(function() {
        a($a8e062ac81949a09$export$c4744153514ff05d());
    }, b);
}
$a8e062ac81949a09$export$3e506c1ccc9cc1a7 = 5;
$a8e062ac81949a09$export$e26fe2ed2fa76875 = 1;
$a8e062ac81949a09$export$502329bbf4b505b1 = 4;
$a8e062ac81949a09$export$6e3807111c4874c4 = 3;
$a8e062ac81949a09$export$c27134553091fb3a = null;
$a8e062ac81949a09$export$33ee1acdc04fd2a2 = 2;
$a8e062ac81949a09$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a8e062ac81949a09$export$8352ce38b91d0c62 = function() {
    $a8e062ac81949a09$var$A || $a8e062ac81949a09$var$z || ($a8e062ac81949a09$var$A = !0, $a8e062ac81949a09$var$I($a8e062ac81949a09$var$J));
};
$a8e062ac81949a09$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a8e062ac81949a09$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a8e062ac81949a09$export$d3dfb8e4810cb555 = function() {
    return $a8e062ac81949a09$var$y;
};
$a8e062ac81949a09$export$839f9183b0465a69 = function() {
    return $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r);
};
$a8e062ac81949a09$export$72fdf0e06517287b = function(a) {
    switch($a8e062ac81949a09$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a8e062ac81949a09$var$y;
    }
    var c = $a8e062ac81949a09$var$y;
    $a8e062ac81949a09$var$y = b;
    try {
        return a();
    } finally{
        $a8e062ac81949a09$var$y = c;
    }
};
$a8e062ac81949a09$export$4b844e58a3e414b4 = function() {};
$a8e062ac81949a09$export$816d2913ae6b83b1 = function() {};
$a8e062ac81949a09$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a8e062ac81949a09$var$y;
    $a8e062ac81949a09$var$y = a;
    try {
        return b();
    } finally{
        $a8e062ac81949a09$var$y = c;
    }
};
$a8e062ac81949a09$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a8e062ac81949a09$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a8e062ac81949a09$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a8e062ac81949a09$var$f($a8e062ac81949a09$var$t, a), null === $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r) && a === $a8e062ac81949a09$var$h($a8e062ac81949a09$var$t) && ($a8e062ac81949a09$var$B ? ($a8e062ac81949a09$var$E($a8e062ac81949a09$var$L), $a8e062ac81949a09$var$L = -1) : $a8e062ac81949a09$var$B = !0, $a8e062ac81949a09$var$K($a8e062ac81949a09$var$H, c - d))) : (a.sortIndex = e, $a8e062ac81949a09$var$f($a8e062ac81949a09$var$r, a), $a8e062ac81949a09$var$A || $a8e062ac81949a09$var$z || ($a8e062ac81949a09$var$A = !0, $a8e062ac81949a09$var$I($a8e062ac81949a09$var$J)));
    return a;
};
$a8e062ac81949a09$export$b5836b71941fa3ed = $a8e062ac81949a09$var$M;
$a8e062ac81949a09$export$cf845f2c119da08a = function(a) {
    var b = $a8e062ac81949a09$var$y;
    return function() {
        var c = $a8e062ac81949a09$var$y;
        $a8e062ac81949a09$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a8e062ac81949a09$var$y = c;
        }
    };
};

});



parcelRegister("fIsAN", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", () => $b71124f85d4fc180$export$1f3f55432a00e06d);
$parcel$export(module.exports, "RouterProvider", () => $b71124f85d4fc180$export$323e4fc2fa4753fb);
$parcel$export(module.exports, "Link", () => $b71124f85d4fc180$export$a6c7ac8248d6e38a);
/**
 * React Router DOM v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8T3gX = parcelRequire("8T3gX");

var $8VQWA = parcelRequire("8VQWA");

var $bnQ5y = parcelRequire("bnQ5y");
var $3T949 = parcelRequire("3T949");

var $bnQ5y = parcelRequire("bnQ5y");
function $b71124f85d4fc180$var$_extends() {
    $b71124f85d4fc180$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b71124f85d4fc180$var$_extends.apply(this, arguments);
}
function $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b71124f85d4fc180$var$defaultMethod = "get";
const $b71124f85d4fc180$var$defaultEncType = "application/x-www-form-urlencoded";
function $b71124f85d4fc180$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b71124f85d4fc180$var$isButtonElement(object) {
    return $b71124f85d4fc180$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b71124f85d4fc180$var$isFormElement(object) {
    return $b71124f85d4fc180$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b71124f85d4fc180$var$isInputElement(object) {
    return $b71124f85d4fc180$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b71124f85d4fc180$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b71124f85d4fc180$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b71124f85d4fc180$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $b71124f85d4fc180$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b71124f85d4fc180$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b71124f85d4fc180$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $b71124f85d4fc180$var$_formDataSupportsSubmitter = null;
function $b71124f85d4fc180$var$isFormDataSubmitterSupported() {
    if ($b71124f85d4fc180$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $b71124f85d4fc180$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $b71124f85d4fc180$var$_formDataSupportsSubmitter = true;
    }
    return $b71124f85d4fc180$var$_formDataSupportsSubmitter;
}
const $b71124f85d4fc180$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $b71124f85d4fc180$var$getFormEncType(encType) {
    if (encType != null && !$b71124f85d4fc180$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $b71124f85d4fc180$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($b71124f85d4fc180$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $bnQ5y.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $b71124f85d4fc180$var$defaultMethod;
        encType = $b71124f85d4fc180$var$getFormEncType(target.getAttribute("enctype")) || $b71124f85d4fc180$var$defaultEncType;
        formData = new FormData(target);
    } else if ($b71124f85d4fc180$var$isButtonElement(target) || $b71124f85d4fc180$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $bnQ5y.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $b71124f85d4fc180$var$defaultMethod;
        encType = $b71124f85d4fc180$var$getFormEncType(target.getAttribute("formenctype")) || $b71124f85d4fc180$var$getFormEncType(form.getAttribute("enctype")) || $b71124f85d4fc180$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$b71124f85d4fc180$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($b71124f85d4fc180$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $b71124f85d4fc180$var$defaultMethod;
        action = null;
        encType = $b71124f85d4fc180$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $b71124f85d4fc180$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $b71124f85d4fc180$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $b71124f85d4fc180$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $b71124f85d4fc180$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $b71124f85d4fc180$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $b71124f85d4fc180$export$1f3f55432a00e06d(routes, opts) {
    return (0, $bnQ5y.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b71124f85d4fc180$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bnQ5y.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b71124f85d4fc180$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3T949.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b71124f85d4fc180$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $bnQ5y.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b71124f85d4fc180$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bnQ5y.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b71124f85d4fc180$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3T949.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b71124f85d4fc180$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $b71124f85d4fc180$var$_extends({}, state, {
        errors: $b71124f85d4fc180$var$deserializeErrors(state.errors)
    });
    return state;
}
function $b71124f85d4fc180$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $bnQ5y.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $b71124f85d4fc180$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8T3gX.createContext({
    isTransitioning: false
});
const $b71124f85d4fc180$export$148fd98d095596d4 = /*#__PURE__*/ $8T3gX.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b71124f85d4fc180$var$START_TRANSITION = "startTransition";
const $b71124f85d4fc180$var$startTransitionImpl = $8T3gX[$b71124f85d4fc180$var$START_TRANSITION];
const $b71124f85d4fc180$var$FLUSH_SYNC = "flushSync";
const $b71124f85d4fc180$var$flushSyncImpl = $8VQWA[$b71124f85d4fc180$var$FLUSH_SYNC];
const $b71124f85d4fc180$var$USE_ID = "useId";
const $b71124f85d4fc180$var$useIdImpl = $8T3gX[$b71124f85d4fc180$var$USE_ID];
function $b71124f85d4fc180$var$startTransitionSafe(cb) {
    if ($b71124f85d4fc180$var$startTransitionImpl) $b71124f85d4fc180$var$startTransitionImpl(cb);
    else cb();
}
function $b71124f85d4fc180$var$flushSyncSafe(cb) {
    if ($b71124f85d4fc180$var$flushSyncImpl) $b71124f85d4fc180$var$flushSyncImpl(cb);
    else cb();
}
class $b71124f85d4fc180$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b71124f85d4fc180$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8T3gX.useState(router.state);
    let [pendingState, setPendingState] = $8T3gX.useState();
    let [vtContext, setVtContext] = $8T3gX.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8T3gX.useState();
    let [transition, setTransition] = $8T3gX.useState();
    let [interruption, setInterruption] = $8T3gX.useState();
    let fetcherData = $8T3gX.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8T3gX.useCallback((cb)=>{
        if (v7_startTransition) $b71124f85d4fc180$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8T3gX.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $b71124f85d4fc180$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $b71124f85d4fc180$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $b71124f85d4fc180$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $b71124f85d4fc180$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $b71124f85d4fc180$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8T3gX.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8T3gX.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $b71124f85d4fc180$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8T3gX.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8T3gX.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8T3gX.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8T3gX.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8T3gX.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8T3gX.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement((0, $3T949.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8T3gX.createElement((0, $3T949.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $b71124f85d4fc180$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $3T949.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $b71124f85d4fc180$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8T3gX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bnQ5y.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && $b71124f85d4fc180$var$startTransitionImpl ? $b71124f85d4fc180$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $b71124f85d4fc180$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8T3gX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bnQ5y.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && $b71124f85d4fc180$var$startTransitionImpl ? $b71124f85d4fc180$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $b71124f85d4fc180$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && $b71124f85d4fc180$var$startTransitionImpl ? $b71124f85d4fc180$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $b71124f85d4fc180$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $b71124f85d4fc180$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $b71124f85d4fc180$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8T3gX.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(_ref7, $b71124f85d4fc180$var$_excluded);
    let { basename: basename } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $b71124f85d4fc180$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($b71124f85d4fc180$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $bnQ5y.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $3T949.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $b71124f85d4fc180$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8T3gX.createElement("a", $b71124f85d4fc180$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $b71124f85d4fc180$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8T3gX.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(_ref8, $b71124f85d4fc180$var$_excluded2);
    let path = (0, $3T949.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $3T949.useLocation)();
    let routerState = $8T3gX.useContext((0, $3T949.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $b71124f85d4fc180$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $bnQ5y.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$export$a6c7ac8248d6e38a, $b71124f85d4fc180$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $b71124f85d4fc180$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8T3gX.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $b71124f85d4fc180$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(_ref9, $b71124f85d4fc180$var$_excluded3);
    let submit = $b71124f85d4fc180$export$47c85c6e3a081d3();
    let formAction = $b71124f85d4fc180$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $8T3gX.createElement("form", $b71124f85d4fc180$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $b71124f85d4fc180$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $b71124f85d4fc180$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $b71124f85d4fc180$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($b71124f85d4fc180$var$DataRouterHook || ($b71124f85d4fc180$var$DataRouterHook = {}));
var $b71124f85d4fc180$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($b71124f85d4fc180$var$DataRouterStateHook || ($b71124f85d4fc180$var$DataRouterStateHook = {}));
// Internal hooks
function $b71124f85d4fc180$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b71124f85d4fc180$var$useDataRouterContext(hookName) {
    let ctx = $8T3gX.useContext((0, $3T949.UNSAFE_DataRouterContext));
    !ctx && (0, $bnQ5y.UNSAFE_invariant)(false);
    return ctx;
}
function $b71124f85d4fc180$var$useDataRouterState(hookName) {
    let state = $8T3gX.useContext((0, $3T949.UNSAFE_DataRouterStateContext));
    !state && (0, $bnQ5y.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $b71124f85d4fc180$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $3T949.useNavigate)();
    let location = (0, $3T949.useLocation)();
    let path = (0, $3T949.useResolvedPath)(to, {
        relative: relative
    });
    return $8T3gX.useCallback((event)=>{
        if ($b71124f85d4fc180$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $bnQ5y.createPath)(location) === (0, $bnQ5y.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $b71124f85d4fc180$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8T3gX.useRef($b71124f85d4fc180$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8T3gX.useRef(false);
    let location = (0, $3T949.useLocation)();
    let searchParams = $8T3gX.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b71124f85d4fc180$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $3T949.useNavigate)();
    let setSearchParams = $8T3gX.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b71124f85d4fc180$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $b71124f85d4fc180$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $b71124f85d4fc180$var$fetcherId = 0;
let $b71124f85d4fc180$var$getUniqueFetcherId = ()=>"__" + String(++$b71124f85d4fc180$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $b71124f85d4fc180$export$47c85c6e3a081d3() {
    let { router: router } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let currentRouteId = (0, $3T949.UNSAFE_useRouteId)();
    return $8T3gX.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $b71124f85d4fc180$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $b71124f85d4fc180$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $b71124f85d4fc180$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $b71124f85d4fc180$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let routeContext = $8T3gX.useContext((0, $3T949.UNSAFE_RouteContext));
    !routeContext && (0, $bnQ5y.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $b71124f85d4fc180$var$_extends({}, (0, $3T949.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $3T949.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bnQ5y.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $bnQ5y.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $b71124f85d4fc180$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.UseFetcher);
    let state = $b71124f85d4fc180$var$useDataRouterState($b71124f85d4fc180$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8T3gX.useContext($b71124f85d4fc180$export$148fd98d095596d4);
    let route = $8T3gX.useContext((0, $3T949.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $bnQ5y.UNSAFE_invariant)(false);
    !route && (0, $bnQ5y.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $bnQ5y.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $b71124f85d4fc180$var$useIdImpl ? $b71124f85d4fc180$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8T3gX.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($b71124f85d4fc180$var$getUniqueFetcherId());
    // Registration/cleanup
    $8T3gX.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8T3gX.useCallback((href, opts)=>{
        !routeId && (0, $bnQ5y.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $b71124f85d4fc180$export$47c85c6e3a081d3();
    let submit = $8T3gX.useCallback((target, opts)=>{
        submitImpl(target, $b71124f85d4fc180$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8T3gX.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8T3gX.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$export$a7fed597f4b8afd8, $b71124f85d4fc180$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $bnQ5y.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8T3gX.useMemo(()=>$b71124f85d4fc180$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $b71124f85d4fc180$export$fa996778a3a31087() {
    let state = $b71124f85d4fc180$var$useDataRouterState($b71124f85d4fc180$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $b71124f85d4fc180$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $b71124f85d4fc180$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $b71124f85d4fc180$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $b71124f85d4fc180$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $b71124f85d4fc180$var$useDataRouterState($b71124f85d4fc180$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let location = (0, $3T949.useLocation)();
    let matches = (0, $3T949.useMatches)();
    let navigation = (0, $3T949.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $8T3gX.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $b71124f85d4fc180$var$usePageHide($8T3gX.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $b71124f85d4fc180$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $b71124f85d4fc180$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b71124f85d4fc180$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8T3gX.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b71124f85d4fc180$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b71124f85d4fc180$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8T3gX.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($b71124f85d4fc180$var$_extends({}, location, {
                    pathname: (0, $bnQ5y.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($b71124f85d4fc180$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8T3gX.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b71124f85d4fc180$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8T3gX.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b71124f85d4fc180$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8T3gX.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $b71124f85d4fc180$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $3T949.useBlocker)(when);
    $8T3gX.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8T3gX.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $b71124f85d4fc180$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8T3gX.useContext($b71124f85d4fc180$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $bnQ5y.UNSAFE_invariant)(false);
    let { basename: basename } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.useViewTransitionState);
    let path = (0, $3T949.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $bnQ5y.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $bnQ5y.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $bnQ5y.matchPath)(path.pathname, nextPath) != null || (0, $bnQ5y.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("8VQWA", function(module, exports) {
"use strict";
function $680cb73086b60533$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($680cb73086b60533$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$680cb73086b60533$var$checkDCE();

module.exports = (parcelRequire("WeH8M"));

});

parcelRegister("bnQ5y", function(module, exports) {

$parcel$export(module.exports, "Action", () => $849a3f667a98fd57$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $849a3f667a98fd57$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $849a3f667a98fd57$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $849a3f667a98fd57$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $849a3f667a98fd57$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $849a3f667a98fd57$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $849a3f667a98fd57$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $849a3f667a98fd57$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $849a3f667a98fd57$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $849a3f667a98fd57$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $849a3f667a98fd57$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $849a3f667a98fd57$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $849a3f667a98fd57$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $849a3f667a98fd57$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $849a3f667a98fd57$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $849a3f667a98fd57$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $849a3f667a98fd57$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $849a3f667a98fd57$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $849a3f667a98fd57$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $849a3f667a98fd57$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.15.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $849a3f667a98fd57$var$_extends() {
    $849a3f667a98fd57$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $849a3f667a98fd57$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $849a3f667a98fd57$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($849a3f667a98fd57$export$e19cd5f9376f8cee || ($849a3f667a98fd57$export$e19cd5f9376f8cee = {}));
const $849a3f667a98fd57$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $849a3f667a98fd57$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $849a3f667a98fd57$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $849a3f667a98fd57$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $849a3f667a98fd57$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $849a3f667a98fd57$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to);
    }
    return $849a3f667a98fd57$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $849a3f667a98fd57$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $849a3f667a98fd57$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $849a3f667a98fd57$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $849a3f667a98fd57$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $849a3f667a98fd57$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $849a3f667a98fd57$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $849a3f667a98fd57$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $849a3f667a98fd57$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $849a3f667a98fd57$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $849a3f667a98fd57$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $849a3f667a98fd57$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $849a3f667a98fd57$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $849a3f667a98fd57$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $849a3f667a98fd57$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $849a3f667a98fd57$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($849a3f667a98fd57$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
        let location = $849a3f667a98fd57$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $849a3f667a98fd57$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
        let location = $849a3f667a98fd57$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $849a3f667a98fd57$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $849a3f667a98fd57$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($849a3f667a98fd57$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($849a3f667a98fd57$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $849a3f667a98fd57$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($849a3f667a98fd57$var$ResultType || ($849a3f667a98fd57$var$ResultType = {}));
const $849a3f667a98fd57$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $849a3f667a98fd57$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $849a3f667a98fd57$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $849a3f667a98fd57$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $849a3f667a98fd57$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($849a3f667a98fd57$var$isIndexRoute(route)) {
            let indexRoute = $849a3f667a98fd57$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $849a3f667a98fd57$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $849a3f667a98fd57$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $849a3f667a98fd57$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $849a3f667a98fd57$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $849a3f667a98fd57$var$flattenRoutes(routes);
    $849a3f667a98fd57$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $849a3f667a98fd57$var$decodePath(pathname);
        matches = $849a3f667a98fd57$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $849a3f667a98fd57$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $849a3f667a98fd57$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $849a3f667a98fd57$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $849a3f667a98fd57$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $849a3f667a98fd57$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $849a3f667a98fd57$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $849a3f667a98fd57$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $849a3f667a98fd57$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $849a3f667a98fd57$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $849a3f667a98fd57$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $849a3f667a98fd57$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $849a3f667a98fd57$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $849a3f667a98fd57$var$paramRe = /^:[\w-]+$/;
const $849a3f667a98fd57$var$dynamicSegmentValue = 3;
const $849a3f667a98fd57$var$indexRouteValue = 2;
const $849a3f667a98fd57$var$emptySegmentValue = 1;
const $849a3f667a98fd57$var$staticSegmentValue = 10;
const $849a3f667a98fd57$var$splatPenalty = -2;
const $849a3f667a98fd57$var$isSplat = (s)=>s === "*";
function $849a3f667a98fd57$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($849a3f667a98fd57$var$isSplat)) initialScore += $849a3f667a98fd57$var$splatPenalty;
    if (index) initialScore += $849a3f667a98fd57$var$indexRouteValue;
    return segments.filter((s)=>!$849a3f667a98fd57$var$isSplat(s)).reduce((score, segment)=>score + ($849a3f667a98fd57$var$paramRe.test(segment) ? $849a3f667a98fd57$var$dynamicSegmentValue : segment === "" ? $849a3f667a98fd57$var$emptySegmentValue : $849a3f667a98fd57$var$staticSegmentValue), initialScore);
}
function $849a3f667a98fd57$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $849a3f667a98fd57$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $849a3f667a98fd57$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $849a3f667a98fd57$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $849a3f667a98fd57$export$a5c6d149b50c1d86($849a3f667a98fd57$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $849a3f667a98fd57$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $849a3f667a98fd57$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $849a3f667a98fd57$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $849a3f667a98fd57$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $849a3f667a98fd57$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $849a3f667a98fd57$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $849a3f667a98fd57$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $849a3f667a98fd57$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $849a3f667a98fd57$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $849a3f667a98fd57$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $849a3f667a98fd57$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $849a3f667a98fd57$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $849a3f667a98fd57$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $849a3f667a98fd57$var$normalizeSearch(search),
        hash: $849a3f667a98fd57$var$normalizeHash(hash)
    };
}
function $849a3f667a98fd57$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $849a3f667a98fd57$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $849a3f667a98fd57$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $849a3f667a98fd57$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $849a3f667a98fd57$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $849a3f667a98fd57$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $849a3f667a98fd57$export$8ccf933b0513f8d0(toArg);
    else {
        to = $849a3f667a98fd57$var$_extends({}, toArg);
        $849a3f667a98fd57$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $849a3f667a98fd57$var$getInvalidPathError("?", "pathname", "search", to));
        $849a3f667a98fd57$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $849a3f667a98fd57$var$getInvalidPathError("#", "pathname", "hash", to));
        $849a3f667a98fd57$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $849a3f667a98fd57$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $849a3f667a98fd57$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $849a3f667a98fd57$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $849a3f667a98fd57$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $849a3f667a98fd57$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $849a3f667a98fd57$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $849a3f667a98fd57$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $849a3f667a98fd57$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $849a3f667a98fd57$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $849a3f667a98fd57$export$42a99a7a4bc0e76a extends Error {
}
class $849a3f667a98fd57$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $849a3f667a98fd57$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $849a3f667a98fd57$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $849a3f667a98fd57$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $849a3f667a98fd57$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $849a3f667a98fd57$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $849a3f667a98fd57$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $849a3f667a98fd57$var$unwrapTrackedPromise(value) {
    if (!$849a3f667a98fd57$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $849a3f667a98fd57$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $849a3f667a98fd57$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $849a3f667a98fd57$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $849a3f667a98fd57$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $849a3f667a98fd57$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $849a3f667a98fd57$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $849a3f667a98fd57$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $849a3f667a98fd57$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $849a3f667a98fd57$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $849a3f667a98fd57$var$validMutationMethods = new Set($849a3f667a98fd57$var$validMutationMethodsArr);
const $849a3f667a98fd57$var$validRequestMethodsArr = [
    "get",
    ...$849a3f667a98fd57$var$validMutationMethodsArr
];
const $849a3f667a98fd57$var$validRequestMethods = new Set($849a3f667a98fd57$var$validRequestMethodsArr);
const $849a3f667a98fd57$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $849a3f667a98fd57$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $849a3f667a98fd57$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $849a3f667a98fd57$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $849a3f667a98fd57$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $849a3f667a98fd57$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $849a3f667a98fd57$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $849a3f667a98fd57$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $849a3f667a98fd57$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $849a3f667a98fd57$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $849a3f667a98fd57$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $849a3f667a98fd57$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $849a3f667a98fd57$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $849a3f667a98fd57$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $849a3f667a98fd57$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $849a3f667a98fd57$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $849a3f667a98fd57$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $849a3f667a98fd57$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $849a3f667a98fd57$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $849a3f667a98fd57$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$849a3f667a98fd57$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($849a3f667a98fd57$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $849a3f667a98fd57$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $849a3f667a98fd57$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $849a3f667a98fd57$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $849a3f667a98fd57$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $849a3f667a98fd57$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($849a3f667a98fd57$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $849a3f667a98fd57$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $849a3f667a98fd57$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $849a3f667a98fd57$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $849a3f667a98fd57$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $849a3f667a98fd57$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $849a3f667a98fd57$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $849a3f667a98fd57$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $849a3f667a98fd57$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $849a3f667a98fd57$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $849a3f667a98fd57$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $849a3f667a98fd57$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$849a3f667a98fd57$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $849a3f667a98fd57$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $849a3f667a98fd57$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $849a3f667a98fd57$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $849a3f667a98fd57$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $849a3f667a98fd57$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $849a3f667a98fd57$var$ResultType.error,
            error: $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $849a3f667a98fd57$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($849a3f667a98fd57$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($849a3f667a98fd57$var$isDeferredResult(result)) throw $849a3f667a98fd57$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $849a3f667a98fd57$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $849a3f667a98fd57$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $849a3f667a98fd57$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $849a3f667a98fd57$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $849a3f667a98fd57$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($849a3f667a98fd57$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $849a3f667a98fd57$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $849a3f667a98fd57$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $849a3f667a98fd57$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $849a3f667a98fd57$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $849a3f667a98fd57$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $849a3f667a98fd57$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $849a3f667a98fd57$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $849a3f667a98fd57$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $849a3f667a98fd57$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $849a3f667a98fd57$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($849a3f667a98fd57$var$isRedirectResult(actionResult) || $849a3f667a98fd57$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $849a3f667a98fd57$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($849a3f667a98fd57$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $849a3f667a98fd57$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $849a3f667a98fd57$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($849a3f667a98fd57$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($849a3f667a98fd57$var$isDeferredResult(actionResult)) throw $849a3f667a98fd57$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $849a3f667a98fd57$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $849a3f667a98fd57$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $849a3f667a98fd57$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $849a3f667a98fd57$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $849a3f667a98fd57$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $849a3f667a98fd57$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $849a3f667a98fd57$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $849a3f667a98fd57$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $849a3f667a98fd57$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $849a3f667a98fd57$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $849a3f667a98fd57$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $849a3f667a98fd57$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $849a3f667a98fd57$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($849a3f667a98fd57$var$isDeferredResult(result)) result = await $849a3f667a98fd57$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $849a3f667a98fd57$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($849a3f667a98fd57$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $849a3f667a98fd57$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $849a3f667a98fd57$export$3e9cee6b33872309(!$849a3f667a98fd57$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $849a3f667a98fd57$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $849a3f667a98fd57$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $849a3f667a98fd57$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($849a3f667a98fd57$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $849a3f667a98fd57$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace : $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $849a3f667a98fd57$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($849a3f667a98fd57$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $849a3f667a98fd57$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $849a3f667a98fd57$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $849a3f667a98fd57$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$849a3f667a98fd57$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $849a3f667a98fd57$var$callLoaderOrAction("loader", $849a3f667a98fd57$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $849a3f667a98fd57$var$ResultType.error,
                        error: $849a3f667a98fd57$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $849a3f667a98fd57$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $849a3f667a98fd57$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $849a3f667a98fd57$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $849a3f667a98fd57$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $849a3f667a98fd57$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $849a3f667a98fd57$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $849a3f667a98fd57$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $849a3f667a98fd57$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $849a3f667a98fd57$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $849a3f667a98fd57$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $849a3f667a98fd57$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $849a3f667a98fd57$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$849a3f667a98fd57$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $849a3f667a98fd57$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $849a3f667a98fd57$export$4d0306f8f6a4585b = Symbol("deferred");
function $849a3f667a98fd57$export$3336b097a6fbc59a(routes, opts) {
    $849a3f667a98fd57$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $849a3f667a98fd57$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $849a3f667a98fd57$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $849a3f667a98fd57$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $849a3f667a98fd57$var$createLocation("", $849a3f667a98fd57$export$fe53371bee54353d(url), null, "default");
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$849a3f667a98fd57$var$isValidMethod(method) && method !== "HEAD") {
            let error = $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $849a3f667a98fd57$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $849a3f667a98fd57$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($849a3f667a98fd57$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $849a3f667a98fd57$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $849a3f667a98fd57$var$createLocation("", $849a3f667a98fd57$export$fe53371bee54353d(url), null, "default");
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$849a3f667a98fd57$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $849a3f667a98fd57$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $849a3f667a98fd57$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $849a3f667a98fd57$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $849a3f667a98fd57$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $849a3f667a98fd57$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($849a3f667a98fd57$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$849a3f667a98fd57$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $849a3f667a98fd57$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($849a3f667a98fd57$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $849a3f667a98fd57$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $849a3f667a98fd57$var$isResponse(result) ? result : $849a3f667a98fd57$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($849a3f667a98fd57$var$isQueryRouteResponse(e)) {
                if (e.type === $849a3f667a98fd57$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($849a3f667a98fd57$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $849a3f667a98fd57$var$ResultType.error,
                error: error
            };
        } else {
            result = await $849a3f667a98fd57$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $849a3f667a98fd57$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($849a3f667a98fd57$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($849a3f667a98fd57$var$isDeferredResult(result)) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $849a3f667a98fd57$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($849a3f667a98fd57$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $849a3f667a98fd57$var$_extends({}, context, {
                statusCode: $849a3f667a98fd57$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $849a3f667a98fd57$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $849a3f667a98fd57$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $849a3f667a98fd57$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $849a3f667a98fd57$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $849a3f667a98fd57$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$849a3f667a98fd57$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $849a3f667a98fd57$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $849a3f667a98fd57$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $849a3f667a98fd57$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $849a3f667a98fd57$export$fec11da027c70692(routes, context, error) {
    let newContext = $849a3f667a98fd57$var$_extends({}, context, {
        statusCode: $849a3f667a98fd57$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $849a3f667a98fd57$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $849a3f667a98fd57$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $849a3f667a98fd57$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $849a3f667a98fd57$export$cae722b0cc860f13(to ? to : ".", $849a3f667a98fd57$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $849a3f667a98fd57$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$849a3f667a98fd57$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $849a3f667a98fd57$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $849a3f667a98fd57$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $849a3f667a98fd57$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$849a3f667a98fd57$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$849a3f667a98fd57$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $849a3f667a98fd57$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $849a3f667a98fd57$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $849a3f667a98fd57$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$849a3f667a98fd57$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$849a3f667a98fd57$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $849a3f667a98fd57$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $849a3f667a98fd57$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $849a3f667a98fd57$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $849a3f667a98fd57$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $849a3f667a98fd57$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($849a3f667a98fd57$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $849a3f667a98fd57$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $849a3f667a98fd57$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $849a3f667a98fd57$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $849a3f667a98fd57$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $849a3f667a98fd57$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $849a3f667a98fd57$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($849a3f667a98fd57$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $849a3f667a98fd57$var$shouldRevalidateLoader(match, $849a3f667a98fd57$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $849a3f667a98fd57$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $849a3f667a98fd57$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $849a3f667a98fd57$var$shouldRevalidateLoader(fetcherMatch, $849a3f667a98fd57$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $849a3f667a98fd57$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $849a3f667a98fd57$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $849a3f667a98fd57$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $849a3f667a98fd57$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $849a3f667a98fd57$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $849a3f667a98fd57$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$849a3f667a98fd57$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $849a3f667a98fd57$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $849a3f667a98fd57$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $849a3f667a98fd57$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $849a3f667a98fd57$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $849a3f667a98fd57$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $849a3f667a98fd57$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $849a3f667a98fd57$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $849a3f667a98fd57$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($849a3f667a98fd57$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($849a3f667a98fd57$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $849a3f667a98fd57$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$849a3f667a98fd57$var$ABSOLUTE_URL_REGEX.test(location)) location = $849a3f667a98fd57$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $849a3f667a98fd57$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $849a3f667a98fd57$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $849a3f667a98fd57$var$ResultType.error ? $849a3f667a98fd57$var$ResultType.error : $849a3f667a98fd57$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $849a3f667a98fd57$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $849a3f667a98fd57$var$ResultType.error) return {
            type: resultType,
            error: new $849a3f667a98fd57$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $849a3f667a98fd57$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $849a3f667a98fd57$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($849a3f667a98fd57$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $849a3f667a98fd57$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $849a3f667a98fd57$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $849a3f667a98fd57$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($849a3f667a98fd57$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $849a3f667a98fd57$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $849a3f667a98fd57$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $849a3f667a98fd57$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $849a3f667a98fd57$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $849a3f667a98fd57$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $849a3f667a98fd57$export$3e9cee6b33872309(!$849a3f667a98fd57$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $849a3f667a98fd57$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($849a3f667a98fd57$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $849a3f667a98fd57$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $849a3f667a98fd57$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $849a3f667a98fd57$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($849a3f667a98fd57$var$isErrorResult(result)) {
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $849a3f667a98fd57$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($849a3f667a98fd57$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $849a3f667a98fd57$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($849a3f667a98fd57$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $849a3f667a98fd57$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $849a3f667a98fd57$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $849a3f667a98fd57$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $849a3f667a98fd57$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $849a3f667a98fd57$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $849a3f667a98fd57$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $849a3f667a98fd57$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $849a3f667a98fd57$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $849a3f667a98fd57$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($849a3f667a98fd57$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $849a3f667a98fd57$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(path) : path;
    return $849a3f667a98fd57$export$fe53371bee54353d($849a3f667a98fd57$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $849a3f667a98fd57$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $849a3f667a98fd57$var$isDeferredResult(result) {
    return result.type === $849a3f667a98fd57$var$ResultType.deferred;
}
function $849a3f667a98fd57$var$isErrorResult(result) {
    return result.type === $849a3f667a98fd57$var$ResultType.error;
}
function $849a3f667a98fd57$var$isRedirectResult(result) {
    return (result && result.type) === $849a3f667a98fd57$var$ResultType.redirect;
}
function $849a3f667a98fd57$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $849a3f667a98fd57$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $849a3f667a98fd57$var$isRedirectResponse(result) {
    if (!$849a3f667a98fd57$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $849a3f667a98fd57$var$isQueryRouteResponse(obj) {
    return obj && $849a3f667a98fd57$var$isResponse(obj.response) && (obj.type === $849a3f667a98fd57$var$ResultType.data || obj.type === $849a3f667a98fd57$var$ResultType.error);
}
function $849a3f667a98fd57$var$isValidMethod(method) {
    return $849a3f667a98fd57$var$validRequestMethods.has(method.toLowerCase());
}
function $849a3f667a98fd57$var$isMutationMethod(method) {
    return $849a3f667a98fd57$var$validMutationMethods.has(method.toLowerCase());
}
async function $849a3f667a98fd57$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$849a3f667a98fd57$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($849a3f667a98fd57$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $849a3f667a98fd57$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $849a3f667a98fd57$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $849a3f667a98fd57$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $849a3f667a98fd57$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $849a3f667a98fd57$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $849a3f667a98fd57$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $849a3f667a98fd57$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $849a3f667a98fd57$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $849a3f667a98fd57$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $849a3f667a98fd57$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $849a3f667a98fd57$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $849a3f667a98fd57$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $849a3f667a98fd57$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $849a3f667a98fd57$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $849a3f667a98fd57$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $849a3f667a98fd57$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $849a3f667a98fd57$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($849a3f667a98fd57$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $849a3f667a98fd57$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($849a3f667a98fd57$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $849a3f667a98fd57$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("3T949", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $2d4d8a77428439fe$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $2d4d8a77428439fe$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $2d4d8a77428439fe$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $2d4d8a77428439fe$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $2d4d8a77428439fe$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $2d4d8a77428439fe$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $2d4d8a77428439fe$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $2d4d8a77428439fe$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $2d4d8a77428439fe$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $2d4d8a77428439fe$export$5fcee62552a12fbf);
$parcel$export(module.exports, "useRouteError", () => $2d4d8a77428439fe$export$ed527bf60f6e05f2);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $2d4d8a77428439fe$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $2d4d8a77428439fe$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $2d4d8a77428439fe$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $2d4d8a77428439fe$export$b273b3273281a049);
$parcel$export(module.exports, "Router", () => $2d4d8a77428439fe$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Outlet", () => $2d4d8a77428439fe$export$910ae8079b2c2852);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $2d4d8a77428439fe$export$52b333d321859367);
/**
 * React Router v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8T3gX = parcelRequire("8T3gX");

var $bnQ5y = parcelRequire("bnQ5y");
function $2d4d8a77428439fe$var$_extends() {
    $2d4d8a77428439fe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2d4d8a77428439fe$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $2d4d8a77428439fe$export$3add0d5dce533e2e = /*#__PURE__*/ $8T3gX.createContext(null);
const $2d4d8a77428439fe$export$145dfa71566a64dc = /*#__PURE__*/ $8T3gX.createContext(null);
const $2d4d8a77428439fe$var$AwaitContext = /*#__PURE__*/ $8T3gX.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $2d4d8a77428439fe$export$26749e8557646306 = /*#__PURE__*/ $8T3gX.createContext(null);
const $2d4d8a77428439fe$export$c7914228fb69b0f5 = /*#__PURE__*/ $8T3gX.createContext(null);
const $2d4d8a77428439fe$export$9072aa6dd1f93057 = /*#__PURE__*/ $8T3gX.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $2d4d8a77428439fe$var$RouteErrorContext = /*#__PURE__*/ $8T3gX.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $2d4d8a77428439fe$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $2d4d8a77428439fe$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $bnQ5y.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $2d4d8a77428439fe$export$9c954a9d03d32f4a() {
    return $8T3gX.useContext($2d4d8a77428439fe$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $2d4d8a77428439fe$export$45d76561a5302f2b() {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    return $8T3gX.useContext($2d4d8a77428439fe$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $2d4d8a77428439fe$export$1b3f31771c5d07c() {
    return $8T3gX.useContext($2d4d8a77428439fe$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $2d4d8a77428439fe$export$6c330e8992e8a295(pattern) {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    let { pathname: pathname } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    return $8T3gX.useMemo(()=>(0, $bnQ5y.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $2d4d8a77428439fe$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $2d4d8a77428439fe$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $2d4d8a77428439fe$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $2d4d8a77428439fe$var$useNavigateStable() : $2d4d8a77428439fe$var$useNavigateUnstable();
}
function $2d4d8a77428439fe$var$useNavigateUnstable() {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    let dataRouterContext = $8T3gX.useContext($2d4d8a77428439fe$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { matches: matches } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bnQ5y.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $8T3gX.useRef(false);
    $2d4d8a77428439fe$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8T3gX.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $bnQ5y.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bnQ5y.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $2d4d8a77428439fe$var$OutletContext = /*#__PURE__*/ $8T3gX.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $2d4d8a77428439fe$export$4138103a3ae699cc() {
    return $8T3gX.useContext($2d4d8a77428439fe$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $2d4d8a77428439fe$export$a3be3530d8e40d0b(context) {
    let outlet = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $2d4d8a77428439fe$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $2d4d8a77428439fe$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { matches: matches } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bnQ5y.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $8T3gX.useMemo(()=>(0, $bnQ5y.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $2d4d8a77428439fe$export$5d3fca4a98652595(routes, locationArg) {
    return $2d4d8a77428439fe$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $2d4d8a77428439fe$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    let { navigator: navigator } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { matches: parentMatches } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $bnQ5y.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $bnQ5y.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $bnQ5y.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $2d4d8a77428439fe$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $bnQ5y.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $bnQ5y.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2d4d8a77428439fe$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $bnQ5y.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2d4d8a77428439fe$var$DefaultErrorComponent() {
    let error = $2d4d8a77428439fe$export$ed527bf60f6e05f2();
    let message = (0, $bnQ5y.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8T3gX.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8T3gX.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $2d4d8a77428439fe$var$defaultErrorElement = /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$DefaultErrorComponent, null);
class $2d4d8a77428439fe$var$RenderErrorBoundary extends $8T3gX.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $2d4d8a77428439fe$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8T3gX.useContext($2d4d8a77428439fe$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2d4d8a77428439fe$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $bnQ5y.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $2d4d8a77428439fe$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $2d4d8a77428439fe$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8T3gX.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $2d4d8a77428439fe$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($2d4d8a77428439fe$var$DataRouterHook || {});
var $2d4d8a77428439fe$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($2d4d8a77428439fe$var$DataRouterStateHook || {});
function $2d4d8a77428439fe$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2d4d8a77428439fe$var$useDataRouterContext(hookName) {
    let ctx = $8T3gX.useContext($2d4d8a77428439fe$export$3add0d5dce533e2e);
    !ctx && (0, $bnQ5y.UNSAFE_invariant)(false);
    return ctx;
}
function $2d4d8a77428439fe$var$useDataRouterState(hookName) {
    let state = $8T3gX.useContext($2d4d8a77428439fe$export$145dfa71566a64dc);
    !state && (0, $bnQ5y.UNSAFE_invariant)(false);
    return state;
}
function $2d4d8a77428439fe$var$useRouteContext(hookName) {
    let route = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    !route && (0, $bnQ5y.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $2d4d8a77428439fe$var$useCurrentRouteId(hookName) {
    let route = $2d4d8a77428439fe$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $bnQ5y.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $2d4d8a77428439fe$export$5fc8298006ad9e58() {
    return $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2d4d8a77428439fe$export$d0fd4b7106de2769() {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2d4d8a77428439fe$export$600dc272ed516c15() {
    let dataRouterContext = $2d4d8a77428439fe$var$useDataRouterContext($2d4d8a77428439fe$var$DataRouterHook.UseRevalidator);
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseRevalidator);
    return $8T3gX.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2d4d8a77428439fe$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseMatches);
    return $8T3gX.useMemo(()=>matches.map((m)=>(0, $bnQ5y.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2d4d8a77428439fe$export$1448a5050d252c4d() {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2d4d8a77428439fe$export$fd5d37484eab868d(routeId) {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2d4d8a77428439fe$export$fdc00f3f26066d5e() {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseActionData);
    let routeId = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2d4d8a77428439fe$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8T3gX.useContext($2d4d8a77428439fe$var$RouteErrorContext);
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteError);
    let routeId = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $2d4d8a77428439fe$export$78a72ddb39bdd145() {
    let value = $8T3gX.useContext($2d4d8a77428439fe$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $2d4d8a77428439fe$export$17f53340677d5831() {
    let value = $8T3gX.useContext($2d4d8a77428439fe$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2d4d8a77428439fe$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2d4d8a77428439fe$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $2d4d8a77428439fe$var$useDataRouterContext($2d4d8a77428439fe$var$DataRouterHook.UseBlocker);
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8T3gX.useState("");
    let blockerFunction = $8T3gX.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $2d4d8a77428439fe$var$_extends({}, currentLocation, {
                pathname: (0, $bnQ5y.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $2d4d8a77428439fe$var$_extends({}, nextLocation, {
                pathname: (0, $bnQ5y.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8T3gX.useEffect(()=>{
        let key = String(++$2d4d8a77428439fe$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8T3gX.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $bnQ5y.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $2d4d8a77428439fe$var$useNavigateStable() {
    let { router: router } = $2d4d8a77428439fe$var$useDataRouterContext($2d4d8a77428439fe$var$DataRouterHook.UseNavigateStable);
    let id = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8T3gX.useRef(false);
    $2d4d8a77428439fe$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8T3gX.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $2d4d8a77428439fe$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $2d4d8a77428439fe$var$alreadyWarned = {};
function $2d4d8a77428439fe$var$warningOnce(key, cond, message) {
    if (!cond && !$2d4d8a77428439fe$var$alreadyWarned[key]) $2d4d8a77428439fe$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2d4d8a77428439fe$var$START_TRANSITION = "startTransition";
const $2d4d8a77428439fe$var$startTransitionImpl = $8T3gX[$2d4d8a77428439fe$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2d4d8a77428439fe$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8T3gX.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        if (v7_startTransition && $2d4d8a77428439fe$var$startTransitionImpl) $2d4d8a77428439fe$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8T3gX.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8T3gX.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8T3gX.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8T3gX.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $2d4d8a77428439fe$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $2d4d8a77428439fe$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $2d4d8a77428439fe$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8T3gX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bnQ5y.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && $2d4d8a77428439fe$var$startTransitionImpl ? $2d4d8a77428439fe$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $2d4d8a77428439fe$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { matches: matches } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let navigate = $2d4d8a77428439fe$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $bnQ5y.resolveTo)(to, (0, $bnQ5y.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8T3gX.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $2d4d8a77428439fe$export$910ae8079b2c2852(props) {
    return $2d4d8a77428439fe$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $2d4d8a77428439fe$export$e7b0ac011bb776c6(_props) {
    (0, $bnQ5y.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $2d4d8a77428439fe$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $bnQ5y.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8T3gX.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $2d4d8a77428439fe$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $bnQ5y.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8T3gX.useMemo(()=>{
        let trailingPathname = (0, $bnQ5y.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $2d4d8a77428439fe$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $2d4d8a77428439fe$export$5d3fca4a98652595($2d4d8a77428439fe$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2d4d8a77428439fe$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$ResolveAwait, null, children));
}
var $2d4d8a77428439fe$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($2d4d8a77428439fe$var$AwaitRenderStatus || {});
const $2d4d8a77428439fe$var$neverSettledPromise = new Promise(()=>{});
class $2d4d8a77428439fe$var$AwaitErrorBoundary extends $8T3gX.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $2d4d8a77428439fe$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2d4d8a77428439fe$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2d4d8a77428439fe$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $2d4d8a77428439fe$var$AwaitRenderStatus.error : promise._data !== undefined ? $2d4d8a77428439fe$var$AwaitRenderStatus.success : $2d4d8a77428439fe$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2d4d8a77428439fe$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.error && promise._error instanceof (0, $bnQ5y.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $2d4d8a77428439fe$var$neverSettledPromise;
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $2d4d8a77428439fe$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $2d4d8a77428439fe$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $2d4d8a77428439fe$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8T3gX.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8T3gX.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8T3gX.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2d4d8a77428439fe$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2d4d8a77428439fe$export$e7b0ac011bb776c6) && (0, $bnQ5y.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $bnQ5y.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2d4d8a77428439fe$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2d4d8a77428439fe$export$daf73786167a7f72(matches) {
    return $2d4d8a77428439fe$var$_renderMatches(matches);
}
function $2d4d8a77428439fe$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8T3gX.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8T3gX.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8T3gX.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $2d4d8a77428439fe$export$f30f7e456d254e83(routes, opts) {
    return (0, $bnQ5y.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2d4d8a77428439fe$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bnQ5y.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $2d4d8a77428439fe$export$52b333d321859367
    }).initialize();
}

});


parcelRegister("eNEVg", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $ac6562abe1ffd23e$export$bf730a2d8bf68b42, (v) => $ac6562abe1ffd23e$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ac6562abe1ffd23e$export$bf730a2d8bf68b42;
"use strict";

var $8T3gX = parcelRequire("8T3gX");
function $ac6562abe1ffd23e$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ac6562abe1ffd23e$var$p = "function" === typeof Object.is ? Object.is : $ac6562abe1ffd23e$var$n, $ac6562abe1ffd23e$var$q = $8T3gX.useSyncExternalStore, $ac6562abe1ffd23e$var$r = $8T3gX.useRef, $ac6562abe1ffd23e$var$t = $8T3gX.useEffect, $ac6562abe1ffd23e$var$u = $8T3gX.useMemo, $ac6562abe1ffd23e$var$v = $8T3gX.useDebugValue;
$ac6562abe1ffd23e$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $ac6562abe1ffd23e$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $ac6562abe1ffd23e$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($ac6562abe1ffd23e$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $ac6562abe1ffd23e$var$q(a, c[0], c[1]);
    $ac6562abe1ffd23e$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $ac6562abe1ffd23e$var$v(d);
    return d;
};

});

parcelRegister("j2AMO", function(module, exports) {

var $lEXWo = parcelRequire("lEXWo");
module.exports = $lEXWo("aFCLs").then(()=>parcelRequire("k5VX5"));

});
parcelRegister("lEXWo", function(module, exports) {
"use strict";

function $fc4bd461e49b4732$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("bCIFA")).resolve(id));
}
module.exports = $fc4bd461e49b4732$var$load;

});



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
var $11011d7422997104$exports = {};

$parcel$export($11011d7422997104$exports, "createRoot", () => $11011d7422997104$export$882461b6382ed46c, (v) => $11011d7422997104$export$882461b6382ed46c = v);
$parcel$export($11011d7422997104$exports, "hydrateRoot", () => $11011d7422997104$export$757ceba2d55c277e, (v) => $11011d7422997104$export$757ceba2d55c277e = v);
var $11011d7422997104$export$882461b6382ed46c;
var $11011d7422997104$export$757ceba2d55c277e;
"use strict";

var $8VQWA = parcelRequire("8VQWA");
var $11011d7422997104$var$i;
$11011d7422997104$export$882461b6382ed46c = $8VQWA.createRoot;
$11011d7422997104$export$757ceba2d55c277e = $8VQWA.hydrateRoot;



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $fIsAN = parcelRequire("fIsAN");
var $9da83de6e889f30e$exports = {};
$9da83de6e889f30e$exports = new URL("zito.3a43dc15.png", import.meta.url).toString();



var $8T3gX = parcelRequire("8T3gX");
var $cd7465c5e6c69d8a$exports = {};
"use strict";

$cd7465c5e6c69d8a$exports = (parcelRequire("eNEVg"));


var $3563a485d86a3589$var$__defProp = Object.defineProperty;
var $3563a485d86a3589$var$__defProps = Object.defineProperties;
var $3563a485d86a3589$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $3563a485d86a3589$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3563a485d86a3589$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3563a485d86a3589$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3563a485d86a3589$var$__defNormalProp = (obj, key, value)=>key in obj ? $3563a485d86a3589$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3563a485d86a3589$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3563a485d86a3589$var$__hasOwnProp.call(b, prop)) $3563a485d86a3589$var$__defNormalProp(a, prop, b[prop]);
    if ($3563a485d86a3589$var$__getOwnPropSymbols) {
        for (var prop of $3563a485d86a3589$var$__getOwnPropSymbols(b))if ($3563a485d86a3589$var$__propIsEnum.call(b, prop)) $3563a485d86a3589$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3563a485d86a3589$var$__spreadProps = (a, b)=>$3563a485d86a3589$var$__defProps(a, $3563a485d86a3589$var$__getOwnPropDescs(b));
var $3563a485d86a3589$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3563a485d86a3589$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3563a485d86a3589$var$__getOwnPropSymbols) {
        for (var prop of $3563a485d86a3589$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3563a485d86a3589$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $3563a485d86a3589$var$React = // prettier-ignore
// @ts-ignore
"default" in $8T3gX ? $8T3gX["default"] : $8T3gX;
// src/components/Context.ts
var $3563a485d86a3589$var$ContextKey = Symbol.for(`react-redux-context`);
var $3563a485d86a3589$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $3563a485d86a3589$var$getContext() {
    var _a;
    if (!$3563a485d86a3589$var$React.createContext) return {};
    const contextMap = (_a = $3563a485d86a3589$var$gT[$3563a485d86a3589$var$ContextKey]) != null ? _a : $3563a485d86a3589$var$gT[$3563a485d86a3589$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($3563a485d86a3589$var$React.createContext);
    if (!realContext) {
        realContext = $3563a485d86a3589$var$React.createContext(null);
        contextMap.set($3563a485d86a3589$var$React.createContext, realContext);
    }
    return realContext;
}
var $3563a485d86a3589$export$cc80c08dc91f1c00 = /* @__PURE__ */ $3563a485d86a3589$var$getContext();
// src/utils/useSyncExternalStore.ts
var $3563a485d86a3589$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $3563a485d86a3589$var$createReduxContextHook(context = $3563a485d86a3589$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $3563a485d86a3589$var$React.useContext(context);
        return contextValue;
    };
}
var $3563a485d86a3589$var$useReduxContext = /* @__PURE__ */ $3563a485d86a3589$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $3563a485d86a3589$var$useSyncExternalStoreWithSelector = $3563a485d86a3589$var$notInitialized;
var $3563a485d86a3589$var$initializeUseSelector = (fn)=>{
    $3563a485d86a3589$var$useSyncExternalStoreWithSelector = fn;
};
var $3563a485d86a3589$var$refEquality = (a, b)=>a === b;
function $3563a485d86a3589$export$2b53f90d2bd1cbfb(context = $3563a485d86a3589$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $3563a485d86a3589$export$cc80c08dc91f1c00 ? $3563a485d86a3589$var$useReduxContext : $3563a485d86a3589$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $3563a485d86a3589$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $3563a485d86a3589$var$React.useRef(true);
        const wrappedSelector = $3563a485d86a3589$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $3563a485d86a3589$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $3563a485d86a3589$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $3563a485d86a3589$export$2105062e25df4afe = /* @__PURE__ */ $3563a485d86a3589$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $3563a485d86a3589$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $3563a485d86a3589$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $3563a485d86a3589$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $3563a485d86a3589$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $3563a485d86a3589$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $3563a485d86a3589$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $3563a485d86a3589$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $3563a485d86a3589$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $3563a485d86a3589$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $3563a485d86a3589$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $3563a485d86a3589$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $3563a485d86a3589$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $3563a485d86a3589$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $3563a485d86a3589$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $3563a485d86a3589$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $3563a485d86a3589$var$ForwardRef = $3563a485d86a3589$var$REACT_FORWARD_REF_TYPE;
var $3563a485d86a3589$var$Memo = $3563a485d86a3589$var$REACT_MEMO_TYPE;
function $3563a485d86a3589$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $3563a485d86a3589$var$REACT_FRAGMENT_TYPE || type === $3563a485d86a3589$var$REACT_PROFILER_TYPE || type === $3563a485d86a3589$var$REACT_STRICT_MODE_TYPE || type === $3563a485d86a3589$var$REACT_SUSPENSE_TYPE || type === $3563a485d86a3589$var$REACT_SUSPENSE_LIST_TYPE || type === $3563a485d86a3589$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $3563a485d86a3589$var$REACT_LAZY_TYPE || type.$$typeof === $3563a485d86a3589$var$REACT_MEMO_TYPE || type.$$typeof === $3563a485d86a3589$var$REACT_PROVIDER_TYPE || type.$$typeof === $3563a485d86a3589$var$REACT_CONTEXT_TYPE || type.$$typeof === $3563a485d86a3589$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $3563a485d86a3589$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $3563a485d86a3589$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $3563a485d86a3589$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $3563a485d86a3589$var$REACT_FRAGMENT_TYPE:
                        case $3563a485d86a3589$var$REACT_PROFILER_TYPE:
                        case $3563a485d86a3589$var$REACT_STRICT_MODE_TYPE:
                        case $3563a485d86a3589$var$REACT_SUSPENSE_TYPE:
                        case $3563a485d86a3589$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $3563a485d86a3589$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $3563a485d86a3589$var$REACT_CONTEXT_TYPE:
                                    case $3563a485d86a3589$var$REACT_FORWARD_REF_TYPE:
                                    case $3563a485d86a3589$var$REACT_LAZY_TYPE:
                                    case $3563a485d86a3589$var$REACT_MEMO_TYPE:
                                    case $3563a485d86a3589$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $3563a485d86a3589$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $3563a485d86a3589$var$isContextConsumer(object) {
    return $3563a485d86a3589$var$typeOf(object) === $3563a485d86a3589$var$REACT_CONTEXT_TYPE;
}
function $3563a485d86a3589$var$isMemo(object) {
    return $3563a485d86a3589$var$typeOf(object) === $3563a485d86a3589$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $3563a485d86a3589$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $3563a485d86a3589$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $3563a485d86a3589$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $3563a485d86a3589$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $3563a485d86a3589$var$verify(mapStateToProps, "mapStateToProps");
    $3563a485d86a3589$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $3563a485d86a3589$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $3563a485d86a3589$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $3563a485d86a3589$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $3563a485d86a3589$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $3563a485d86a3589$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $3563a485d86a3589$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $3563a485d86a3589$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $3563a485d86a3589$var$verifyPlainObject(value, displayName, methodName) {
    if (!$3563a485d86a3589$var$isPlainObject(value)) $3563a485d86a3589$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $3563a485d86a3589$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $3563a485d86a3589$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $3563a485d86a3589$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $3563a485d86a3589$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $3563a485d86a3589$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $3563a485d86a3589$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $3563a485d86a3589$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $3563a485d86a3589$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $3563a485d86a3589$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $3563a485d86a3589$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $3563a485d86a3589$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $3563a485d86a3589$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $3563a485d86a3589$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $3563a485d86a3589$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $3563a485d86a3589$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $3563a485d86a3589$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $3563a485d86a3589$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $3563a485d86a3589$var$__spreadValues($3563a485d86a3589$var$__spreadValues($3563a485d86a3589$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $3563a485d86a3589$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $3563a485d86a3589$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$3563a485d86a3589$var$defaultMergeProps : typeof mergeProps === "function" ? $3563a485d86a3589$var$wrapMergePropsFunc(mergeProps) : $3563a485d86a3589$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $3563a485d86a3589$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $3563a485d86a3589$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $3563a485d86a3589$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $3563a485d86a3589$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $3563a485d86a3589$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $3563a485d86a3589$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $3563a485d86a3589$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $3563a485d86a3589$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $3563a485d86a3589$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $3563a485d86a3589$var$useIsomorphicLayoutEffect = $3563a485d86a3589$var$canUseDOM ? $3563a485d86a3589$var$React.useLayoutEffect : $3563a485d86a3589$var$React.useEffect;
// src/utils/shallowEqual.ts
function $3563a485d86a3589$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $3563a485d86a3589$export$d36bdfa510afb180(objA, objB) {
    if ($3563a485d86a3589$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$3563a485d86a3589$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $3563a485d86a3589$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3563a485d86a3589$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3563a485d86a3589$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3563a485d86a3589$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3563a485d86a3589$var$TYPE_STATICS = {
    [$3563a485d86a3589$var$ForwardRef]: $3563a485d86a3589$var$FORWARD_REF_STATICS,
    [$3563a485d86a3589$var$Memo]: $3563a485d86a3589$var$MEMO_STATICS
};
function $3563a485d86a3589$var$getStatics(component) {
    if ($3563a485d86a3589$var$isMemo(component)) return $3563a485d86a3589$var$MEMO_STATICS;
    return $3563a485d86a3589$var$TYPE_STATICS[component["$$typeof"]] || $3563a485d86a3589$var$REACT_STATICS;
}
var $3563a485d86a3589$var$defineProperty = Object.defineProperty;
var $3563a485d86a3589$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3563a485d86a3589$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3563a485d86a3589$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3563a485d86a3589$var$getPrototypeOf = Object.getPrototypeOf;
var $3563a485d86a3589$var$objectPrototype = Object.prototype;
function $3563a485d86a3589$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($3563a485d86a3589$var$objectPrototype) {
            const inheritedComponent = $3563a485d86a3589$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3563a485d86a3589$var$objectPrototype) $3563a485d86a3589$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $3563a485d86a3589$var$getOwnPropertyNames(sourceComponent);
        if ($3563a485d86a3589$var$getOwnPropertySymbols) keys = keys.concat($3563a485d86a3589$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $3563a485d86a3589$var$getStatics(targetComponent);
        const sourceStatics = $3563a485d86a3589$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$3563a485d86a3589$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $3563a485d86a3589$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $3563a485d86a3589$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $3563a485d86a3589$var$useSyncExternalStore = $3563a485d86a3589$var$notInitialized;
var $3563a485d86a3589$var$initializeConnect = (fn)=>{
    $3563a485d86a3589$var$useSyncExternalStore = fn;
};
var $3563a485d86a3589$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $3563a485d86a3589$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $3563a485d86a3589$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $3563a485d86a3589$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $3563a485d86a3589$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $3563a485d86a3589$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $3563a485d86a3589$var$strictEqual(a, b) {
    return a === b;
}
var $3563a485d86a3589$var$hasWarnedAboutDeprecatedPureOption = false;
function $3563a485d86a3589$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $3563a485d86a3589$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $3563a485d86a3589$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $3563a485d86a3589$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $3563a485d86a3589$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $3563a485d86a3589$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $3563a485d86a3589$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $3563a485d86a3589$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $3563a485d86a3589$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $3563a485d86a3589$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $3563a485d86a3589$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $3563a485d86a3589$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $3563a485d86a3589$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $3563a485d86a3589$var$React.useMemo(()=>{
                return $3563a485d86a3589$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $3563a485d86a3589$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $3563a485d86a3589$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $3563a485d86a3589$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $3563a485d86a3589$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $3563a485d86a3589$var$__spreadProps($3563a485d86a3589$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $3563a485d86a3589$var$React.useRef();
            const lastWrapperProps = $3563a485d86a3589$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $3563a485d86a3589$var$React.useRef();
            const renderIsScheduled = $3563a485d86a3589$var$React.useRef(false);
            const isProcessingDispatch = $3563a485d86a3589$var$React.useRef(false);
            const isMounted = $3563a485d86a3589$var$React.useRef(false);
            const latestSubscriptionCallbackError = $3563a485d86a3589$var$React.useRef();
            $3563a485d86a3589$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $3563a485d86a3589$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $3563a485d86a3589$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $3563a485d86a3589$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $3563a485d86a3589$var$useIsomorphicLayoutEffectWithArgs($3563a485d86a3589$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $3563a485d86a3589$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $3563a485d86a3589$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $3563a485d86a3589$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $3563a485d86a3589$var$React.createElement(WrappedComponent, $3563a485d86a3589$var$__spreadProps($3563a485d86a3589$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $3563a485d86a3589$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $3563a485d86a3589$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $3563a485d86a3589$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $3563a485d86a3589$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $3563a485d86a3589$var$React.createElement(Connect, $3563a485d86a3589$var$__spreadProps($3563a485d86a3589$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $3563a485d86a3589$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $3563a485d86a3589$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $3563a485d86a3589$export$64605811ab45167f = $3563a485d86a3589$var$connect;
// src/components/Provider.tsx
function $3563a485d86a3589$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $3563a485d86a3589$var$React.useMemo(()=>{
        const subscription = $3563a485d86a3589$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $3563a485d86a3589$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $3563a485d86a3589$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $3563a485d86a3589$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $3563a485d86a3589$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $3563a485d86a3589$export$2881499e37b75b9a = $3563a485d86a3589$var$Provider;
// src/hooks/useStore.ts
function $3563a485d86a3589$export$671dba69185d0304(context = $3563a485d86a3589$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $3563a485d86a3589$export$cc80c08dc91f1c00 ? $3563a485d86a3589$var$useReduxContext : // @ts-ignore
    $3563a485d86a3589$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $3563a485d86a3589$export$6ccbb43953eebf8 = /* @__PURE__ */ $3563a485d86a3589$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $3563a485d86a3589$export$bc9b55530897c558(context = $3563a485d86a3589$export$cc80c08dc91f1c00) {
    const useStore2 = context === $3563a485d86a3589$export$cc80c08dc91f1c00 ? $3563a485d86a3589$export$6ccbb43953eebf8 : $3563a485d86a3589$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $3563a485d86a3589$export$8ad76b76a4c905f8 = /* @__PURE__ */ $3563a485d86a3589$export$bc9b55530897c558();
// src/exports.ts
var $3563a485d86a3589$export$712ea50be43a7858 = $3563a485d86a3589$var$defaultNoopBatch;
// src/index.ts
$3563a485d86a3589$var$initializeUseSelector((0, $cd7465c5e6c69d8a$exports.useSyncExternalStoreWithSelector));
$3563a485d86a3589$var$initializeConnect($8T3gX.useSyncExternalStore);


// common functions and logics

var $8T3gX = parcelRequire("8T3gX");
function $b17d528c9be7da99$export$d6ad891437e8c72c(searchText, allRestaurants) {
    const filterData = allRestaurants.filter((restaurant)=>restaurant?.info?.name?.toLowerCase().includes(searchText.toLowerCase()));
    return filterData;
}
const $b17d528c9be7da99$export$f80b45ea636617be = (ratingValue, allRestaurants)=>{
    const filterData = allRestaurants.filter((restaurant)=>{
        return restaurant.info.avgRating >= ratingValue;
    });
    return filterData;
};
const $b17d528c9be7da99$export$99e986d5326d56a4 = (veg, allRestaurants)=>{
    const filterData = allRestaurants.filter((restaurant)=>{
        if (restaurant.info && restaurant.info.veg !== undefined) return restaurant.info.veg === veg;
    });
    return filterData;
};
const $b17d528c9be7da99$export$2808572feca4ba17 = (distance, allRestaurants)=>{
    const filterData = allRestaurants.filter((restaurant)=>{
        return restaurant?.info?.sla?.lastMileTravel <= distance;
    });
    return filterData;
};
const $b17d528c9be7da99$export$9fa19c6d9bcb8ec8 = (price, allRestaurants)=>{
    const filterData = allRestaurants.filter((restaurant)=>{
        // Extract numerical value from the "costForTwo" string
        const costForTwo = parseInt(restaurant?.info?.costForTwo.replace(/[^\d]/g, "")); // Remove non-digit characters (like '₹') and convert to integer
        return costForTwo < price;
    });
    return filterData;
};
const $b17d528c9be7da99$export$fc09282584efe12c = (minPrice, maxPrice, allRestaurants)=>{
    const filterData = allRestaurants.filter((restaurant)=>{
        const costForTwo = parseInt(restaurant?.info?.costForTwo.replace(/[^\d]/g, "")); // Extract numerical value and convert to integer
        // Check if costForTwo is within the specified range
        return costForTwo >= minPrice && costForTwo <= maxPrice;
    });
    return filterData;
};
const $b17d528c9be7da99$export$8bf4ce924aca1720 = ()=>{
    // normal function which updates state variable isLoggedIn
    const [isLoggedIn, setIsLoggedIn] = (0, $8T3gX.useState)(false);
    const logout = ()=>{
        setIsLoggedIn(false);
    };
    const login = ()=>{
        setIsLoggedIn(true);
    };
    return [
        isLoggedIn,
        login,
        logout
    ];
};
const $b17d528c9be7da99$export$789fa4c5300b11dd = (str)=>{
    const match = str.match(/^[^\[\(]+/);
    return match ? match[0].trim() : str.trim();
};


var $1bdf55611f740138$exports = {};
$1bdf55611f740138$exports = new URL("user_logo.4c99c296.png", import.meta.url).toString();



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

// store slice creation
// src/index.ts
// src/utils/formatProdErrorMessage.ts
function $866c1eaece9c0f08$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $866c1eaece9c0f08$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $866c1eaece9c0f08$var$symbol_observable_default = $866c1eaece9c0f08$var$$$observable;
// src/utils/actionTypes.ts
var $866c1eaece9c0f08$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $866c1eaece9c0f08$var$ActionTypes = {
    INIT: `@@redux/INIT${$866c1eaece9c0f08$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$866c1eaece9c0f08$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$866c1eaece9c0f08$var$randomString()}`
};
var $866c1eaece9c0f08$export$4219e499db7ca678 = $866c1eaece9c0f08$var$ActionTypes;
// src/utils/isPlainObject.ts
function $866c1eaece9c0f08$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $866c1eaece9c0f08$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($866c1eaece9c0f08$var$isDate(val)) return "date";
    if ($866c1eaece9c0f08$var$isError(val)) return "error";
    const constructorName = $866c1eaece9c0f08$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $866c1eaece9c0f08$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $866c1eaece9c0f08$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $866c1eaece9c0f08$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $866c1eaece9c0f08$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $866c1eaece9c0f08$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(1));
        return enhancer($866c1eaece9c0f08$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$866c1eaece9c0f08$export$53b83ca8eaab0383(action)) throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $866c1eaece9c0f08$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$866c1eaece9c0f08$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $866c1eaece9c0f08$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$866c1eaece9c0f08$var$symbol_observable_default]: observable
    };
    return store;
}
function $866c1eaece9c0f08$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $866c1eaece9c0f08$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $866c1eaece9c0f08$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $866c1eaece9c0f08$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $866c1eaece9c0f08$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$866c1eaece9c0f08$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$866c1eaece9c0f08$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $866c1eaece9c0f08$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $866c1eaece9c0f08$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $866c1eaece9c0f08$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $866c1eaece9c0f08$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(13));
    });
}
function $866c1eaece9c0f08$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $866c1eaece9c0f08$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $866c1eaece9c0f08$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $866c1eaece9c0f08$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $866c1eaece9c0f08$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $866c1eaece9c0f08$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $866c1eaece9c0f08$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $866c1eaece9c0f08$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($866c1eaece9c0f08$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $866c1eaece9c0f08$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $866c1eaece9c0f08$export$b956e38827fca970(action) {
    return $866c1eaece9c0f08$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $23cd39f08819a30f$var$__defProp = Object.defineProperty;
var $23cd39f08819a30f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $23cd39f08819a30f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $23cd39f08819a30f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $23cd39f08819a30f$var$__defNormalProp = (obj, key, value)=>key in obj ? $23cd39f08819a30f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $23cd39f08819a30f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($23cd39f08819a30f$var$__hasOwnProp.call(b, prop)) $23cd39f08819a30f$var$__defNormalProp(a, prop, b[prop]);
    if ($23cd39f08819a30f$var$__getOwnPropSymbols) {
        for (var prop of $23cd39f08819a30f$var$__getOwnPropSymbols(b))if ($23cd39f08819a30f$var$__propIsEnum.call(b, prop)) $23cd39f08819a30f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $23cd39f08819a30f$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $23cd39f08819a30f$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $23cd39f08819a30f$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $23cd39f08819a30f$var$errors = [];
function $23cd39f08819a30f$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $23cd39f08819a30f$var$getPrototypeOf = Object.getPrototypeOf;
function $23cd39f08819a30f$export$541ac630993a4c84(value) {
    return !!value && !!value[$23cd39f08819a30f$var$DRAFT_STATE];
}
function $23cd39f08819a30f$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $23cd39f08819a30f$var$isPlainObject(value) || Array.isArray(value) || !!value[$23cd39f08819a30f$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$23cd39f08819a30f$export$6ee2082928bcb0ee]) || $23cd39f08819a30f$var$isMap(value) || $23cd39f08819a30f$var$isSet(value);
}
var $23cd39f08819a30f$var$objectCtorString = Object.prototype.constructor.toString();
function $23cd39f08819a30f$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $23cd39f08819a30f$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $23cd39f08819a30f$var$objectCtorString;
}
function $23cd39f08819a30f$export$22e8af3f75a010e3(value) {
    if (!$23cd39f08819a30f$export$541ac630993a4c84(value)) $23cd39f08819a30f$var$die(15, value);
    return value[$23cd39f08819a30f$var$DRAFT_STATE].base_;
}
function $23cd39f08819a30f$var$each(obj, iter) {
    if ($23cd39f08819a30f$var$getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(([key, value])=>{
        iter(key, value, obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $23cd39f08819a30f$var$getArchtype(thing) {
    const state = thing[$23cd39f08819a30f$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $23cd39f08819a30f$var$isMap(thing) ? 2 /* Map */  : $23cd39f08819a30f$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $23cd39f08819a30f$var$has(thing, prop) {
    return $23cd39f08819a30f$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $23cd39f08819a30f$var$get(thing, prop) {
    return $23cd39f08819a30f$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $23cd39f08819a30f$var$set(thing, propOrOldValue, value) {
    const t = $23cd39f08819a30f$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $23cd39f08819a30f$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $23cd39f08819a30f$var$isMap(target) {
    return target instanceof Map;
}
function $23cd39f08819a30f$var$isSet(target) {
    return target instanceof Set;
}
function $23cd39f08819a30f$var$latest(state) {
    return state.copy_ || state.base_;
}
function $23cd39f08819a30f$var$shallowCopy(base, strict) {
    if ($23cd39f08819a30f$var$isMap(base)) return new Map(base);
    if ($23cd39f08819a30f$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && $23cd39f08819a30f$var$isPlainObject(base)) {
        if (!$23cd39f08819a30f$var$getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return $23cd39f08819a30f$var$__spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[$23cd39f08819a30f$var$DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create($23cd39f08819a30f$var$getPrototypeOf(base), descriptors);
}
function $23cd39f08819a30f$export$792f3d81ea979f55(obj, deep = false) {
    if ($23cd39f08819a30f$var$isFrozen(obj) || $23cd39f08819a30f$export$541ac630993a4c84(obj) || !$23cd39f08819a30f$export$16e3aed3edb85946(obj)) return obj;
    if ($23cd39f08819a30f$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $23cd39f08819a30f$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) $23cd39f08819a30f$var$each(obj, (_key, value)=>$23cd39f08819a30f$export$792f3d81ea979f55(value, true), true);
    return obj;
}
function $23cd39f08819a30f$var$dontMutateFrozenCollections() {
    $23cd39f08819a30f$var$die(2);
}
function $23cd39f08819a30f$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $23cd39f08819a30f$var$plugins = {};
function $23cd39f08819a30f$var$getPlugin(pluginKey) {
    const plugin = $23cd39f08819a30f$var$plugins[pluginKey];
    if (!plugin) $23cd39f08819a30f$var$die(0, pluginKey);
    return plugin;
}
function $23cd39f08819a30f$var$loadPlugin(pluginKey, implementation) {
    if (!$23cd39f08819a30f$var$plugins[pluginKey]) $23cd39f08819a30f$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $23cd39f08819a30f$var$currentScope;
function $23cd39f08819a30f$var$getCurrentScope() {
    return $23cd39f08819a30f$var$currentScope;
}
function $23cd39f08819a30f$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $23cd39f08819a30f$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $23cd39f08819a30f$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $23cd39f08819a30f$var$revokeScope(scope) {
    $23cd39f08819a30f$var$leaveScope(scope);
    scope.drafts_.forEach($23cd39f08819a30f$var$revokeDraft);
    scope.drafts_ = null;
}
function $23cd39f08819a30f$var$leaveScope(scope) {
    if (scope === $23cd39f08819a30f$var$currentScope) $23cd39f08819a30f$var$currentScope = scope.parent_;
}
function $23cd39f08819a30f$var$enterScope(immer2) {
    return $23cd39f08819a30f$var$currentScope = $23cd39f08819a30f$var$createScope($23cd39f08819a30f$var$currentScope, immer2);
}
function $23cd39f08819a30f$var$revokeDraft(draft) {
    const state = draft[$23cd39f08819a30f$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $23cd39f08819a30f$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$23cd39f08819a30f$var$DRAFT_STATE].modified_) {
            $23cd39f08819a30f$var$revokeScope(scope);
            $23cd39f08819a30f$var$die(4);
        }
        if ($23cd39f08819a30f$export$16e3aed3edb85946(result)) {
            result = $23cd39f08819a30f$var$finalize(scope, result);
            if (!scope.parent_) $23cd39f08819a30f$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $23cd39f08819a30f$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$23cd39f08819a30f$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $23cd39f08819a30f$var$finalize(scope, baseDraft, []);
    $23cd39f08819a30f$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $23cd39f08819a30f$export$45b790e32b2810ee ? result : void 0;
}
function $23cd39f08819a30f$var$finalize(rootScope, value, path) {
    if ($23cd39f08819a30f$var$isFrozen(value)) return value;
    const state = value[$23cd39f08819a30f$var$DRAFT_STATE];
    if (!state) {
        $23cd39f08819a30f$var$each(value, (key, childValue)=>$23cd39f08819a30f$var$finalizeProperty(rootScope, state, value, key, childValue, path), true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $23cd39f08819a30f$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $23cd39f08819a30f$var$each(resultEach, (key, childValue)=>$23cd39f08819a30f$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $23cd39f08819a30f$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $23cd39f08819a30f$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $23cd39f08819a30f$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($23cd39f08819a30f$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$23cd39f08819a30f$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $23cd39f08819a30f$var$finalize(rootScope, childValue, path);
        $23cd39f08819a30f$var$set(targetObject, prop, res);
        if ($23cd39f08819a30f$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($23cd39f08819a30f$export$16e3aed3edb85946(childValue) && !$23cd39f08819a30f$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $23cd39f08819a30f$var$finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) $23cd39f08819a30f$var$maybeFreeze(rootScope, childValue);
    }
}
function $23cd39f08819a30f$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $23cd39f08819a30f$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $23cd39f08819a30f$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $23cd39f08819a30f$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $23cd39f08819a30f$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $23cd39f08819a30f$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $23cd39f08819a30f$var$objectTraps = {
    get (state, prop) {
        if (prop === $23cd39f08819a30f$var$DRAFT_STATE) return state;
        const source = $23cd39f08819a30f$var$latest(state);
        if (!$23cd39f08819a30f$var$has(source, prop)) return $23cd39f08819a30f$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$23cd39f08819a30f$export$16e3aed3edb85946(value)) return value;
        if (value === $23cd39f08819a30f$var$peek(state.base_, prop)) {
            $23cd39f08819a30f$var$prepareCopy(state);
            return state.copy_[prop] = $23cd39f08819a30f$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $23cd39f08819a30f$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($23cd39f08819a30f$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $23cd39f08819a30f$var$getDescriptorFromProto($23cd39f08819a30f$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $23cd39f08819a30f$var$peek($23cd39f08819a30f$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$23cd39f08819a30f$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($23cd39f08819a30f$var$is(value, current2) && (value !== void 0 || $23cd39f08819a30f$var$has(state.base_, prop))) return true;
            $23cd39f08819a30f$var$prepareCopy(state);
            $23cd39f08819a30f$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($23cd39f08819a30f$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $23cd39f08819a30f$var$prepareCopy(state);
            $23cd39f08819a30f$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $23cd39f08819a30f$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $23cd39f08819a30f$var$die(11);
    },
    getPrototypeOf (state) {
        return $23cd39f08819a30f$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $23cd39f08819a30f$var$die(12);
    }
};
var $23cd39f08819a30f$var$arrayTraps = {};
$23cd39f08819a30f$var$each($23cd39f08819a30f$var$objectTraps, (key, fn)=>{
    $23cd39f08819a30f$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$23cd39f08819a30f$var$arrayTraps.deleteProperty = function(state, prop) {
    return $23cd39f08819a30f$var$arrayTraps.set.call(this, state, prop, void 0);
};
$23cd39f08819a30f$var$arrayTraps.set = function(state, prop, value) {
    return $23cd39f08819a30f$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $23cd39f08819a30f$var$peek(draft, prop) {
    const state = draft[$23cd39f08819a30f$var$DRAFT_STATE];
    const source = state ? $23cd39f08819a30f$var$latest(state) : draft;
    return source[prop];
}
function $23cd39f08819a30f$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $23cd39f08819a30f$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $23cd39f08819a30f$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $23cd39f08819a30f$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $23cd39f08819a30f$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $23cd39f08819a30f$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $23cd39f08819a30f$var$markChanged(state.parent_);
    }
}
function $23cd39f08819a30f$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $23cd39f08819a30f$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $23cd39f08819a30f$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $23cd39f08819a30f$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $23cd39f08819a30f$var$die(7);
            let result;
            if ($23cd39f08819a30f$export$16e3aed3edb85946(base)) {
                const scope = $23cd39f08819a30f$var$enterScope(this);
                const proxy = $23cd39f08819a30f$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $23cd39f08819a30f$var$revokeScope(scope);
                    else $23cd39f08819a30f$var$leaveScope(scope);
                }
                $23cd39f08819a30f$var$usePatchesInScope(scope, patchListener);
                return $23cd39f08819a30f$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $23cd39f08819a30f$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $23cd39f08819a30f$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $23cd39f08819a30f$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $23cd39f08819a30f$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$23cd39f08819a30f$export$16e3aed3edb85946(base)) $23cd39f08819a30f$var$die(8);
        if ($23cd39f08819a30f$export$541ac630993a4c84(base)) base = $23cd39f08819a30f$export$97aac956da55dae9(base);
        const scope = $23cd39f08819a30f$var$enterScope(this);
        const proxy = $23cd39f08819a30f$var$createProxy(base, void 0);
        proxy[$23cd39f08819a30f$var$DRAFT_STATE].isManual_ = true;
        $23cd39f08819a30f$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$23cd39f08819a30f$var$DRAFT_STATE];
        if (!state || !state.isManual_) $23cd39f08819a30f$var$die(9);
        const { scope_: scope } = state;
        $23cd39f08819a30f$var$usePatchesInScope(scope, patchListener);
        return $23cd39f08819a30f$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $23cd39f08819a30f$var$getPlugin("Patches").applyPatches_;
        if ($23cd39f08819a30f$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $23cd39f08819a30f$var$createProxy(value, parent) {
    const draft = $23cd39f08819a30f$var$isMap(value) ? $23cd39f08819a30f$var$getPlugin("MapSet").proxyMap_(value, parent) : $23cd39f08819a30f$var$isSet(value) ? $23cd39f08819a30f$var$getPlugin("MapSet").proxySet_(value, parent) : $23cd39f08819a30f$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $23cd39f08819a30f$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $23cd39f08819a30f$export$97aac956da55dae9(value) {
    if (!$23cd39f08819a30f$export$541ac630993a4c84(value)) $23cd39f08819a30f$var$die(10, value);
    return $23cd39f08819a30f$var$currentImpl(value);
}
function $23cd39f08819a30f$var$currentImpl(value) {
    if (!$23cd39f08819a30f$export$16e3aed3edb85946(value) || $23cd39f08819a30f$var$isFrozen(value)) return value;
    const state = value[$23cd39f08819a30f$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $23cd39f08819a30f$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $23cd39f08819a30f$var$shallowCopy(value, true);
    $23cd39f08819a30f$var$each(copy, (key, childValue)=>{
        $23cd39f08819a30f$var$set(copy, key, $23cd39f08819a30f$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $23cd39f08819a30f$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $23cd39f08819a30f$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $23cd39f08819a30f$var$get(base_, key);
            const value = $23cd39f08819a30f$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $23cd39f08819a30f$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $23cd39f08819a30f$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $23cd39f08819a30f$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $23cd39f08819a30f$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $23cd39f08819a30f$var$die(errorOffset + 3);
                base = $23cd39f08819a30f$var$get(base, p);
                if (typeof base !== "object") $23cd39f08819a30f$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $23cd39f08819a30f$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $23cd39f08819a30f$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $23cd39f08819a30f$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$23cd39f08819a30f$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($23cd39f08819a30f$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($23cd39f08819a30f$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($23cd39f08819a30f$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($23cd39f08819a30f$var$has(obj, $23cd39f08819a30f$export$6ee2082928bcb0ee)) cloned[$23cd39f08819a30f$export$6ee2082928bcb0ee] = obj[$23cd39f08819a30f$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($23cd39f08819a30f$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $23cd39f08819a30f$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $23cd39f08819a30f$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$23cd39f08819a30f$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $23cd39f08819a30f$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $23cd39f08819a30f$var$latest(this[$23cd39f08819a30f$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $23cd39f08819a30f$var$latest(this[$23cd39f08819a30f$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$23cd39f08819a30f$var$latest(state).has(key) || $23cd39f08819a30f$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $23cd39f08819a30f$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $23cd39f08819a30f$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($23cd39f08819a30f$var$latest(state).size) {
                prepareMapCopy(state);
                $23cd39f08819a30f$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $23cd39f08819a30f$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            $23cd39f08819a30f$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $23cd39f08819a30f$var$latest(state).get(key);
            if (state.finalized_ || !$23cd39f08819a30f$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $23cd39f08819a30f$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $23cd39f08819a30f$var$latest(this[$23cd39f08819a30f$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($23cd39f08819a30f$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$23cd39f08819a30f$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $23cd39f08819a30f$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $23cd39f08819a30f$var$latest(this[$23cd39f08819a30f$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $23cd39f08819a30f$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $23cd39f08819a30f$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($23cd39f08819a30f$var$latest(state).size) {
                prepareSetCopy(state);
                $23cd39f08819a30f$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$23cd39f08819a30f$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($23cd39f08819a30f$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($23cd39f08819a30f$export$16e3aed3edb85946(value)) {
                    const draft = $23cd39f08819a30f$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $23cd39f08819a30f$var$die(3, JSON.stringify($23cd39f08819a30f$var$latest(state)));
    }
    $23cd39f08819a30f$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $23cd39f08819a30f$var$immer = new $23cd39f08819a30f$export$aaadc6ff0f822719();
var $23cd39f08819a30f$export$b46cabe22e78bc00 = $23cd39f08819a30f$var$immer.produce;
var $23cd39f08819a30f$export$4da66d41c9492c78 = $23cd39f08819a30f$var$immer.produceWithPatches.bind($23cd39f08819a30f$var$immer);
var $23cd39f08819a30f$export$573f26f60825c493 = $23cd39f08819a30f$var$immer.setAutoFreeze.bind($23cd39f08819a30f$var$immer);
var $23cd39f08819a30f$export$333ce65961cbe047 = $23cd39f08819a30f$var$immer.setUseStrictShallowCopy.bind($23cd39f08819a30f$var$immer);
var $23cd39f08819a30f$export$a8b8e03e6bbe5473 = $23cd39f08819a30f$var$immer.applyPatches.bind($23cd39f08819a30f$var$immer);
var $23cd39f08819a30f$export$3c3214997190395f = $23cd39f08819a30f$var$immer.createDraft.bind($23cd39f08819a30f$var$immer);
var $23cd39f08819a30f$export$c60f5e69c521b528 = $23cd39f08819a30f$var$immer.finishDraft.bind($23cd39f08819a30f$var$immer);
function $23cd39f08819a30f$export$c05b21e3257751e5(value) {
    return value;
}
function $23cd39f08819a30f$export$20f911b3f8cf0b74(value) {
    return value;
}


var $688adee419d442c1$var$__defProp = Object.defineProperty;
var $688adee419d442c1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $688adee419d442c1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $688adee419d442c1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $688adee419d442c1$var$__defNormalProp = (obj, key, value)=>key in obj ? $688adee419d442c1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $688adee419d442c1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($688adee419d442c1$var$__hasOwnProp.call(b, prop)) $688adee419d442c1$var$__defNormalProp(a, prop, b[prop]);
    if ($688adee419d442c1$var$__getOwnPropSymbols) {
        for (var prop of $688adee419d442c1$var$__getOwnPropSymbols(b))if ($688adee419d442c1$var$__propIsEnum.call(b, prop)) $688adee419d442c1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $688adee419d442c1$var$__publicField = (obj, key, value)=>{
    $688adee419d442c1$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $688adee419d442c1$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $688adee419d442c1$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $688adee419d442c1$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $688adee419d442c1$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($688adee419d442c1$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $688adee419d442c1$var$NOT_FOUND = "NOT_FOUND";
function $688adee419d442c1$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $688adee419d442c1$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $688adee419d442c1$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $688adee419d442c1$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $688adee419d442c1$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $688adee419d442c1$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $688adee419d442c1$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $688adee419d442c1$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $688adee419d442c1$var$__spreadValues($688adee419d442c1$var$__spreadValues({}, $688adee419d442c1$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $688adee419d442c1$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $688adee419d442c1$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $688adee419d442c1$var$$REVISION = 0;
var $688adee419d442c1$var$CURRENT_TRACKER = null;
var $688adee419d442c1$var$Cell = class {
    constructor(initialValue, isEqual = $688adee419d442c1$var$tripleEq){
        $688adee419d442c1$var$__publicField(this, "revision", $688adee419d442c1$var$$REVISION);
        $688adee419d442c1$var$__publicField(this, "_value");
        $688adee419d442c1$var$__publicField(this, "_lastValue");
        $688adee419d442c1$var$__publicField(this, "_isEqual", $688adee419d442c1$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $688adee419d442c1$var$CURRENT_TRACKER == null || $688adee419d442c1$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$688adee419d442c1$var$$REVISION;
    }
};
function $688adee419d442c1$var$tripleEq(a, b) {
    return a === b;
}
var $688adee419d442c1$var$TrackingCache = class {
    constructor(fn){
        $688adee419d442c1$var$__publicField(this, "_cachedValue");
        $688adee419d442c1$var$__publicField(this, "_cachedRevision", -1);
        $688adee419d442c1$var$__publicField(this, "_deps", []);
        $688adee419d442c1$var$__publicField(this, "hits", 0);
        $688adee419d442c1$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $688adee419d442c1$var$CURRENT_TRACKER;
            $688adee419d442c1$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $688adee419d442c1$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $688adee419d442c1$var$CURRENT_TRACKER == null || $688adee419d442c1$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $688adee419d442c1$var$getValue(cell) {
    if (!(cell instanceof $688adee419d442c1$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $688adee419d442c1$var$setValue(storage, value) {
    if (!(storage instanceof $688adee419d442c1$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $688adee419d442c1$var$createCell(initialValue, isEqual = $688adee419d442c1$var$tripleEq) {
    return new $688adee419d442c1$var$Cell(initialValue, isEqual);
}
function $688adee419d442c1$var$createCache(fn) {
    $688adee419d442c1$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $688adee419d442c1$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $688adee419d442c1$var$neverEq = (a, b)=>false;
function $688adee419d442c1$var$createTag() {
    return $688adee419d442c1$var$createCell(null, $688adee419d442c1$var$neverEq);
}
function $688adee419d442c1$var$dirtyTag(tag, value) {
    $688adee419d442c1$var$setValue(tag, value);
}
var $688adee419d442c1$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $688adee419d442c1$var$createTag();
    $688adee419d442c1$var$getValue(tag);
};
var $688adee419d442c1$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $688adee419d442c1$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $688adee419d442c1$var$REDUX_PROXY_LABEL = Symbol();
var $688adee419d442c1$var$nextId = 0;
var $688adee419d442c1$var$proto = Object.getPrototypeOf({});
var $688adee419d442c1$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $688adee419d442c1$var$__publicField(this, "proxy", new Proxy(this, $688adee419d442c1$var$objectProxyHandler));
        $688adee419d442c1$var$__publicField(this, "tag", $688adee419d442c1$var$createTag());
        $688adee419d442c1$var$__publicField(this, "tags", {});
        $688adee419d442c1$var$__publicField(this, "children", {});
        $688adee419d442c1$var$__publicField(this, "collectionTag", null);
        $688adee419d442c1$var$__publicField(this, "id", $688adee419d442c1$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $688adee419d442c1$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $688adee419d442c1$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $688adee419d442c1$var$createNode(childValue);
                if (childNode.tag) $688adee419d442c1$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $688adee419d442c1$var$createTag();
                    tag.value = childValue;
                }
                $688adee419d442c1$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $688adee419d442c1$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $688adee419d442c1$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $688adee419d442c1$var$__publicField(this, "proxy", new Proxy([
            this
        ], $688adee419d442c1$var$arrayProxyHandler));
        $688adee419d442c1$var$__publicField(this, "tag", $688adee419d442c1$var$createTag());
        $688adee419d442c1$var$__publicField(this, "tags", {});
        $688adee419d442c1$var$__publicField(this, "children", {});
        $688adee419d442c1$var$__publicField(this, "collectionTag", null);
        $688adee419d442c1$var$__publicField(this, "id", $688adee419d442c1$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $688adee419d442c1$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $688adee419d442c1$var$consumeCollection(node);
        return $688adee419d442c1$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $688adee419d442c1$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $688adee419d442c1$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $688adee419d442c1$var$objectProxyHandler.has(node, prop);
    }
};
function $688adee419d442c1$var$createNode(value) {
    if (Array.isArray(value)) return new $688adee419d442c1$var$ArrayTreeNode(value);
    return new $688adee419d442c1$var$ObjectTreeNode(value);
}
function $688adee419d442c1$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $688adee419d442c1$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $688adee419d442c1$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $688adee419d442c1$var$dirtyCollection(node);
            $688adee419d442c1$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $688adee419d442c1$var$updateNode(childNode, newChildValue);
        else {
            $688adee419d442c1$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $688adee419d442c1$var$deleteNode(node) {
    if (node.tag) $688adee419d442c1$var$dirtyTag(node.tag, null);
    $688adee419d442c1$var$dirtyCollection(node);
    for(const key in node.tags)$688adee419d442c1$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$688adee419d442c1$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $688adee419d442c1$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $688adee419d442c1$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $688adee419d442c1$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $688adee419d442c1$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $688adee419d442c1$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $688adee419d442c1$export$3f025202a230c6dd = (a, b)=>a === b;
function $688adee419d442c1$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $688adee419d442c1$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $688adee419d442c1$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $688adee419d442c1$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize === 1 ? $688adee419d442c1$var$createSingletonCache(comparator) : $688adee419d442c1$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $688adee419d442c1$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $688adee419d442c1$export$c8f9cf88d9fdee55(func) {
    const node = $688adee419d442c1$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $688adee419d442c1$var$createCacheKeyComparator($688adee419d442c1$export$3f025202a230c6dd);
    const cache = $688adee419d442c1$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $688adee419d442c1$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $688adee419d442c1$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $688adee419d442c1$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $688adee419d442c1$var$StrongRef;
var $688adee419d442c1$var$UNTERMINATED = 0;
var $688adee419d442c1$var$TERMINATED = 1;
function $688adee419d442c1$var$createCacheNode() {
    return {
        s: $688adee419d442c1$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $688adee419d442c1$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $688adee419d442c1$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $688adee419d442c1$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $688adee419d442c1$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $688adee419d442c1$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $688adee419d442c1$var$TERMINATED;
        if (resultEqualityCheck) {
            const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $688adee419d442c1$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $688adee419d442c1$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $688adee419d442c1$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $688adee419d442c1$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $688adee419d442c1$var$__spreadValues($688adee419d442c1$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $688adee419d442c1$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $688adee419d442c1$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $688adee419d442c1$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $688adee419d442c1$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $688adee419d442c1$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $688adee419d442c1$export$595d22ed68ca2841 = /* @__PURE__ */ $688adee419d442c1$export$5943f4447f6ef248($688adee419d442c1$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $688adee419d442c1$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $688adee419d442c1$export$595d22ed68ca2841)=>{
    $688adee419d442c1$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$688adee419d442c1$export$75979cfcd91bf38f
});


// src/index.ts
function $755809100bdc152e$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $755809100bdc152e$export$dd164f5517779f15 = $755809100bdc152e$var$createThunkMiddleware();
var $755809100bdc152e$export$16d06542a1949d9e = $755809100bdc152e$var$createThunkMiddleware;


var $c68e419b2a37d2b9$exports = {};
// shim for using process in browser
var $c68e419b2a37d2b9$var$process = $c68e419b2a37d2b9$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $c68e419b2a37d2b9$var$cachedSetTimeout;
var $c68e419b2a37d2b9$var$cachedClearTimeout;
function $c68e419b2a37d2b9$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $c68e419b2a37d2b9$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $c68e419b2a37d2b9$var$cachedSetTimeout = setTimeout;
        else $c68e419b2a37d2b9$var$cachedSetTimeout = $c68e419b2a37d2b9$var$defaultSetTimout;
    } catch (e) {
        $c68e419b2a37d2b9$var$cachedSetTimeout = $c68e419b2a37d2b9$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $c68e419b2a37d2b9$var$cachedClearTimeout = clearTimeout;
        else $c68e419b2a37d2b9$var$cachedClearTimeout = $c68e419b2a37d2b9$var$defaultClearTimeout;
    } catch (e) {
        $c68e419b2a37d2b9$var$cachedClearTimeout = $c68e419b2a37d2b9$var$defaultClearTimeout;
    }
})();
function $c68e419b2a37d2b9$var$runTimeout(fun) {
    if ($c68e419b2a37d2b9$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($c68e419b2a37d2b9$var$cachedSetTimeout === $c68e419b2a37d2b9$var$defaultSetTimout || !$c68e419b2a37d2b9$var$cachedSetTimeout) && setTimeout) {
        $c68e419b2a37d2b9$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c68e419b2a37d2b9$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $c68e419b2a37d2b9$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $c68e419b2a37d2b9$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $c68e419b2a37d2b9$var$runClearTimeout(marker) {
    if ($c68e419b2a37d2b9$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($c68e419b2a37d2b9$var$cachedClearTimeout === $c68e419b2a37d2b9$var$defaultClearTimeout || !$c68e419b2a37d2b9$var$cachedClearTimeout) && clearTimeout) {
        $c68e419b2a37d2b9$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c68e419b2a37d2b9$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $c68e419b2a37d2b9$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $c68e419b2a37d2b9$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $c68e419b2a37d2b9$var$queue = [];
var $c68e419b2a37d2b9$var$draining = false;
var $c68e419b2a37d2b9$var$currentQueue;
var $c68e419b2a37d2b9$var$queueIndex = -1;
function $c68e419b2a37d2b9$var$cleanUpNextTick() {
    if (!$c68e419b2a37d2b9$var$draining || !$c68e419b2a37d2b9$var$currentQueue) return;
    $c68e419b2a37d2b9$var$draining = false;
    if ($c68e419b2a37d2b9$var$currentQueue.length) $c68e419b2a37d2b9$var$queue = $c68e419b2a37d2b9$var$currentQueue.concat($c68e419b2a37d2b9$var$queue);
    else $c68e419b2a37d2b9$var$queueIndex = -1;
    if ($c68e419b2a37d2b9$var$queue.length) $c68e419b2a37d2b9$var$drainQueue();
}
function $c68e419b2a37d2b9$var$drainQueue() {
    if ($c68e419b2a37d2b9$var$draining) return;
    var timeout = $c68e419b2a37d2b9$var$runTimeout($c68e419b2a37d2b9$var$cleanUpNextTick);
    $c68e419b2a37d2b9$var$draining = true;
    var len = $c68e419b2a37d2b9$var$queue.length;
    while(len){
        $c68e419b2a37d2b9$var$currentQueue = $c68e419b2a37d2b9$var$queue;
        $c68e419b2a37d2b9$var$queue = [];
        while(++$c68e419b2a37d2b9$var$queueIndex < len)if ($c68e419b2a37d2b9$var$currentQueue) $c68e419b2a37d2b9$var$currentQueue[$c68e419b2a37d2b9$var$queueIndex].run();
        $c68e419b2a37d2b9$var$queueIndex = -1;
        len = $c68e419b2a37d2b9$var$queue.length;
    }
    $c68e419b2a37d2b9$var$currentQueue = null;
    $c68e419b2a37d2b9$var$draining = false;
    $c68e419b2a37d2b9$var$runClearTimeout(timeout);
}
$c68e419b2a37d2b9$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $c68e419b2a37d2b9$var$queue.push(new $c68e419b2a37d2b9$var$Item(fun, args));
    if ($c68e419b2a37d2b9$var$queue.length === 1 && !$c68e419b2a37d2b9$var$draining) $c68e419b2a37d2b9$var$runTimeout($c68e419b2a37d2b9$var$drainQueue);
};
// v8 likes predictible objects
function $c68e419b2a37d2b9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$c68e419b2a37d2b9$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$c68e419b2a37d2b9$var$process.title = "browser";
$c68e419b2a37d2b9$var$process.browser = true;
$c68e419b2a37d2b9$var$process.env = {};
$c68e419b2a37d2b9$var$process.argv = [];
$c68e419b2a37d2b9$var$process.version = ""; // empty string to avoid regexp issues
$c68e419b2a37d2b9$var$process.versions = {};
function $c68e419b2a37d2b9$var$noop() {}
$c68e419b2a37d2b9$var$process.on = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.addListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.once = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.off = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.removeListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.removeAllListeners = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.emit = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.prependListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.prependOnceListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.listeners = function(name) {
    return [];
};
$c68e419b2a37d2b9$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$c68e419b2a37d2b9$var$process.cwd = function() {
    return "/";
};
$c68e419b2a37d2b9$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$c68e419b2a37d2b9$var$process.umask = function() {
    return 0;
};


var $5725b37018bbdb6b$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $688adee419d442c1$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $23cd39f08819a30f$export$541ac630993a4c84)(value) ? (0, $23cd39f08819a30f$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $5725b37018bbdb6b$export$a5d3c27355e35910 = $5725b37018bbdb6b$export$aab6de9e3dbb1473((0, $688adee419d442c1$export$8402dc26d96f6902));
var $5725b37018bbdb6b$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $866c1eaece9c0f08$export$f672e0b6f7222cd7;
    return (0, $866c1eaece9c0f08$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $5725b37018bbdb6b$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $5725b37018bbdb6b$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $5725b37018bbdb6b$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $866c1eaece9c0f08$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $5725b37018bbdb6b$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $5725b37018bbdb6b$var$hasMatchFunction(action);
}
function $5725b37018bbdb6b$export$ebd532f9034651f3(action) {
    return (0, $866c1eaece9c0f08$export$b956e38827fca970)(action) && Object.keys(action).every($5725b37018bbdb6b$var$isValidKey);
}
function $5725b37018bbdb6b$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $5725b37018bbdb6b$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $5725b37018bbdb6b$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $5725b37018bbdb6b$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $5725b37018bbdb6b$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $5725b37018bbdb6b$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $5725b37018bbdb6b$var$freezeDraftable(val) {
    return (0, $23cd39f08819a30f$export$16e3aed3edb85946)(val) ? (0, $23cd39f08819a30f$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $5725b37018bbdb6b$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $5725b37018bbdb6b$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $5725b37018bbdb6b$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $5725b37018bbdb6b$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $5725b37018bbdb6b$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $5725b37018bbdb6b$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $5725b37018bbdb6b$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $5725b37018bbdb6b$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $5725b37018bbdb6b$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $5725b37018bbdb6b$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $5725b37018bbdb6b$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $866c1eaece9c0f08$export$53b83ca8eaab0383)(val);
}
function $5725b37018bbdb6b$export$ada5dca0b571bc7(value, path = "", isSerializable = $5725b37018bbdb6b$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $5725b37018bbdb6b$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $5725b37018bbdb6b$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $5725b37018bbdb6b$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$5725b37018bbdb6b$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $5725b37018bbdb6b$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $5725b37018bbdb6b$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $5725b37018bbdb6b$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $5725b37018bbdb6b$export$1908877435b1d5e9();
        if (thunk) {
            if ($5725b37018bbdb6b$var$isBoolean(thunk)) middlewareArray.push((0, $755809100bdc152e$export$dd164f5517779f15));
            else middlewareArray.push((0, $755809100bdc152e$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $5725b37018bbdb6b$export$8fb31c0f05df007b = "RTK_autoBatch";
var $5725b37018bbdb6b$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$5725b37018bbdb6b$export$8fb31c0f05df007b]: true
            }
        });
var $5725b37018bbdb6b$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $5725b37018bbdb6b$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $5725b37018bbdb6b$var$createQueueWithTimer(10);
var $5725b37018bbdb6b$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $5725b37018bbdb6b$var$rAF : options.type === "callback" ? options.queueNotification : $5725b37018bbdb6b$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$5725b37018bbdb6b$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $5725b37018bbdb6b$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $5725b37018bbdb6b$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($5725b37018bbdb6b$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
var $5725b37018bbdb6b$var$IS_PRODUCTION = true;
function $5725b37018bbdb6b$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $5725b37018bbdb6b$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $866c1eaece9c0f08$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $866c1eaece9c0f08$export$66e4520cdb265d18)(reducer);
    else throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(1));
    if (!$5725b37018bbdb6b$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(2));
    let finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$5725b37018bbdb6b$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$5725b37018bbdb6b$var$IS_PRODUCTION && finalMiddleware.some((item)=>typeof item !== "function")) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(4));
    let finalCompose = (0, $866c1eaece9c0f08$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $5725b37018bbdb6b$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$5725b37018bbdb6b$var$IS_PRODUCTION,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $866c1eaece9c0f08$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $5725b37018bbdb6b$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$5725b37018bbdb6b$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(5));
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$5725b37018bbdb6b$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(6));
    if (!$5725b37018bbdb6b$var$IS_PRODUCTION && storeEnhancers.some((item)=>typeof item !== "function")) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(7));
    if (!$5725b37018bbdb6b$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $866c1eaece9c0f08$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $5725b37018bbdb6b$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $5725b37018bbdb6b$var$isStateFunction(x) {
    return typeof x === "function";
}
function $5725b37018bbdb6b$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $5725b37018bbdb6b$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($5725b37018bbdb6b$var$isStateFunction(initialState)) getInitialState = ()=>$5725b37018bbdb6b$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $5725b37018bbdb6b$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $23cd39f08819a30f$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $23cd39f08819a30f$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $23cd39f08819a30f$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $5725b37018bbdb6b$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $5725b37018bbdb6b$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $5725b37018bbdb6b$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $5725b37018bbdb6b$var$matches = (matcher, action)=>{
    if ($5725b37018bbdb6b$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $5725b37018bbdb6b$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$5725b37018bbdb6b$var$matches(matcher, action));
    };
}
function $5725b37018bbdb6b$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$5725b37018bbdb6b$var$matches(matcher, action));
    };
}
function $5725b37018bbdb6b$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $5725b37018bbdb6b$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $5725b37018bbdb6b$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$5725b37018bbdb6b$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$5725b37018bbdb6b$var$isAsyncThunkArray(asyncThunks)) return $5725b37018bbdb6b$export$872dec21e9a69476()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.pending);
        const combinedMatcher = $5725b37018bbdb6b$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $5725b37018bbdb6b$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$5725b37018bbdb6b$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$5725b37018bbdb6b$var$isAsyncThunkArray(asyncThunks)) return $5725b37018bbdb6b$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.rejected);
        const combinedMatcher = $5725b37018bbdb6b$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $5725b37018bbdb6b$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return (action)=>{
        const combinedMatcher = $5725b37018bbdb6b$export$9dd1fb32974da385($5725b37018bbdb6b$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$5725b37018bbdb6b$var$isAsyncThunkArray(asyncThunks)) return $5725b37018bbdb6b$export$fcc3388fb56de601()(asyncThunks[0]);
    return (action)=>{
        const combinedMatcher = $5725b37018bbdb6b$export$9dd1fb32974da385($5725b37018bbdb6b$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $5725b37018bbdb6b$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$5725b37018bbdb6b$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$5725b37018bbdb6b$var$isAsyncThunkArray(asyncThunks)) return $5725b37018bbdb6b$export$1da80a6ef1307441()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled);
        const combinedMatcher = $5725b37018bbdb6b$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $5725b37018bbdb6b$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$5725b37018bbdb6b$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$5725b37018bbdb6b$var$isAsyncThunkArray(asyncThunks)) return $5725b37018bbdb6b$export$6aa4142d99c1abce()(asyncThunks[0]);
    return (action)=>{
        const matchers = [];
        for (const asyncThunk of asyncThunks)matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        const combinedMatcher = $5725b37018bbdb6b$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $5725b37018bbdb6b$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $5725b37018bbdb6b$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $5725b37018bbdb6b$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $5725b37018bbdb6b$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $5725b37018bbdb6b$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $5725b37018bbdb6b$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $5725b37018bbdb6b$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $5725b37018bbdb6b$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $5725b37018bbdb6b$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $5725b37018bbdb6b$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $5725b37018bbdb6b$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($5725b37018bbdb6b$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $5725b37018bbdb6b$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $5725b37018bbdb6b$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $5725b37018bbdb6b$var$RejectWithValue) throw result;
                                if (result instanceof $5725b37018bbdb6b$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $5725b37018bbdb6b$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($5725b37018bbdb6b$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $5725b37018bbdb6b$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $5725b37018bbdb6b$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $5725b37018bbdb6b$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $5725b37018bbdb6b$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $5725b37018bbdb6b$export$343355ed40c51c46 = {
    [$5725b37018bbdb6b$var$asyncThunkSymbol]: $5725b37018bbdb6b$export$6abd22dc03e5063f
};
var $5725b37018bbdb6b$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($5725b37018bbdb6b$export$23a094319a4b586 || {});
function $5725b37018bbdb6b$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $5725b37018bbdb6b$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$5725b37018bbdb6b$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(11));
        typeof $c68e419b2a37d2b9$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($5725b37018bbdb6b$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $5725b37018bbdb6b$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($5725b37018bbdb6b$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $5725b37018bbdb6b$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $5725b37018bbdb6b$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $5725b37018bbdb6b$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $5725b37018bbdb6b$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $5725b37018bbdb6b$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $5725b37018bbdb6b$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        const map = {};
                        for (const [name2, selector] of Object.entries(options.selectors ?? {}))map[name2] = $5725b37018bbdb6b$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt ?? reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $5725b37018bbdb6b$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $5725b37018bbdb6b$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $5725b37018bbdb6b$export$affdea4146de9cf5();
function $5725b37018bbdb6b$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $5725b37018bbdb6b$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$5725b37018bbdb6b$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $5725b37018bbdb6b$export$309c7a02b0b0bc62(type, prepareCallback) : $5725b37018bbdb6b$export$309c7a02b0b0bc62(type));
}
function $5725b37018bbdb6b$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $5725b37018bbdb6b$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $5725b37018bbdb6b$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $5725b37018bbdb6b$var$noop,
        pending: pending || $5725b37018bbdb6b$var$noop,
        rejected: rejected || $5725b37018bbdb6b$var$noop,
        settled: settled || $5725b37018bbdb6b$var$noop
    });
}
function $5725b37018bbdb6b$var$noop() {}
// src/entities/entity_state.ts
function $5725b37018bbdb6b$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $5725b37018bbdb6b$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($5725b37018bbdb6b$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $5725b37018bbdb6b$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $5725b37018bbdb6b$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $5725b37018bbdb6b$var$isDraftTyped = (0, $23cd39f08819a30f$export$541ac630993a4c84);
function $5725b37018bbdb6b$var$createSingleArgumentStateOperator(mutator) {
    const operator = $5725b37018bbdb6b$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $5725b37018bbdb6b$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $5725b37018bbdb6b$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($5725b37018bbdb6b$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $23cd39f08819a30f$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $5725b37018bbdb6b$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $5725b37018bbdb6b$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $5725b37018bbdb6b$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $5725b37018bbdb6b$var$ensureEntitiesArray(newEntities);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $5725b37018bbdb6b$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $5725b37018bbdb6b$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $5725b37018bbdb6b$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $5725b37018bbdb6b$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $5725b37018bbdb6b$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $5725b37018bbdb6b$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $5725b37018bbdb6b$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $5725b37018bbdb6b$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$5725b37018bbdb6b$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $5725b37018bbdb6b$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $5725b37018bbdb6b$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $5725b37018bbdb6b$var$createStateOperator(addOneMutably),
        addMany: $5725b37018bbdb6b$var$createStateOperator(addManyMutably),
        setOne: $5725b37018bbdb6b$var$createStateOperator(setOneMutably),
        setMany: $5725b37018bbdb6b$var$createStateOperator(setManyMutably),
        setAll: $5725b37018bbdb6b$var$createStateOperator(setAllMutably),
        updateOne: $5725b37018bbdb6b$var$createStateOperator(updateOneMutably),
        updateMany: $5725b37018bbdb6b$var$createStateOperator(updateManyMutably),
        upsertOne: $5725b37018bbdb6b$var$createStateOperator(upsertOneMutably),
        upsertMany: $5725b37018bbdb6b$var$createStateOperator(upsertManyMutably),
        removeOne: $5725b37018bbdb6b$var$createStateOperator(removeOneMutably),
        removeMany: $5725b37018bbdb6b$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $5725b37018bbdb6b$var$createSortedStateAdapter(selectId, sort) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $5725b37018bbdb6b$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $5725b37018bbdb6b$var$ensureEntitiesArray(newEntities);
        const models = newEntities.filter((model)=>!($5725b37018bbdb6b$var$selectIdValue(model, selectId) in state.entities));
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $5725b37018bbdb6b$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $5725b37018bbdb6b$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $5725b37018bbdb6b$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach((model)=>{
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        const allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        const newSortedIds = allEntities.map(selectId);
        const { ids: ids } = state;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $5725b37018bbdb6b$var$createStateOperator(addOneMutably),
        updateOne: $5725b37018bbdb6b$var$createStateOperator(updateOneMutably),
        upsertOne: $5725b37018bbdb6b$var$createStateOperator(upsertOneMutably),
        setOne: $5725b37018bbdb6b$var$createStateOperator(setOneMutably),
        setMany: $5725b37018bbdb6b$var$createStateOperator(setManyMutably),
        setAll: $5725b37018bbdb6b$var$createStateOperator(setAllMutably),
        addMany: $5725b37018bbdb6b$var$createStateOperator(addManyMutably),
        updateMany: $5725b37018bbdb6b$var$createStateOperator(updateManyMutably),
        upsertMany: $5725b37018bbdb6b$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $5725b37018bbdb6b$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateAdapter = sortComparer ? $5725b37018bbdb6b$var$createSortedStateAdapter(selectId, sortComparer) : $5725b37018bbdb6b$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $5725b37018bbdb6b$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $5725b37018bbdb6b$var$createSelectorsFactory();
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $5725b37018bbdb6b$var$task = "task";
var $5725b37018bbdb6b$var$listener = "listener";
var $5725b37018bbdb6b$var$completed = "completed";
var $5725b37018bbdb6b$var$cancelled = "cancelled";
var $5725b37018bbdb6b$var$taskCancelled = `task-${$5725b37018bbdb6b$var$cancelled}`;
var $5725b37018bbdb6b$var$taskCompleted = `task-${$5725b37018bbdb6b$var$completed}`;
var $5725b37018bbdb6b$var$listenerCancelled = `${$5725b37018bbdb6b$var$listener}-${$5725b37018bbdb6b$var$cancelled}`;
var $5725b37018bbdb6b$var$listenerCompleted = `${$5725b37018bbdb6b$var$listener}-${$5725b37018bbdb6b$var$completed}`;
var $5725b37018bbdb6b$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        this.message = `${$5725b37018bbdb6b$var$task} ${$5725b37018bbdb6b$var$cancelled} (reason: ${code})`;
    }
    name = "TaskAbortError";
    message;
};
// src/listenerMiddleware/utils.ts
var $5725b37018bbdb6b$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(32));
};
var $5725b37018bbdb6b$var$noop2 = ()=>{};
var $5725b37018bbdb6b$var$catchRejection = (promise, onError = $5725b37018bbdb6b$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $5725b37018bbdb6b$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $5725b37018bbdb6b$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $5725b37018bbdb6b$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $5725b37018bbdb6b$export$cb1bdac908fed7f(reason);
    }
};
function $5725b37018bbdb6b$var$raceWithSignal(signal, promise) {
    let cleanup = $5725b37018bbdb6b$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $5725b37018bbdb6b$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $5725b37018bbdb6b$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $5725b37018bbdb6b$var$noop2;
    });
}
var $5725b37018bbdb6b$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $5725b37018bbdb6b$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
var $5725b37018bbdb6b$var$createPause = (signal)=>{
    return (promise)=>{
        return $5725b37018bbdb6b$var$catchRejection($5725b37018bbdb6b$var$raceWithSignal(signal, promise).then((output)=>{
            $5725b37018bbdb6b$var$validateActive(signal);
            return output;
        }));
    };
};
var $5725b37018bbdb6b$var$createDelay = (signal)=>{
    const pause = $5725b37018bbdb6b$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $5725b37018bbdb6b$var$assign } = Object;
var $5725b37018bbdb6b$var$INTERNAL_NIL_TOKEN = {};
var $5725b37018bbdb6b$var$alm = "listenerMiddleware";
var $5725b37018bbdb6b$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$5725b37018bbdb6b$var$addAbortSignalListener(parentAbortSignal, ()=>$5725b37018bbdb6b$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $5725b37018bbdb6b$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $5725b37018bbdb6b$var$runTask(async ()=>{
            $5725b37018bbdb6b$var$validateActive(parentAbortSignal);
            $5725b37018bbdb6b$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $5725b37018bbdb6b$var$createPause(childAbortController.signal),
                delay: $5725b37018bbdb6b$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $5725b37018bbdb6b$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$5725b37018bbdb6b$var$abortControllerWithReason(childAbortController, $5725b37018bbdb6b$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result.catch($5725b37018bbdb6b$var$noop2));
        return {
            result: $5725b37018bbdb6b$var$createPause(parentAbortSignal)(result),
            cancel () {
                $5725b37018bbdb6b$var$abortControllerWithReason(childAbortController, $5725b37018bbdb6b$var$taskCancelled);
            }
        };
    };
};
var $5725b37018bbdb6b$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $5725b37018bbdb6b$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $5725b37018bbdb6b$var$raceWithSignal(signal, Promise.race(promises));
            $5725b37018bbdb6b$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$5725b37018bbdb6b$var$catchRejection(take(predicate, timeout));
};
var $5725b37018bbdb6b$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $5725b37018bbdb6b$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(21));
    $5725b37018bbdb6b$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $5725b37018bbdb6b$var$createListenerEntry = Object.assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $5725b37018bbdb6b$var$getListenerEntryPropsFrom(options);
    const id = $5725b37018bbdb6b$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$5725b37018bbdb6b$var$createListenerEntry
});
var $5725b37018bbdb6b$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $5725b37018bbdb6b$var$abortControllerWithReason(controller, $5725b37018bbdb6b$var$listenerCancelled);
    });
};
var $5725b37018bbdb6b$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($5725b37018bbdb6b$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $5725b37018bbdb6b$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $5725b37018bbdb6b$export$f03a6b845d3fb58b = Object.assign($5725b37018bbdb6b$export$309c7a02b0b0bc62(`${$5725b37018bbdb6b$var$alm}/add`), {
    withTypes: ()=>$5725b37018bbdb6b$export$f03a6b845d3fb58b
});
var $5725b37018bbdb6b$export$b1b8022855fb2b71 = $5725b37018bbdb6b$export$309c7a02b0b0bc62(`${$5725b37018bbdb6b$var$alm}/removeAll`);
var $5725b37018bbdb6b$export$b03e9483f936dccb = Object.assign($5725b37018bbdb6b$export$309c7a02b0b0bc62(`${$5725b37018bbdb6b$var$alm}/remove`), {
    withTypes: ()=>$5725b37018bbdb6b$export$b03e9483f936dccb
});
var $5725b37018bbdb6b$var$defaultErrorHandler = (...args)=>{
    console.error(`${$5725b37018bbdb6b$var$alm}/error`, ...args);
};
var $5725b37018bbdb6b$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $5725b37018bbdb6b$var$defaultErrorHandler } = middlewareOptions;
    $5725b37018bbdb6b$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $5725b37018bbdb6b$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $5725b37018bbdb6b$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $5725b37018bbdb6b$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $5725b37018bbdb6b$var$getListenerEntryPropsFrom(options);
        const entry = $5725b37018bbdb6b$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $5725b37018bbdb6b$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $5725b37018bbdb6b$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $5725b37018bbdb6b$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $5725b37018bbdb6b$var$createDelay(internalTaskController.signal),
                pause: $5725b37018bbdb6b$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $5725b37018bbdb6b$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $5725b37018bbdb6b$var$abortControllerWithReason(controller, $5725b37018bbdb6b$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $5725b37018bbdb6b$var$abortControllerWithReason(internalTaskController, $5725b37018bbdb6b$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $5725b37018bbdb6b$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $5725b37018bbdb6b$export$cb1bdac908fed7f)) $5725b37018bbdb6b$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $5725b37018bbdb6b$var$abortControllerWithReason(internalTaskController, $5725b37018bbdb6b$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $5725b37018bbdb6b$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $866c1eaece9c0f08$export$b956e38827fca970)(action)) return next(action);
                if ($5725b37018bbdb6b$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($5725b37018bbdb6b$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($5725b37018bbdb6b$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $5725b37018bbdb6b$var$INTERNAL_NIL_TOKEN) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $5725b37018bbdb6b$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $5725b37018bbdb6b$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $5725b37018bbdb6b$var$createMiddlewareEntry = (middleware)=>({
        id: $5725b37018bbdb6b$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $5725b37018bbdb6b$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
var $5725b37018bbdb6b$export$4bb1606a79445586 = ()=>{
    const instanceId = $5725b37018bbdb6b$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($5725b37018bbdb6b$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $5725b37018bbdb6b$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $5725b37018bbdb6b$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$5725b37018bbdb6b$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $866c1eaece9c0f08$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $5725b37018bbdb6b$export$9dd1fb32974da385(withMiddleware, $5725b37018bbdb6b$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $5725b37018bbdb6b$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $5725b37018bbdb6b$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$5725b37018bbdb6b$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $5725b37018bbdb6b$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $5725b37018bbdb6b$var$isStateProxy = (value)=>!!value && !!value[$5725b37018bbdb6b$var$ORIGINAL_STATE];
var $5725b37018bbdb6b$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $5725b37018bbdb6b$var$createStateProxy = (state, reducerMap)=>$5725b37018bbdb6b$var$emplace($5725b37018bbdb6b$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $5725b37018bbdb6b$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $5725b37018bbdb6b$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $5725b37018bbdb6b$var$original = (state)=>{
    if (!$5725b37018bbdb6b$var$isStateProxy(state)) throw new Error($5725b37018bbdb6b$export$378fa86b259c0280(25));
    return state[$5725b37018bbdb6b$var$ORIGINAL_STATE];
};
var $5725b37018bbdb6b$var$noopReducer = (state = {})=>state;
function $5725b37018bbdb6b$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($5725b37018bbdb6b$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $866c1eaece9c0f08$export$66e4520cdb265d18)(reducerMap) : $5725b37018bbdb6b$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $c68e419b2a37d2b9$exports;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($5725b37018bbdb6b$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $5725b37018bbdb6b$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $5725b37018bbdb6b$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $aa98b1824adfa6f2$var$cartSlice = (0, $5725b37018bbdb6b$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: [],
        notification: null
    },
    reducers: {
        addItem: (state, action)=>{
            // addItem is the name of action which calls the reducer function, reducer function takes-In two params state and action payload
            // action.payload will be the item that we add
            const existingItemIndex = state.items.findIndex((item)=>item.id === action.payload.id); // we can use findIndex or find method
            if (existingItemIndex !== -1) {
                state.items[existingItemIndex].quantityCount++;
                state.notification = {
                    type: "success",
                    message: "Quantity updated"
                };
            } else {
                state.items.push({
                    ...action.payload,
                    quantityCount: 1
                });
                state.notification = {
                    type: "success",
                    message: "Item added to cart"
                };
            }
        },
        removeItem: (state, action)=>{
            const existingItemIndex = state.items.findIndex((item)=>item.id === action.payload.id); // we can use findIndex or find method
            if (existingItemIndex !== -1) {
                state.items[existingItemIndex].quantityCount--;
                state.notification = {
                    type: "success",
                    message: "Quantity updated"
                };
                if (state.items[existingItemIndex].quantityCount === 0) {
                    state.items.splice(existingItemIndex, 1);
                    state.notification = {
                        type: "success",
                        message: "Item removed"
                    };
                }
            }
        },
        removeFullItem: (state, action)=>{
            const existingItemIndex = state.items.findIndex((item)=>item.id === action.payload.id);
            if (existingItemIndex !== -1) {
                state.items.splice(existingItemIndex, 1);
                state.notification = {
                    type: "success",
                    message: "Item removed"
                };
            }
        },
        clearCart: (state)=>{
            state.items = [];
            state.notification = {
                type: "success",
                message: "Cart cleared"
            };
        },
        clearNotification: (state)=>{
            state.notification = null;
        }
    }
});
const { addItem: $aa98b1824adfa6f2$export$fb9705de59d96855, removeItem: $aa98b1824adfa6f2$export$fe2d9b4e03920b4c, clearCart: $aa98b1824adfa6f2$export$810121176e3e3671, removeFullItem: $aa98b1824adfa6f2$export$1c55978aee5fc2e7, clearNotification: $aa98b1824adfa6f2$export$2e0a8d27cffff36a } = $aa98b1824adfa6f2$var$cartSlice.actions;
var $aa98b1824adfa6f2$export$2e2bcd8739ae039 // it combines all the reducer functions and exports as a single reducer
 // dont forget to import it into store as a slice
 = $aa98b1824adfa6f2$var$cartSlice.reducer;


const $ef4d3c1b0f4287aa$var$Notifications = ()=>{
    // subscribing to store for notifications status
    const notification = (0, $3563a485d86a3589$export$2105062e25df4afe)((state)=>state.cart.notification);
    const dispatch = (0, $3563a485d86a3589$export$8ad76b76a4c905f8)();
    console.log(notification);
    // here useEffect hook is used for modifying the notification to null after 3 seconds
    // in useEffect we can apply the the componentWillUnmount tasks
    (0, $8T3gX.useEffect)(()=>{
        if (notification) {
            const timer = setTimeout(()=>{
                // Dispatch clearNotification action to clear the notification after 3 seconds
                dispatch((0, $aa98b1824adfa6f2$export$2e0a8d27cffff36a)());
            }, 1000);
            // Cleanup function to clear the timeout when the component unmounts or when notification changes
            return ()=>clearTimeout(timer);
        }
    }, [
        notification,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "absolute left-1/2 transform -translate-x-1/2 -bottom-[23px] ",
        children: notification && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: `${notification.type} animate-bounce  bg-green-600 text-sm py-1 px-4 text-white rounded`,
            children: [
                notification.message,
                "\xa0",
                /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                    className: "fa-solid fa-check "
                })
            ]
        })
    });
};
var $ef4d3c1b0f4287aa$export$2e2bcd8739ae039 = $ef4d3c1b0f4287aa$var$Notifications;


const $8d2777a938aec608$var$Logo = ()=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
        to: "/",
        children: /*#__PURE__*/ (0, $k4ank.jsx)("img", {
            className: "sm:w-16 sm:h-16 rounded-lg w-14 h-14",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9da83de6e889f30e$exports))),
            alt: "logo"
        })
    });
const $8d2777a938aec608$var$Header = ()=>{
    const [isLoggedIn, login, logout] = (0, $b17d528c9be7da99$export$8bf4ce924aca1720)();
    // subscribing the store using useSelector hook
    const cartItems = (0, $3563a485d86a3589$export$2105062e25df4afe)((store)=>store.cart.items); // SUBSCRIBING TO CART SLICE OF STORE\
    const notifications = (0, $3563a485d86a3589$export$2105062e25df4afe)((store)=>store.cart.notification);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = (0, $8T3gX.useState)(false);
    const [isProfileMenuOpen, setIsProfileMenuOpen] = (0, $8T3gX.useState)(false);
    // Toggling hambergermenu
    const toggleMobileMenu = ()=>{
        setIsMobileMenuOpen((prevState)=>!prevState);
    };
    /**
   * setIsMobileMenuOpen is a function provided by the useState hook, which updates the state value isMobileMenuOpen.
   * (prevState => !prevState) is an updater function used as an argument to setIsMobileMenuOpen. This function takes the previous state value (prevState) 
   *  and returns the new state value. In this case, it toggles the boolean value by negating it (!prevState), 
   *  which means if prevState is true, it becomes false, and vice versa.
   */ const closeMobileMenu = ()=>{
        setIsMobileMenuOpen(false);
    };
    const closeProfileMenu = ()=>{
        setIsProfileMenuOpen(false);
    };
    // Toggling profile menu
    const toggleProfileMenu = ()=>{
        setIsProfileMenuOpen((prevState)=>!prevState);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("nav", {
        className: "bg-white border shadow-md py-0 fixed top-0 left-0 right-0 z-10",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "mx-auto max-w-7xl px-2 sm:px-6 lg:px-8",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "relative flex h-16 items-center justify-between",
                    children: [
                        notifications && /*#__PURE__*/ (0, $k4ank.jsx)((0, $ef4d3c1b0f4287aa$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute inset-y-0 left-0 flex items-center sm:hidden",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                type: "button",
                                className: "relative inline-flex items-center justify-center rounded-md p-2",
                                onClick: toggleMobileMenu,
                                "aria-controls": "mobile-menu",
                                "aria-expanded": isMobileMenuOpen,
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                        className: "sr-only",
                                        children: "Open main menu"
                                    }),
                                    "   ",
                                    /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                        className: `h-6 w-6 ${isMobileMenuOpen ? "hidden" : "block"}`,
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M3 12h18M3 6h18M3 18h18"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                        className: `h-6 w-6 ${isMobileMenuOpen ? "block" : "hidden"}`,
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex flex-1 items-center justify-center sm:items-center sm:justify-between",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "flex flex-shrink-0 items-center",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)($8d2777a938aec608$var$Logo, {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "hidden sm:ml-6 sm:block",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex space-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                to: "/",
                                                onClick: closeMobileMenu,
                                                className: "hover:text-orange-600 rounded-md px-3 py-2 text-md font-medium",
                                                children: "Home"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                to: "/about",
                                                onClick: closeMobileMenu,
                                                className: "hover:text-orange-600 rounded-md px-3 py-2 text-md font-medium",
                                                children: "About"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                to: "/contact",
                                                onClick: closeMobileMenu,
                                                className: "hover:text-orange-600 rounded-md px-3 py-2 text-md font-medium",
                                                children: "Contact"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                to: "/faqs",
                                                onClick: closeMobileMenu,
                                                className: "hover:text-orange-600 rounded-md px-3 py-2 text-md font-medium",
                                                children: "FAQs"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.Link), {
                                    to: "/cart",
                                    className: "relative p-1 focus:outline-none mx-6 sm:mr-16",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                            className: "text-2xl fa-solid fa-cart-shopping"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            className: "absolute -right-2 -top-0.5 rounded-full text-center text-white h-5 w-5 bg-green-600 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                "data-testid": "cart",
                                                children: cartItems.length
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "relative ml-3",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                                type: "button",
                                                onClick: toggleProfileMenu,
                                                className: "relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800",
                                                id: "user-menu-button",
                                                "aria-expanded": isProfileMenuOpen,
                                                "aria-haspopup": "true",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open user menu"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                        className: "h-8 w-8 rounded-full",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1bdf55611f740138$exports))),
                                                        alt: ""
                                                    })
                                                ]
                                            })
                                        }),
                                        isProfileMenuOpen && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                                            role: "menu",
                                            "aria-orientation": "vertical",
                                            "aria-labelledby": "user-menu-button",
                                            tabIndex: "-1",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                    to: "/login",
                                                    onClick: closeProfileMenu,
                                                    className: "block px-4 py-2 text-sm",
                                                    role: "menuitem",
                                                    tabIndex: "-1",
                                                    id: "user-menu-item-2",
                                                    children: "Login"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                    to: "/signup",
                                                    onClick: closeProfileMenu,
                                                    className: "block px-4 py-2 text-sm",
                                                    role: "menuitem",
                                                    tabIndex: "-1",
                                                    id: "user-menu-item-2",
                                                    children: "SignUP"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: `sm:hidden ${isMobileMenuOpen ? "block" : "hidden"}`,
                id: "mobile-menu",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "space-y-1 px-2 pb-3 pt-2",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            to: "/",
                            onClick: closeMobileMenu,
                            className: "hover:text-orange-600 block rounded-md px-3 py-2 text-base font-medium",
                            children: "Home"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            to: "/about",
                            onClick: closeMobileMenu,
                            className: "hover:text-orange-600 block rounded-md px-3 py-2 text-base font-medium",
                            children: "About"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            to: "/contact",
                            onClick: closeMobileMenu,
                            className: "hover:text-orange-600 block rounded-md px-3 py-2 text-base font-medium",
                            children: "Contact"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            to: "/faqs",
                            onClick: closeMobileMenu,
                            className: "hover:text-orange-600 block rounded-md px-3 py-2 text-base font-medium",
                            children: "FAQs"
                        })
                    ]
                })
            })
        ]
    });
};
var $8d2777a938aec608$export$2e2bcd8739ae039 = $8d2777a938aec608$var$Header;



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
const $d5635a6f632073af$export$3c67ec6258c4a827 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";
const $d5635a6f632073af$export$53c56703882e1d3f = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";



var $k4ank = parcelRequire("k4ank");

var $fIsAN = parcelRequire("fIsAN");

const $ef116864596ae72e$var$RestaurantCard = ({ id: id, cloudinaryImageId: cloudinaryImageId, name: name, cuisines: cuisines, areaName: areaName, sla: sla, costForTwo: costForTwo, avgRating: avgRating })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
        className: " relative  rounded mb-6 w-72 sm:w-60 mx-3 sm:my-4 text-black transform sm:hover:scale-95 transition-transform duration-200",
        to: `/restaurant/${id}`,
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                    className: "rounded-2xl",
                    src: (0, $d5635a6f632073af$export$3c67ec6258c4a827) + cloudinaryImageId
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "px-2",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                            className: "font-semibold text-l uppercase mt-4 my-2 overflow-hidden whitespace-nowrap overflow-ellipsis",
                            children: name
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("h5", {
                            className: " bg-green-600 inline-block px-2 py-px mb-2 rounded text-white",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                    className: "fa-solid fa-star text-white text-sm"
                                }),
                                " ",
                                avgRating
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("h5", {
                            className: "font-medium",
                            children: costForTwo
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex gap-2",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("h5", {
                                    children: [
                                        "\xa0\xa0",
                                        sla?.lastMileTravelString || "_._ km"
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                    children: "\u2022"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("h5", {
                                    children: sla?.slaString
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("h5", {
                            className: "whitespace-nowrap overflow-hidden overflow-ellipsis",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                    className: "fa-solid fa-location-dot  text-yellow-500 "
                                }),
                                " ",
                                areaName
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("h5", {
                            className: "sans-serif font-thin opacity-75 text-sm mb-1",
                            children: cuisines.length > 2 ? cuisines.slice(0, 2).join(", ") : cuisines.join(", ")
                        })
                    ]
                })
            ]
        })
    });
};
var $ef116864596ae72e$export$2e2bcd8739ae039 = $ef116864596ae72e$var$RestaurantCard;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

const $28e6dcc87485ab2c$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "shimmer-wrapper overflow-hidden absolute top-0 left-0 w-full h-full",
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: "shimmer w-full h-full "
        })
    });
};
var $28e6dcc87485ab2c$export$2e2bcd8739ae039 = $28e6dcc87485ab2c$var$Shimmer;


const $26b4f0f36688da6b$var$SkeletonCard = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative rounded mb-6 w-72 h-72 sm:w-60 mx-3 sm:my-4 ",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: " ",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "rounded-2xl bg-gray-300  p-[75px] "
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "px-2 bg-gray-50 pb-px",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "text-l uppercase mt-4 my-2 py-3  bg-gray-300 rounded "
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "py-3 px-7  inline-block  mb-2 rounded bg-gray-300 "
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: " w-24 py-2 bg-gray-300 rounded"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex gap-2 bg-gray-300 rounded h-5 w-36 my-2",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("h5", {
                                        className: "w-12 ml-1 bg-gray-300 rounded"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("h5", {
                                        className: "w-20 ml-1 bg-gray-300 rounded"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "bg-gray-300 w-24 p-2 my-2 rounded"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "bg-gray-300 w-32 p-2 mb-2 rounded"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $28e6dcc87485ab2c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $26b4f0f36688da6b$export$2e2bcd8739ae039 = $26b4f0f36688da6b$var$SkeletonCard;



// This is a custom hook for checking whether online or offline.. It checks while 

var $8T3gX = parcelRequire("8T3gX");
const $5bea38428e091604$var$useOnline = ()=>{
    const [isOnline, setIsOnline] = (0, $8T3gX.useState)(window.navigator.onLine);
    (0, $8T3gX.useEffect)(()=>{
        console.log("useOnline called");
        const handleOnline = ()=>setIsOnline(true);
        const handleOffline = ()=>setIsOnline(false);
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
        return ()=>{
            // for cleanup - removing all the events -- cleaning cache
            console.log("componentWillUnmount of useOnline");
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []); // this will work only while first render
    return isOnline;
};
var $5bea38428e091604$export$2e2bcd8739ae039 = $5bea38428e091604$var$useOnline;


// NoInternet.js

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
// NoInternet component to display when there's no internet connection
// This is working based on useOnline custom hook
const $c33ccb8a63480d9b$var$NoInternet = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "no-internet-container",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                className: "no-internet-heading",
                children: "No Internet Connection"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "no-internet-message",
                children: "Please check your internet connection and try again."
            })
        ]
    });
};
var $c33ccb8a63480d9b$export$2e2bcd8739ae039 = $c33ccb8a63480d9b$var$NoInternet;



var $fIsAN = parcelRequire("fIsAN");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

const $1abc408c8731b3e4$var$SkeletonFilter = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        class: "relative overflow-x-auto  no-scrollbar overflow-y-scrol mx-6  sm:mx-10 sm:pl-12 md:pl-4 mt-7 mb-4  ",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("ul", {
                class: "flex lg:justify-center gap-3 py-1 sm:pl-6 md:-ml-7 whitespace-nowrap text-gray-600 text-base text font-medium animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                        class: "hover:text-gray-950 cursor-pointer  px-3 rounded-full border border-gray-300",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            class: "skeleton-item w-32 h-8 rounded-full flex justify-center items-center animate-pulse",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "w-full h-5 rounded-xl bg-gray-300 py-1"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                        class: "hover:text-gray-950 cursor-pointer  px-3 rounded-full border border-gray-300",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            class: "skeleton-item w-32 h-8 rounded-full flex justify-center items-center animate-pulse",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "w-full h-5 rounded-xl bg-gray-300 py-1"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                        class: "hover:text-gray-950 cursor-pointer  px-3 rounded-full border border-gray-300",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            class: "skeleton-item w-32 h-8 rounded-full flex justify-center items-center animate-pulse",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "w-full h-5 rounded-xl bg-gray-300 py-1"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                        class: "hover:text-gray-950 cursor-pointer  px-3 rounded-full border border-gray-300",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            class: "skeleton-item w-32 h-8 rounded-full flex justify-center items-center animate-pulse",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "w-full h-5 rounded-xl bg-gray-300 py-1"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                        class: "hover:text-gray-950 cursor-pointer  px-3 rounded-full border border-gray-300",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            class: "skeleton-item w-32 h-8 rounded-full flex justify-center items-center animate-pulse",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "w-full h-5 rounded-xl bg-gray-300 py-1"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                        class: "hover:text-gray-950 cursor-pointer  px-3 rounded-full border border-gray-300",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            class: "skeleton-item w-32 h-8 rounded-full flex justify-center items-center animate-pulse",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "w-full h-5 rounded-xl bg-gray-300 py-1"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                        class: "hover:text-gray-950 cursor-pointer  px-3 rounded-full border border-gray-300",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            class: "skeleton-item w-32 h-8 rounded-full flex justify-center items-center animate-pulse",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "w-full h-5 rounded-xl bg-gray-300 py-1"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $28e6dcc87485ab2c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $1abc408c8731b3e4$export$2e2bcd8739ae039 = $1abc408c8731b3e4$var$SkeletonFilter;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

const $2ba5e944087a0378$var$SkeletonSearch = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative bg-gray-400 flex flex-col lg:flex-row lg:justify-between lg:items-center px-5 sm:px-20 py-16 md:py-24 lg:py-[4.4rem] gap-4",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex items-center rounded w-3/4 sm:w-[21.5%]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "p-2 bg-gray-200 rounded-s w-full h-10 animate-pulse"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        className: "bg-gray-500  font-medium py-2 px-3 rounded-e w-24 h-10 animate-pulse"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "relative pb-10 w-full sm:w-[60%]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "bg-gray-200 h-36 sm:h-9 w-full rounded-lg animate-pulse"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute right-16 bottom-0 sm:bottom-2 bg-gray-200 h-6 w-48 rounded-lg animate-pulse"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $28e6dcc87485ab2c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $2ba5e944087a0378$export$2e2bcd8739ae039 = $2ba5e944087a0378$var$SkeletonSearch;


const $8686c691f81afa3c$var$Body = ()=>{
    const [allRestaurants, setAllRestaurants] = (0, $8T3gX.useState)([]);
    const [filteredRestaurants, setFilteredRestaurants] = (0, $8T3gX.useState)([]);
    const [searchText, setSearchText] = (0, $8T3gX.useState)("");
    (0, $8T3gX.useEffect)(()=>{
        getRestaurants();
    }, []);
    async function getRestaurants() {
        setTimeout(async ()=>{
            // const data = await fetch("https://www.swiggy.com/api/seo/getListing?lat=9.9816358&lng=76.2998842");
            const data = await fetch("https://foodfire.onrender.com/api/restaurants?lat=21.1702401&lng=72.83106070000001&page_type=DESKTOP_WEB_LISTING");
            const json = await data.json();
            setAllRestaurants(json?.data?.cards?.[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
            setFilteredRestaurants(json?.data?.cards?.[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        }, 2000);
    }
    console.log(allRestaurants);
    const isOnline = (0, $5bea38428e091604$export$2e2bcd8739ae039)();
    if (!isOnline) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $c33ccb8a63480d9b$export$2e2bcd8739ae039), {});
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") {
            const data = (0, $b17d528c9be7da99$export$d6ad891437e8c72c)(searchText, allRestaurants);
            setFilteredRestaurants(data);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            allRestaurants?.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $2ba5e944087a0378$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: " bg-black flex flex-wrap justify-between items-center px-5 sm:px-20 py-16 gap-4",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "   flex  items-center  rounded ",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                type: "text",
                                className: "p-2 outline-none  rounded-s ",
                                placeholder: "Search",
                                value: searchText,
                                onChange: (e)=>setSearchText(e.target.value),
                                onKeyDown: handleKeyDown
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                className: " bg-green-800 hover:bg-green-900 text-white font-medium py-2 px-3  rounded-e",
                                onClick: ()=>{
                                    const data = (0, $b17d528c9be7da99$export$d6ad891437e8c72c)(searchText, allRestaurants);
                                    setFilteredRestaurants(data);
                                },
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: " relative pb-10 ",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("h1", {
                                className: "text-orange-400 text-5xl madimi-one-regular",
                                children: "Discover Delightful Flavors Near You"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                className: "absolute right-16 sm:bottom-4 text-white font-semibold m-plus-rounded-1c-regular text-center text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                        className: "fa-solid fa-award text-green-600 text-2xl"
                                    }),
                                    "\xa0 Zito Tradition Since 1990! ",
                                    /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                        className: "fa-solid fa-utensils text-orange-600"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            allRestaurants?.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $1abc408c8731b3e4$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "overflow-x-auto  no-scrollbar overflow-y-scroll mx-6 sm:mx-10  sm:pl-12 md:pl-4 mt-7 mb-4",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("ul", {
                    className: "flex lg:justify-center gap-3 py-1 sm:pl-6 md:-ml-7  whitespace-nowrap text-gray-600 text-base text font-medium",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            className: " hover:text-gray-950 cursor-pointer p-1  px-5 rounded-full border border-gray-300",
                            onClick: ()=>{
                                const data = (0, $b17d528c9be7da99$export$d6ad891437e8c72c)("", allRestaurants);
                                setFilteredRestaurants(data);
                            },
                            children: "All Restaurants"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            className: " hover:text-gray-950 cursor-pointer p-1  px-5 rounded-full border border-gray-300",
                            onClick: ()=>{
                                const data = (0, $b17d528c9be7da99$export$f80b45ea636617be)(4, allRestaurants);
                                setFilteredRestaurants(data);
                            },
                            children: "Ratings 4.O+"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            className: " hover:text-gray-950 cursor-pointer p-1  px-5 rounded-full border border-gray-300",
                            onClick: ()=>{
                                const data = (0, $b17d528c9be7da99$export$f80b45ea636617be)(4.5, allRestaurants);
                                setFilteredRestaurants(data);
                            },
                            children: "Ratings 4.5+"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            className: " hover:text-gray-950 cursor-pointer p-1  px-5 rounded-full border border-gray-300",
                            onClick: ()=>{
                                const data = (0, $b17d528c9be7da99$export$99e986d5326d56a4)(true, allRestaurants);
                                setFilteredRestaurants(data);
                            },
                            children: "Pure Veg"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            className: " hover:text-gray-950 cursor-pointer p-1  px-5 rounded-full border border-gray-300",
                            onClick: ()=>{
                                const data = (0, $b17d528c9be7da99$export$2808572feca4ba17)(4, allRestaurants);
                                setFilteredRestaurants(data);
                            },
                            children: "Within 4km"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            className: " hover:text-gray-950 cursor-pointer p-1  px-5 rounded-full border border-gray-300",
                            onClick: ()=>{
                                const data = (0, $b17d528c9be7da99$export$9fa19c6d9bcb8ec8)(300, allRestaurants);
                                setFilteredRestaurants(data);
                            },
                            children: "Less than Rs.300"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                            className: " hover:text-gray-950 cursor-pointer p-1  px-5 rounded-full border border-gray-300",
                            onClick: ()=>{
                                const data = (0, $b17d528c9be7da99$export$fc09282584efe12c)(300, 600, allRestaurants);
                                setFilteredRestaurants(data);
                            },
                            children: "Rs.300-Rs.600"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: " flex flex-wrap justify-center mb-10 ",
                children: allRestaurants?.length === 0 ? Array(15).fill("").map((e, i)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "mb-14 ",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $26b4f0f36688da6b$export$2e2bcd8739ae039), {}, i)
                        ]
                    })) : filteredRestaurants?.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)("h1", {
                    children: "Not found"
                }) : filteredRestaurants?.map((restaurant)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $ef116864596ae72e$export$2e2bcd8739ae039), {
                        ...restaurant?.info
                    }, restaurant?.info?.id))
            })
        ]
    });
};
var $8686c691f81afa3c$export$2e2bcd8739ae039 = $8686c691f81afa3c$var$Body;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $fIsAN = parcelRequire("fIsAN");
const $a8d145286bd96b60$var$Footer = ()=>{
    const year = new Date().getFullYear();
    return /*#__PURE__*/ (0, $k4ank.jsxs)("footer", {
        className: "bg-black text-gray-400  py-8",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "container mx-auto flex flex-col md:flex-row justify-between px-4 sm:gap-10",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "md:w-1/3",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                                className: "text-xl font-bold mb-4 text-orange-400",
                                children: "About Us"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "text-sm",
                                children: "Welcome to Zito! We're your one-stop destination for all things food. From delicious recipes to helpful cooking hacks, we've got you covered. Join us on our culinary journey and let's explore the wonderful world of flavors together."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "md:w-1/3 mt-6 md:mt-0",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                                className: "text-xl font-bold mb-4 text-orange-400",
                                children: "Contact Us"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                className: "text-sm",
                                children: [
                                    "Email: shijothomashome@gmail.com ",
                                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                    "Phone: +917034436073 ",
                                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                    "Address: Palakkad, Kerala, India"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "md:w-1/3 mt-6 md:mt-0",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                                className: "text-xl font-bold mb-4 text-orange-400",
                                children: "Follow Us"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex items-center space-x-4",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                        target: "_blank",
                                        to: "https://www.facebook.com/shijo.thomas.71066?mibextid=JRoKGi",
                                        className: "text-lg",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                            className: "fab fa-facebook-square text-gray-100 "
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                        target: "_blank",
                                        to: "https://linkedin.com/in/shijo-thomas-home",
                                        className: "text-lg",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                            className: "fa-brands fa-x-twitter text-gray-100"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                        target: "_blank",
                                        to: "https://www.instagram.com/_shijo_thomas_____/",
                                        className: "text-lg ",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                            className: "fab fa-instagram-square text-gray-100"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                        target: "_blank",
                                        to: "https://linkedin.com/in/shijo-thomas-home",
                                        className: "text-lg ",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                            class: "fa-brands fa-linkedin text-gray-100"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "mt-8 text-center",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        className: "text-sm",
                        children: [
                            "\xa9 ",
                            year,
                            " Zito. All rights reserved."
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                className: "fa-regular fa-copyright"
                            }),
                            " "
                        ]
                    })
                ]
            })
        ]
    });
};
var $a8d145286bd96b60$export$2e2bcd8739ae039 = $a8d145286bd96b60$var$Footer;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


const $56d7605a07b29674$var$Contact = ()=>{
    const isOnline = (0, $5bea38428e091604$export$2e2bcd8739ae039)();
    if (!isOnline) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $c33ccb8a63480d9b$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "flex justify-center items-center  sm:my-20",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: " mx-auto flex flex-col justify-center items-center ",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: " h-96 overflow-hidden w-full ",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("iframe", {
                                title: "Google Map",
                                src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.7470247286826!2d76.66079861479476!3d10.788542760810979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba5d2ff6a25b3c1%3A0x30bb3d1c7f3050b7!2sPalakkad%2C%20Kerala!5e0!3m2!1sen!2sin!4v1646735905534!5m2!1sen!2sin",
                                className: "w-full h-full",
                                loading: "lazy"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "w-full  -mb-16 sm:mb-0  p-8  text-orange-500 bg-white py-20",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                                    className: "text-2xl font-medium mb-4 -mt-10 text-black text-center",
                                    children: "Contact Us"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "mb-4 text-black",
                                    children: "Thank you for your interest in contacting us. If you have any questions or inquiries, please don't hesitate to reach out. We are here to assist you in any way we can."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("ul", {
                                    className: " pl-4 text",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                            className: "text-blue-600",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                                    class: "fa-solid fa-envelope mr-1 "
                                                }),
                                                " shijothomashome@gmail.com"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                            className: "text-blue-600",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                                    class: "fa-solid fa-phone mr-1"
                                                }),
                                                "  +917034436073"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                            className: "text-blue-600",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                                    class: "fa-solid fa-location-dot mr-1"
                                                }),
                                                " Palakkad, Kerala, India"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "flex justify-center items-center text-white bg-black pb-10 pt-32 sm:pt-20 ",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "container mx-auto p-8 w-11/12  sm:max-w-md bg-white text-black rounded-lg shadow-md",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("h1", {
                            className: "text-2xl font-bold mb-8 text-center text-gray-700",
                            children: "Send Message"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("form", {
                            className: "space-y-4 ",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                            htmlFor: "name",
                                            className: "block font-bold mb-2  text-gray-700",
                                            children: "Name:"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                            type: "text",
                                            id: "name",
                                            name: "name",
                                            className: "text-black w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-orange-500",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                            htmlFor: "email",
                                            className: "block font-bold mb-2  text-gray-700",
                                            children: "Email:"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                            type: "email",
                                            id: "email",
                                            name: "email",
                                            className: "text-black  w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-orange-500",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                            htmlFor: "message",
                                            className: "block font-bold mb-2  text-gray-700",
                                            children: "Message:"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("textarea", {
                                            id: "message",
                                            name: "message",
                                            className: "text-black  w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-orange-500",
                                            rows: "5",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                    type: "submit",
                                    className: "w-full bg-orange-500 text-white font-bold py-2 px-4 rounded hover:bg-orange-700",
                                    children: "Submit"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $56d7605a07b29674$export$2e2bcd8739ae039 = $56d7605a07b29674$var$Contact;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $3T949 = parcelRequire("3T949");


const $3b0217e46698a216$var$Error = ()=>{
    const err = (0, $3T949.useRouteError)(); // hook 
    console.log(err);
    const isOnline = (0, $5bea38428e091604$export$2e2bcd8739ae039)();
    if (!isOnline) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $c33ccb8a63480d9b$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("h1", {
                children: err.error.message
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                children: err.status + " " + err.statusText
            })
        ]
    });
};
var $3b0217e46698a216$export$2e2bcd8739ae039 = $3b0217e46698a216$var$Error;



var $fIsAN = parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $k4ank = parcelRequire("k4ank");

var $3T949 = parcelRequire("3T949");
// custom hook

var $8T3gX = parcelRequire("8T3gX");
/** here in this hook we are implementing the logic  
 *  fetch the data from the API and return it to where this hook is been called
 */ const $e29b5ae74364ebcf$var$useRestaurant = (id)=>{
    const [restaurant, setRestaurant] = (0, $8T3gX.useState)(null);
    const [restaurantMenu, setRestaurantMenu] = (0, $8T3gX.useState)(null);
    console.log("useRestaurant called");
    (0, $8T3gX.useEffect)(()=>{
        getRestaurantInfo();
    }, []);
    async function getRestaurantInfo() {
        try {
            setTimeout(async ()=>{
                const response = await fetch(`https://foodfire.onrender.com/api/menu?page-type=REGULAR_MENU&complete-menu=true&lat=21.1702401&lng=72.83106070000001&&submitAction=ENTER&restaurantId=${id}`);
                // const response = await fetch(`https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=9.58130&lng=76.52630&restaurantId=${id}&isMenuUx4=true&submitAction=ENTER`);
                const json = await response.json();
                // Store cards data in a variable
                const cardsData = json?.data?.cards || [];
                // Find the card containing restaurant information
                const restaurantCard = cardsData.find((e)=>e?.card?.card?.info);
                const restaurantCardDetails = cardsData.find((e)=>e?.groupedCard?.cardGroupMap?.REGULAR?.cards);
                if (restaurantCard && restaurantCardDetails) {
                    const restaurantInfo = restaurantCard.card.card.info;
                    setRestaurant(restaurantInfo);
                    const restaurantInfoDetails = restaurantCardDetails?.groupedCard?.cardGroupMap?.REGULAR?.cards;
                    setRestaurantMenu(restaurantInfoDetails);
                } else console.error("Restaurant information not found in the API response");
            }, 2000);
        } catch (error) {
            console.error("Error fetching restaurant info:", error);
        // Handle error (e.g., show error message to the user)
        }
    }
    return [
        restaurant,
        restaurantMenu
    ];
};
var $e29b5ae74364ebcf$export$2e2bcd8739ae039 = $e29b5ae74364ebcf$var$useRestaurant;






var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

const $50823240afa89928$var$SkeletonMenu = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative overflow-hidden  shadow-2xl",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "rounded-md my-8 pt-6  shadow-2xl",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex flex-col p-10 md:px-32 md:flex-row -mt-14 items-center md:items-start bg-gray-300",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "w-48 sm:w-[16rem] h-48 sm:h-40 sm:mr-5 rounded bg-gray-400"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "mt-4 md:mt-0 sm:ml-3 self-start",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "w-72 lg:w-[484px] h-6 mb-2 bg-gray-400 my-3 rounded"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "w-32 h-4 mb-2 bg-gray-400 my-3 rounded"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "w-24 h-4 mb-2 bg-gray-400 my-3 rounded"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "w-40 h-4 mb-4 bg-gray-400 my-3 rounded"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "w-8 h-4 mr-1 bg-gray-400 my-3 rounded"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "w-24 h-4 bg-gray-400 my-3 rounded"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "mt-8 md:mx-32 px-12 sm:px-0",
                        children: Array(15).fill("").map((_, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex justify-between items-center mb-2 bg-gray-300 p-[10px] rounded",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "w-40 sm:w-72 bg-gray-400 h-4 rounded-lg"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                        className: "fa-solid fa-angle-down mr-2 text-gray-500"
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $28e6dcc87485ab2c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $50823240afa89928$export$2e2bcd8739ae039 = $50823240afa89928$var$SkeletonMenu;




var $0a8c890069c64fb4$exports = {};
$0a8c890069c64fb4$exports = new URL("dummy_food_image.af1d2b71.png", import.meta.url).toString();




var $8T3gX = parcelRequire("8T3gX");
const $15a438e874e61e10$var$Section = ({ index: index, category: category, isVisible: isVisible, setIsVisible: setIsVisible })=>{
    const dispatch = (0, $3563a485d86a3589$export$8ad76b76a4c905f8)();
    const handleAddFoodItem = (item)=>{
        dispatch((0, $aa98b1824adfa6f2$export$fb9705de59d96855)(item)); // dispatches the addItem action
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "mb-2",
        children: [
            isVisible ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "rounded flex justify-between items-center cursor-pointer p-1  border border-gray-00",
                onClick: ()=>setIsVisible(false),
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("h6", {
                        className: "text-lg font-medium mb-0 text-black",
                        children: category?.card?.card?.title
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                        className: "fa-solid fa-angle-up mr-2"
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "rounded flex justify-between items-center cursor-pointer p-1  border border-dotted border-gray-400",
                onClick: ()=>setIsVisible(true),
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                        className: "text-lg font-medium mb-0 text-black",
                        children: category?.card?.card?.title
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                        className: "fa-solid fa-angle-down mr-2"
                    })
                ]
            }),
            isVisible && category?.card?.card?.itemCards?.map((item, itemIndex)=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "overflow-hidden mb-6  shadow",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "p-4",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex flex-col  md:flex-row justify-between items-center mb-3 gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("h3", {
                                        className: "text-lg m-plus-rounded-1c-regular text-black font-medium  md:w-1/2 flex-1 ",
                                        children: (0, $b17d528c9be7da99$export$789fa4c5300b11dd)(item?.card?.info?.name)
                                    }),
                                    console.log(`${typeof item.card.info.price}`),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                        className: "font-semibold text-gray-700 flex-1",
                                        children: [
                                            "\u20B9 ",
                                            item?.card?.info?.price / 200 || (item?.card?.info?.defaultPrice / 200).toFixed(2),
                                            " INR"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "relative  mx-auto flex-1",
                                        children: [
                                            item?.card?.info?.imageId ? /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                src: (0, $d5635a6f632073af$export$53c56703882e1d3f) + item?.card?.info?.imageId,
                                                alt: "food image",
                                                className: " w-52 h-36 object-cover rounded-lg"
                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0a8c890069c64fb4$exports))),
                                                alt: "food image",
                                                className: "w-52 h-36  object-cover rounded-lg"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                                className: "absolute -bottom-4 left-1/4 text-sm text-white font-semibold bg-green-600 py-2 px-4 rounded-md hover:bg-green-700 ",
                                                onClick: ()=>handleAddFoodItem(item?.card?.info),
                                                children: "Add to Cart"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "flex items-center",
                                children: item?.card?.info?.ratings?.aggregatedRating?.rating ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex items-center font-semibold mx-auto mt-4 md:mx-0 md:-mt-10",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                            className: "text-base text-black mr-2",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                                    className: "fa-solid fa-star text-xs p-1 bg-green-500 rounded-xl",
                                                    style: {
                                                        color: "#fff"
                                                    }
                                                }),
                                                "\xa0",
                                                item?.card?.info?.ratings?.aggregatedRating?.rating,
                                                " ",
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                                    children: "\u2022"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "text-base text-black",
                                            children: item?.card?.info?.ratings?.aggregatedRating?.ratingCount
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex items-center font-semibold mx-auto mt-4 sm:mx-0 sm:mt-0",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                            className: "text-base text-black mr-2",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                                    className: "fa-solid fa-star fa-flip p-1 bg-green-500 rounded-xl",
                                                    style: {
                                                        color: "#fff"
                                                    }
                                                }),
                                                "3.9 ",
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                                    children: "\u2022"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "text-base text-black",
                                            children: "176 ratings"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }, itemIndex))
        ]
    }, index);
};
const $15a438e874e61e10$var$RestaurantMenu = ()=>{
    const { id: id } = (0, $3T949.useParams)();
    const [restaurant, restaurantMenu] = (0, $e29b5ae74364ebcf$export$2e2bcd8739ae039)(id); // fetching data from API and storing it into state variable restaurant is written inside this custom hook
    const [visibleSection, setVisibleSection] = (0, $8T3gX.useState)();
    const isOnline = (0, $5bea38428e091604$export$2e2bcd8739ae039)();
    if (!isOnline) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $c33ccb8a63480d9b$export$2e2bcd8739ae039), {});
    if (!restaurant) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $50823240afa89928$export$2e2bcd8739ae039), {});
    const { name: name, areaName: areaName, costForTwoMessage: costForTwoMessage, cuisines: cuisines, avgRating: avgRating, cloudinaryImageId: cloudinaryImageId } = restaurant;
    const menuCategories = restaurantMenu;
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: " rounded-md mb-8 -mt-6 pt-6 min-h-screen ",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "bg-black p-10 md:px-32 text-white flex flex-col md:flex-row items-center md:items-start ",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                            className: "rounded-md w-48 h-48 md:w-64 md:h-auto md:mr-8",
                            src: (0, $d5635a6f632073af$export$3c67ec6258c4a827) + cloudinaryImageId,
                            alt: name
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "mt-4 md:mt-0",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("h1", {
                                    className: "text-2xl md:text-3xl font-bold mb-2",
                                    children: name
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("h3", {
                                    className: "text-sm md:text-base mb-2",
                                    children: areaName
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("h3", {
                                    className: "text-sm md:text-base text-green-400 mb-2",
                                    children: costForTwoMessage
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("h3", {
                                    className: "text-sm md:text-base mb-4",
                                    children: cuisines?.join(", ")
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            className: "text-sm md:text-base text-yellow-500 font-semibold mr-1",
                                            children: avgRating
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            className: "text-xs md:text-sm text-gray-500",
                                            children: "(Based on 500+ ratings)"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "mt-8 md:mx-32 mx-10",
                    children: menuCategories.filter((category)=>category?.card?.card?.itemCards?.length > 0).map((category, index)=>/*#__PURE__*/ (0, $k4ank.jsx)($15a438e874e61e10$var$Section, {
                            index: index,
                            category: category,
                            isVisible: visibleSection === category?.card?.card?.title,
                            setIsVisible: (Bool)=>Bool ? setVisibleSection(category?.card?.card?.title) : setVisibleSection("")
                        }, index))
                })
            ]
        })
    });
};
var $15a438e874e61e10$export$2e2bcd8739ae039 = $15a438e874e61e10$var$RestaurantMenu;



// here we create the store 
// and we wil update it in our Applayout using a provider from react-redux library 


const $5f0eb7dd40abf144$var$store = (0, $5725b37018bbdb6b$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $aa98b1824adfa6f2$export$2e2bcd8739ae039)
    }
});
var $5f0eb7dd40abf144$export$2e2bcd8739ae039 = $5f0eb7dd40abf144$var$store;


/**
 * SUBSCRIBING
 * 
 * useSelector( store => store.cart.items ) -- subscribing to the items of cart slice of store
 * useSelector( store => store.cart ) -- subscribing to the cart slice of store
 * useSelector( store => store ) -- subscribing to whole store 
 * */ // 

var $k4ank = parcelRequire("k4ank");

parcelRequire("8T3gX");




var $58733e7ccae9507d$exports = {};
$58733e7ccae9507d$exports = new URL("empty_cart.cdd853dc.png", import.meta.url).toString();



var $fIsAN = parcelRequire("fIsAN");
const $281a74ae9bff5df6$var$Cart = ()=>{
    // subscribing to the items of cart slice of store
    const cartItems = (0, $3563a485d86a3589$export$2105062e25df4afe)((store)=>store.cart.items);
    const dispatch = (0, $3563a485d86a3589$export$8ad76b76a4c905f8)();
    // modifying / dispatching action
    const handleClearCart = ()=>{
        dispatch((0, $aa98b1824adfa6f2$export$810121176e3e3671)());
    };
    // adding item to the cartSlice store
    const handleAddItem = (item)=>{
        dispatch((0, $aa98b1824adfa6f2$export$fb9705de59d96855)(item));
    };
    // removing single quantity from the cartSlice store
    const handleRemoveItem = (item)=>{
        dispatch((0, $aa98b1824adfa6f2$export$fe2d9b4e03920b4c)(item));
    };
    // removing full quantity from the cartSlice store
    const handleRemoveFullItem = (item)=>{
        dispatch((0, $aa98b1824adfa6f2$export$1c55978aee5fc2e7)(item));
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "py-4  px-4 sm:px-6 lg:px-8  lg:mb-0 bg-gray-100 min-h-screen",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                className: "text-xl font-bold mb-4 text-center sans-serif text-gray-600 underline ",
                children: "My Cart"
            }),
            cartItems.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex lg:flex-row flex-col gap-10 lg:gap-3 justify-center items-center",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                        className: "w-2/4 ",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($58733e7ccae9507d$exports))),
                        alt: "cart is empty image"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex flex-col gap-3 justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-bold",
                                children: "Your cart is empty"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                class: "bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                    to: "/",
                                    children: "Go To Purchase"
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex flex-col  lg:flex-row",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                        className: "divide-y divide-gray-300 bg-white border  rounded py-2 px-6 sm:w-4/5 mx-auto lg:w-1/2 lg:mb-10",
                        children: cartItems.map((item, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                className: "py-4 flex flex-col sm:flex-row justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex flex-col sm:flex-row gap-5 items-center sm:items-start ",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    item.imageId ? /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                        className: "w-20 h-20 object-cover rounded-lg ",
                                                        src: `${(0, $d5635a6f632073af$export$3c67ec6258c4a827)}${item.imageId}`,
                                                        alt: (0, $b17d528c9be7da99$export$789fa4c5300b11dd)(item.name)
                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                        className: "w-20 h-20 object-cover rounded-lg ",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0a8c890069c64fb4$exports))),
                                                        alt: (0, $b17d528c9be7da99$export$789fa4c5300b11dd)(item.name)
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                                        class: "fa-solid fa-xmark absolute text-white -top-1 -left-1 bg-[#fb542b] text-small rounded-3xl p-px cursor-pointer",
                                                        title: "Remove item",
                                                        onClick: ()=>handleRemoveFullItem(item)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "ml-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("h3", {
                                                        className: "text-lg font-semibold",
                                                        children: (0, $b17d528c9be7da99$export$789fa4c5300b11dd)(item.name)
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "text-gray-500",
                                                        children: item.category
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "flex justify-center items-center sm:w-20 w-auto ",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                            className: "inline-flex items-center my-2 px-3 py-1 border border-gray-500 bg-white rounded",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                                                    className: "relative group",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                                                            className: "fa-solid fa-minus mr-2 text-gray-500",
                                                                            onClick: ()=>handleRemoveItem(item)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                            className: "absolute bg-gray-800 text-white py-1 px-2 rounded text-xs bottom-8 left-0 transition-opacity opacity-0 group-hover:opacity-100",
                                                                            children: "Remove"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                    className: "mr-2",
                                                                    children: item.quantityCount
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                                                    className: "relative group",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                                                                            className: "fa-solid fa-plus text-green-800",
                                                                            onClick: ()=>handleAddItem(item)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                            className: "absolute bg-gray-800 text-white py-1 px-2 rounded text-xs bottom-8 left-0 transition-opacity opacity-0 group-hover:opacity-100",
                                                                            children: "Add"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                            className: "text-base whitespace-nowrap  text-gray-600 sans-serif",
                                            children: [
                                                " ",
                                                `${item.quantityCount} x ${(item.price / 200 || item.defaultPrice / 200).toFixed(2)} = \u20B9 ${(item.price / 200 || item.defaultPrice / 200).toFixed(2) * item.quantityCount.toFixed(2)}`
                                            ]
                                        })
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex   justify-center sm:justify-end  lg:items-start",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex flex-col bg-black rounded p-6 md:p-8 border md:mr-14 lg:mr-0 ",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex justify-between items-center mb-4 ",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            className: "text-sm font-thin text-white",
                                            children: "Item Total:"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                            className: "text-sm font-thin text-white",
                                            children: [
                                                "\u20B9 ",
                                                cartItems.reduce((total, item)=>total + (item.price || item.defaultPrice) / 200 * item.quantityCount, 0).toFixed(2)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex justify-between items-center mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            className: "text-sm font-thin text-white",
                                            children: "GST (5%):"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                            className: "text-sm font-thin text-white",
                                            children: [
                                                "\u20B9 ",
                                                (cartItems.reduce((total, item)=>total + (item.price || item.defaultPrice) / 200 * item.quantityCount, 0) * 0.05).toFixed(2)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "h-px w-full bg-gray-500 mb-2 -p-6"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex justify-between items-center mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            className: "text-sm font-thin text-white",
                                            children: "Total:"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                            className: "text-sm font-thin text-white",
                                            children: [
                                                "\u20B9 ",
                                                (cartItems.reduce((total, item)=>total + (item.price || item.defaultPrice) / 200 * item.quantityCount, 0) * 1.05).toFixed(2)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex justify-end -mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                            className: "bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded mx-2 whitespace-nowrap font-thin text-sm",
                                            onClick: ()=>handleClearCart(),
                                            children: "Clear cart"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                            className: "bg-green-700 hover:bg-green-800 text-white py-2 px-4 rounded whitespace-nowrap font-base text-sm",
                                            children: "Proceed to Checkout"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $281a74ae9bff5df6$export$2e2bcd8739ae039 = $281a74ae9bff5df6$var$Cart;


// lifting the state up concept

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
const $aa787585ebcfd004$var$Section = ({ question: question, answer: answer, isVisible: isVisible, setIsVisible: setIsVisible })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            isVisible ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "rounded flex justify-between items-center cursor-pointer p-1 pl-3 py-5 sm:py-5 mt-px bg-gray-800 text-gray-400",
                onClick: ()=>setIsVisible(false),
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("h6", {
                        className: "text-xl font-medium mb-0 ",
                        children: question
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                        className: "fa-solid fa-minus mr-2 sm:mr-7 text-xl sm:text-2xl font-thin text-white"
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "rounded flex justify-between items-center cursor-pointer p-1 pl-3 py-5 sm:py-5 mt-px bg-gray-800 text-gray-400",
                onClick: ()=>setIsVisible(true),
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                        className: " text-base sm:text-xl font-medium mb-0 ",
                        children: question
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("i", {
                        className: "fa-solid fa-plus mr-2 sm:mr-7 text-xl sm:text-2xl font-thin text-white"
                    })
                ]
            }),
            isVisible && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-white px-3 sm:pr-24 py-5 bg-gray-700 -mt-2 rounded font-thin",
                children: answer
            })
        ]
    });
};
const $aa787585ebcfd004$var$Faqs = ()=>{
    const [visibleSection, setIsVisibleSection] = (0, $8T3gX.useState)();
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "flex flex-col mx-auto w-[90%] sm:w-[80%] mt-10 mb-16 lg:mb-24 gap-px",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "md:mr-10 lg:mr-40",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("h1", {
                    className: "text-3xl p-2 mb-2 font-bold",
                    children: "Frequently Asked Questions"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($aa787585ebcfd004$var$Section, {
                    question: "What cuisines do you offer?",
                    answer: "We offer a diverse range of cuisines including Italian, Mexican, Asian, American, and more. Our menu is designed to cater to various tastes and preferences.",
                    isVisible: visibleSection === "question_1",
                    setIsVisible: (Bool)=>Bool ? setIsVisibleSection("question_1") : setIsVisibleSection("")
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($aa787585ebcfd004$var$Section, {
                    question: "Do you offer vegetarian options?",
                    answer: "Yes, we have a wide selection of vegetarian options available on our menu. From salads to pasta dishes, we ensure there are plenty of choices for vegetarians.",
                    isVisible: visibleSection === "question_2",
                    setIsVisible: (Bool)=>Bool ? setIsVisibleSection("question_2") : setIsVisibleSection("")
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($aa787585ebcfd004$var$Section, {
                    question: "Are ingredients locally sourced?",
                    answer: "We make every effort to source our ingredients locally whenever possible. Supporting local farmers and businesses is important to us, and we believe it contributes to the freshness and quality of our dishes.",
                    isVisible: visibleSection === "question_3",
                    setIsVisible: (Bool)=>Bool ? setIsVisibleSection("question_3") : setIsVisibleSection("")
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($aa787585ebcfd004$var$Section, {
                    question: "Can I customize my order?",
                    answer: "Of course! We encourage customization to ensure your meal is exactly how you like it. Whether you want to add extra toppings, substitute ingredients, or adjust the spice level, just let us know, and we'll make it happen.",
                    isVisible: visibleSection === "question_4",
                    setIsVisible: (Bool)=>Bool ? setIsVisibleSection("question_4") : setIsVisibleSection("")
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($aa787585ebcfd004$var$Section, {
                    question: "Do you offer delivery services?",
                    answer: "Yes, we offer delivery services within our local area. Simply place your order online or give us a call, and we'll deliver your delicious meal straight to your doorstep.",
                    isVisible: visibleSection === "question_5",
                    setIsVisible: (Bool)=>Bool ? setIsVisibleSection("question_5") : setIsVisibleSection("")
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($aa787585ebcfd004$var$Section, {
                    question: "What are your hours of operation?",
                    answer: "Our hours of operation may vary depending on the location. Please check our website or give us a call for the most up-to-date information on our opening hours.",
                    isVisible: visibleSection === "question_6",
                    setIsVisible: (Bool)=>Bool ? setIsVisibleSection("question_6") : setIsVisibleSection("")
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($aa787585ebcfd004$var$Section, {
                    question: "Do you cater for events?",
                    answer: "Yes, we provide catering services for events of all sizes. Whether it's a corporate luncheon, wedding reception, or family gathering, our catering team will work with you to create a memorable dining experience.",
                    isVisible: visibleSection === "question_7",
                    setIsVisible: (Bool)=>Bool ? setIsVisibleSection("question_7") : setIsVisibleSection("")
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($aa787585ebcfd004$var$Section, {
                    question: "How can I provide feedback about my experience?",
                    answer: "We value your feedback! You can provide feedback by filling out our online feedback form, contacting us via email or phone, or speaking directly with our staff during your visit. Your input helps us improve our services and enhance your dining experience.",
                    isVisible: visibleSection === "question_8",
                    setIsVisible: (Bool)=>Bool ? setIsVisibleSection("question_8") : setIsVisibleSection("")
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($aa787585ebcfd004$var$Section, {
                    question: "Do you offer gift cards?",
                    answer: "Yes, we offer gift cards that can be purchased online or at any of our locations. Treat your loved ones to the gift of delicious food and a memorable dining experience with our gift cards.",
                    isVisible: visibleSection === "question_9",
                    setIsVisible: (Bool)=>Bool ? setIsVisibleSection("question_9") : setIsVisibleSection("")
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($aa787585ebcfd004$var$Section, {
                    question: "Do you accommodate dietary restrictions?",
                    answer: "Absolutely! We understand the importance of accommodating dietary restrictions. Please inform our staff about any allergies or dietary preferences, and we will do our best to provide suitable options.",
                    isVisible: visibleSection === "question_10",
                    setIsVisible: (Bool)=>Bool ? setIsVisibleSection("question_10") : setIsVisibleSection("")
                })
            ]
        })
    });
};
var $aa787585ebcfd004$export$2e2bcd8739ae039 = $aa787585ebcfd004$var$Faqs;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $fIsAN = parcelRequire("fIsAN");
const $c96884709bba2610$var$Login = ()=>{
    const handleFormSubmit = (e)=>{
        e.preventDefault();
    // Handle form submission
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: " flex bg-gray-100",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "w-[90%] my-10 sm:my-20 sm:w-full max-w-md m-auto bg-white rounded-lg border border-primaryBorder shadow-default p-4",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("h1", {
                    className: "text-2xl font-medium text-primary mt-4 mb-12 text-center",
                    children: "Log in to your account \uD83D\uDD10"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("form", {
                    onSubmit: handleFormSubmit,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                    htmlFor: "email",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                    type: "email",
                                    id: "email",
                                    className: "w-full p-2 text-primary border rounded-md outline-none text-sm transition duration-150 ease-in-out mb-4",
                                    placeholder: "Your Email"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                    htmlFor: "password",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                    type: "password",
                                    id: "password",
                                    className: "w-full p-2 text-primary border rounded-md outline-none text-sm transition duration-150 ease-in-out mb-4",
                                    placeholder: "Your Password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex items-center mb-6",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                    type: "checkbox",
                                    id: "remember",
                                    className: "mr-2"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                    htmlFor: "remember",
                                    children: "Remember Me"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "flex justify-center items-center mt-6",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                to: "/",
                                className: "bg-green py-2 px-4 text-sm text-white  bg-orange-500 hover:bg-orange-600 rounded border border-green focus:outline-none focus:border-green-dark",
                                children: "Login"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "flex justify-center items-center mt-4",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                className: "text-blue-500 hover:text-blue-700",
                                children: "Forgot Password?"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "flex justify-center items-center mt-4",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                children: [
                                    "Don\u2019t have an account yet? ",
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                        to: "/signup",
                                        className: " text-blue-500 hover:text-blue-700",
                                        children: "Sign Up"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $c96884709bba2610$export$2e2bcd8739ae039 = $c96884709bba2610$var$Login;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $fIsAN = parcelRequire("fIsAN");
const $2bca3186b8f28ce0$var$Signup = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "h-screen flex bg-gray-100",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "w-full max-w-md m-auto bg-white rounded-lg border border-primaryBorder shadow-default py-10 px-16",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("h1", {
                    className: "text-2xl font-medium text-primary mt-4 mb-12 text-center",
                    children: "Create your account \uD83D\uDE80"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("form", {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                    htmlFor: "name",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                    type: "text",
                                    id: "name",
                                    className: "w-full p-2 text-primary border rounded-md outline-none text-sm transition duration-150 ease-in-out mb-4",
                                    placeholder: "Your Name"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                    htmlFor: "email",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                    type: "email",
                                    id: "email",
                                    className: "w-full p-2 text-primary border rounded-md outline-none text-sm transition duration-150 ease-in-out mb-4",
                                    placeholder: "Your Email"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                    htmlFor: "password",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                    type: "password",
                                    id: "password",
                                    className: "w-full p-2 text-primary border rounded-md outline-none text-sm transition duration-150 ease-in-out mb-4",
                                    placeholder: "Your Password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                    htmlFor: "confirmPassword",
                                    children: "Confirm Password"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                    type: "password",
                                    id: "confirmPassword",
                                    className: "w-full p-2 text-primary border rounded-md outline-none text-sm transition duration-150 ease-in-out mb-4",
                                    placeholder: "Confirm Your Password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex items-center mb-6",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                    type: "checkbox",
                                    id: "agree",
                                    className: "mr-2"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                    htmlFor: "agree",
                                    children: "I agree to the Terms and Conditions"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "flex justify-center items-center mt-6",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                to: "/",
                                className: "bg-green py-2 px-4 text-sm bg-orange-500 hover:bg-orange-600 text-white rounded border border-green focus:outline-none focus:border-green-dark",
                                children: "Sign Up"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $2bca3186b8f28ce0$export$2e2bcd8739ae039 = $2bca3186b8f28ce0$var$Signup;



const $e6b1d08405348346$var$About = /*#__PURE__*/ (0, $8T3gX.lazy)(()=>(parcelRequire("j2AMO"))); // lazy loading/dynamic loading/etc- never load this inside the functional component
const $e6b1d08405348346$var$AppLayout = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3563a485d86a3589$export$2881499e37b75b9a), {
        store: (0, $5f0eb7dd40abf144$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8d2777a938aec608$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Outlet), {}),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a8d145286bd96b60$export$2e2bcd8739ae039), {})
        ]
    });
};
const $e6b1d08405348346$var$appRouter = (0, $fIsAN.createBrowserRouter)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $k4ank.jsx)($e6b1d08405348346$var$AppLayout, {}),
        errorElement: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3b0217e46698a216$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8686c691f81afa3c$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8T3gX.Suspense), {
                    fallback: /*#__PURE__*/ (0, $k4ank.jsx)("div", {}),
                    children: /*#__PURE__*/ (0, $k4ank.jsx)($e6b1d08405348346$var$About, {})
                }) //play in network using slow 3G to understand
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $56d7605a07b29674$export$2e2bcd8739ae039), {})
            },
            {
                path: "/faqs",
                element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aa787585ebcfd004$export$2e2bcd8739ae039), {})
            },
            {
                path: "restaurant/:id",
                element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $15a438e874e61e10$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $281a74ae9bff5df6$export$2e2bcd8739ae039), {})
            },
            {
                path: "/login",
                element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $c96884709bba2610$export$2e2bcd8739ae039), {})
            },
            {
                path: "/signup",
                element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2bca3186b8f28ce0$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
// create root using createRoot
const $e6b1d08405348346$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($11011d7422997104$exports))).createRoot(document.getElementById("root"));
// passing react element inside root
$e6b1d08405348346$var$root.render(/*#__PURE__*/ (0, $k4ank.jsx)("div", {
    className: "pt-[66px]",
    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.RouterProvider), {
        router: $e6b1d08405348346$var$appRouter
    })
}));


//# sourceMappingURL=index.d454d5cc.js.map
